const categories = [
  {
    slug: 'danza-acrobatica',
    title: 'Danza Acrobática',
    description: 'Aprende sobre técnicas de danza y métodos acrobáticos',
    color: '#55BD9C',
  },
  {
    slug: 'flex',
    title: 'Flex',
    description: 'Mejora tu flexibilidad para lograr la máxima amplitud posible en tus movimientos.',
    color: '#E74C3C',
  },
  {
    slug: 'acroyoga',
    title: 'AcroYoga',
    description: 'Combina Yoga y Acrobacia, en pareja o en grupo.',
    color: '#9B59B6',
  },
  {
    slug: 'calistenia',
    title: 'Calistenia',
    description: 'Freestyle, street workout o Calistenia, ejercicios para todos los niveles.',
    color: '#EF6723',
  },
  {
    slug: 'defensa-personal',
    title: 'Defensa Personal',
    description: 'Te enseñamos a defenderte y librarte de situaciones que te puedan poner en peligro.',
    color: '#c0c0c0',
  },
  {
    slug: 'gimnasia',
    title: 'Gimnasia',
    description: 'Actívate, fortalecete y mejora tu forma física con nosotros.',
    color: '#3498DB',
  },
  {
    slug: 'yoga',
    title: 'Yoga',
    description: 'Mejora tu elasticidad, vitalidad y mantente consciente de tu cuerpo por más tiempo.',
    color: '#8E44AD',
  },
  {
    slug: 'baile-fitness',
    title: 'Baile Fitness',
    description: '¡Mantente en forma mientras aprendes nuevos pasos de baile!.',
    color: '#51AF61',
  },
  {
    slug: 'ritmos-latinos',
    title: 'Ritmos Latinos',
    description: 'Disfruta con nosotros del merengue, la bachata, salsa, rumba, rock, cumbia, el tango, desde el folklor de México hasta la habanera de Cuba.',
    color: '#FA1E44',
  },
  {
    slug: 'danza-jazz',
    title: 'Danza Jazz',
    description: 'Aprende las técnicas de ballet, danza contemporanea y principalmente expresión corporal aplicadas a la danza Jazz.',
    color: '#AAB3EB',
  },
  {
    slug: 'breaking',
    title: 'Breaking',
    description: 'Aprende este estilo de danza urbana conocido como breaking, break dance o b-boying/b-girling',
    color: '#6653EB',
  },
  {
    slug: 'fisioterapia',
    title: 'Fisioterapia',
    description: 'Evita lesiones, aprende a fortalecer y sanar tu cuerpo para que puedas realizar todas nuestras actividades sin lesiones.',
    color: '#00B3EB',
  },
  {
    slug: 'yoga-kids',
    title: 'Yoga Kids',
    description: 'Diviertete, relajate y juega. Ejercicio para niños de 3 a 99 años',
    color: '#00D3EB',
  },
]

const roasterMap = {
  rao: 0,
  'alma-y-cesar': 1,
  johnatan: 2,
  guillo: 3,
  'mary-y-john': 4,
  'angie-campirano': 5,
  ekbars: 6,
  'cesar-zamudio': 7,
  'javier-basilio': 8,
  'juan-carlos-lopez': 9,
  'guillo-y-kei': 10,
  'didack': 11,
  'roberto-parra': 12,
  'yuri': 13,
}

const categoryMap = {
  danzaacrobatica: 0,
  flex: 1,
  acroyoga: 2,
  calistenia: 3,
  defensapersonal: 4,
  gimnasia: 5,
  yoga: 6,
  bailefitness: 7,
  ritmoslatinos: 8,
  danzajazz: 9,
  breaking: 10,
  fisioterapia: 11,
  yogakids: 12,
}

const roaster = [{
  slug: "rao",
  name: "RAO",
  instructor: 'Roberto Aguilar Ortíz (RAO)',
  profile_picture: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-danza-acrobatica.jpg',
  disciplina: 'Danza Acrobática',
  studio: 'D-NS',
  email: 'flama_3pk [en] hotmail.com',
  fb: 'roberto.aguilarortiz.92',
  tw: '',
  in: 'https://www.instagram.com/aguilarortizroberto/',
  yt: '',
},
{
  slug: "alma-y-cesar",
  name: "Alma y Cesar",
  instructor: 'Alma Castro y Cesar Zamudio',
  profile_picture: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-ritmos-latinos.jpg',
  disciplina: 'Ritmos Latinos',
  studio: 'D-NS',
  email: null,
  fb: 'profile.php?id=100007195514885',
  tw: '',
  in: '',
  yt: '',
},
{
  slug: "johnatan",
  name: "Johnatan",
  instructor: 'Johnatan',
  profile_picture: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-yoga.jpg',
  disciplina: 'Yoga',
  studio: 'D-NS',
  email: null,
  whatsapp: '',
  fb: 'YogaPole-104680707591441',
  tw: '',
  in: '',
  yt: '',
},
{
  slug: "guillo",
  name: "Guillo",
  instructor: 'Guillermo',
  profile_picture: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-gimnasia.jpg',
  disciplina: 'Gimnasia',
  studio: 'D-NS',
  email: null,
  whatsapp: '',
  fb: '',
  tw: '',
  in: '',
  yt: '',
},
{
  slug: "mary-y-john",
  name: "Mary y John",
  instructor: 'Mary y Coach',
  profile_picture: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-acroyoga.jpg',
  disciplina: 'AcroYoga',
  studio: 'D-NS',
  email: null,
  whatsapp: '',
  fb: 'YogaPole-104680707591441',
  tw: '',
  in: '',
  yt: '',
},
{
  slug: "angie-campirano",
  name: "Angie",
  instructor: 'Angie Campirano',
  profile_picture: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-flex.jpg',
  disciplina: 'Flex',
  studio: 'D-NS',
  email: null,
  whatsapp: '',
  fb: '',
  tw: '',
  in: '',
  yt: '',
},
{
  slug: "ekbars",
  name: "EK Bars",
  instructor: 'Emmanuel, Luis Angel y Adonai',
  profile_picture: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-calistenia.jpg',
  disciplina: 'Calistenia',
  studio: '<a target="_blank" href="https://www.facebook.com/eklektos.workout/">EK Bars</a>',
  email: null,
  whatsapp: '',
  fb: '',
  tw: '',
  in: '',
  yt: '',
},
{
  slug: "cesar-zamudio",
  name: "Cesar Zamudio",
  instructor: 'Cesar Zamudio',
  profile_picture: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-baile-fitness.jpg',
  disciplina: 'Baile Fitness',
  studio: 'D-NS',
  email: null,
  whatsapp: '',
  fb: '',
  tw: '',
  in: '',
  yt: '',
},
{
  slug: "javier-bacilio",
  name: "Javier Bacilio",
  instructor: 'Javier Bacilio',
  profile_picture: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-defensa-personal.jpg',
  disciplina: 'Defensa Personal',
  studio: 'D-NS',
  email: null,
  whatsapp: '',
  fb: '',
  tw: '',
  in: '',
  yt: '',
},
{
  slug: "juan-carlos-lopez",
  name: "Juan Carlos López",
  instructor: 'Juan Carlos López',
  profile_picture: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-danza-jazz.jpg',
  disciplina: 'Danza Jazz',
  studio: 'D-NS',
  email: null,
  whatsapp: '',
  fb: '',
  tw: '',
  in: '',
  yt: '',
},
{
  slug: "guillo-y-kei",
  name: "Guillo y Kei",
  instructor: 'Guillermo y Keila',
  profile_picture: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-gimnasia-02.jpg',
  disciplina: 'Gimnasia',
  studio: 'D-NS',
  email: null,
  whatsapp: '',
  fb: '',
  tw: '',
  in: '',
  yt: '',
},
{
  slug: "didack",
  name: "Didack",
  instructor: 'Eduardo Manriquez',
  profile_picture: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-breaking.jpg',
  disciplina: 'Breaking',
  studio: 'D-NS',
  email: null,
  whatsapp: '',
  fb: '',
  tw: '',
  in: '',
  yt: '',
},
{
  slug: "roberto-parra",
  name: "Roberto Parra",
  instructor: 'Roberto Parra',
  profile_picture: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-fisioterapia.jpg',
  disciplina: 'Fisioterapia',
  studio: 'D-NS',
  email: null,
  whatsapp: '',
  fb: '',
  tw: '',
  in: '',
  yt: '',
},
{
  slug: "yuri",
  name: "Yuri",
  instructor: 'Yuritzi',
  profile_picture: 'https://s3.amazonaws.com/assets.d-ns.studio/detail-yoga-kids.jpg',
  disciplina: 'Yoga Kids',
  studio: 'D-NS',
  email: null,
  whatsapp: '',
  fb: '',
  tw: '',
  in: '',
  yt: '',
},
]
const sessions = [
  {
  id: "001",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/001/Front/HLS/Session+001+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/001/Back/HLS/Session+001+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/001/Front/HLS/Session+001+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/001/Back/HLS/Session+001+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/001/Front/HLS/Session+001+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/001/Back/HLS/Session+001+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/001/Front/Thumbnails/poster-001.jpg',
  details: roaster[roasterMap.rao],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['skill'],
  },
  videoInfo: {
    about: 'En esta sesión aplicamos el método RAO enfocado a realizar una rodada hacia atrás con agrupación y con split.',
    description: 'El método RAO es un conjunto de técnicas de danza y métodos acrobáticos. El desarrollo de este método tiene como finalidad, el poder brindar al estudiante, herramientas como la fuerza, la flexibilidad, coordinación, control y fluidez corporal.',
    relatesTo: 'Ritmos Latinos, Danza, Jazz, Hip Hop, Calentamiento',
    recommended: 'Las rutinas de calentamiento no solo son importantes antes de hacer ejercicio, también las puedes utilizar como un método de relajación y terapia muscular y articular.<br>Te recomendamos realizar ejercicios de calentamiento de 10 a 15 minutos diariamente en tu hogar, oficina o de camino a casa.<br>Con estos ejercicios puedes complementar tu rutina de calentamiento o realizar ejercicios de estiramiento como parte de tu terapia física.<br>En este video pondrás en práctica el método RAO y además aprendas las bases de una rodada hacia atrás.',
    tools: 'Cambia entre la cámara frontal y la trasera para revisar el detalle de cada movimiento.<br>Puedes activar el modo espejo y ver si te ayuda a seguir más fácilmente las indicaciones.<br>Usa el #challengeMode para grabar tu rodada',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['002', '004', '003'],
  sections: [{
      name: 'Estiramiento',
      time: 17,
      sub: [{
        name: 'Hombros',
        time: 39,
      },
      {
        name: 'Cabeza',
        time: 71,
      },
      {
        name: 'Abdomen',
        time: 128,
      },
      {
        name: 'Espalda',
        time: 148,
      },
      {
        name: 'Tendones',
        time: 181,
      },
      {
        name: 'Desarticulación',
        time: 216,
      },
      {
        name: 'Piernas',
        time: 243,
      },
      {
        name: 'Espalda',
        time: 384,
      },
    ]
    },{
      name: 'Movimiento Articular',
      time: 445,
      sub: [{
        name: 'Hombros',
        time: 457,
      },
      {
        name: 'Codos',
        time: 508,
      },
      {
        name: 'Cabeza / Cuello',
        time: 564,
      },
      {
        name: 'Cervicales',
        time: 598,
      },
      {
        name: 'Rodillas',
        time: 614,
      },
      {
        name: 'Flat Back',
        time: 690,
      },],
    },
    {
      name: 'Aumento de Temperatura',
      time: 730,
      sub: [{
          name: 'Introducción',
          time: 730,
        },
        {
          name: 'Técnica de Salto',
          time: 765,
        },
        {
          name: 'Técnica de Remos',
          time: 844,
        },
        {
          name: 'Saltos x 10',
          time: 1018,
        },
        {
          name: 'Remos x 10',
          time: 1053,
        },
        {
          name: 'Descanso',
          time: 1106,
        },
        {
          name: 'Flexibilidad para plegado',
          time: 1120,
        },
        {
          name: 'Flexibilidad en Segunda Posición',
          time: 1232,
        },
      ],
    },
    {
      name: 'Full Training',
      time: 1318,
      sub: [
        {
          name: 'Definición del método RAO',
          time: 1318,
        },
        {
          name: 'Agrupación',
          time: 1362,
        },
        {
          name: 'Agrupación a una pierna',
          time: 1429,
        },
        {
          name: 'Técnica para rodada hacia atrás I',
          time: 1523,
        },
        {
          name: 'Técnica para rodada hacia atrás II',
          time: 1620,
        },
        {
          name: 'Rodada con Split',
          time: 1681,
        },
        {
          name: 'Tips y Recomendaciones',
          time: 1790,
        },
        {
          name: 'Rodada con Agrupación',
          time: 1885,
        },
        {
          name: 'Tips y Recomendaciones',
          time: 1998,
        },
      ],
    },
    {
      name: 'Estiramiento',
      time: 2049,
      sub: [
        {
          name: 'Antebrazos',
          time: 2049,
        },
        {
          name: 'Cabeza',
          time: 2071,
        },
        {
          name: 'Flat Back',
          time: 2100,
        },
        {
          name: 'Desarticulación',
          time: 2119,
        },
        {
          name: 'Segunda posición',
          time: 2126,
        },
        {
          name: 'Plegado',
          time: 2158,
        },
        {
          name: 'Cobra',
          time: 2174,
        },
        {
          name: 'Espalda',
          time: 2190,
        },
      ],
    },
  ],
},
{
  id: "002",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/002/Default/HLS/Session+002+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/002/Back/HLS/Session+002+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/002/Default/HLS/Session+002+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/002/Back/HLS/Session+002+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/002/Default/HLS/Session+002+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/002/Back/HLS/Session+002+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/002/Default/Thumbnails/Session+002+-+Custom-Poster.jpg',
  details: roaster[roasterMap['alma-y-cesar']],
  category: categories[categoryMap.ritmoslatinos],
  isFree: true,
  classType: {
    slug: ['movement', 'free'],
  },
  videoInfo: {
    about: 'En esta sesión, principios de Danzón, paso cuadro y dos variantes.',
    description: 'Prepárate para tu siguiente viaje a Veracruz aprendiendo los pasos básicos del Danzón. En esta sesión desglosamos el paso cuadro, el paso básico del Danzón, y agregamos dos variantes, el cuadro con salida y el cuadro con giro. ¡No te quedes sentado!.',
    relatesTo: 'Ritmos Latinos, Danza, Baile Fitness',
    recommended: 'El baile es un excelente ejercicio que ayuda a fortalecer el corazón, pero además poco a poco mejora tu memoria, flexibilidad y resistencia.',
    tools: 'Utiliza la cámara trasera para no perder detalle en los pasos.<br>Con el modo espejo, te será más fácil seguir las indicaciones para manos y piés.',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['003', '001', '005'],
  sections: [
    {
      name: 'Introducción',
      time: 0,
      sub: [{
        name: 'Demostración',
        time: 0,
      },
      {
        name: 'Acerca del género',
        time: 24,
      },
      {
        name: 'Musicalidad',
        time: 50,
      },
      {
        name: 'Cadencia',
        time: 64,
      },
      {
        name: 'Cuenta del Danzón',
        time: 94,
      },
      {
        name: 'Paso cuadro',
        time: 118,
      },]
    },
    {
      name: 'Paso Cuadro',
      time: 0,
      sub: [
        {
          name: 'Explicación paso de dama',
          time: 213,
        },
        {
          name: 'Descripción por pié de dama',
          time: 242,
        },
        {
          name: 'Explicación paso de hombre',
          time: 267,
        },
        {
          name: 'Desglose por pié de hombre',
          time: 292,
        },
        {
          name: 'Paso cuadro en pareja',
          time: 324,
        },
        {
          name: 'Paso cuadro con música',
          time: 349,
        },
        {
          name: 'Paso cuadro en pareja',
          time: 366,
        },
        {
          name: 'Con música',
          time: 389,
        },
        {
          name: 'Posición cerrada',
          time: 405,
        },
        {
          name: 'Posición cerrada con música',
          time: 461,
        },
      ]
    },
    {
      name: 'Cuadro con salida',
      time: 479,
      sub: [
        {
          name: 'Introducción',
          time: 479,
        },
        {
          name: 'Cuenta del cuadro con salida',
          time: 492,
        },
        {
          name: 'Por tiempo',
          time: 531,
        },
        {
          name: 'Marcación',
          time: 577,
        },
        {
          name: 'Con música',
          time: 623,
        },
      ]
    },
    {
      name: 'Cuadro girado',
      time: 650,
      sub: [
        {
          name: 'Introducción',
          time: 650,
        },
        {
          name: 'Técnica del cuadro girado',
          time: 688,
        },
        {
          name: 'Con música',
          time: 778,
        },
      ]
    },
    {
      name: 'Resumen',
      time: 804,
      sub: [
        {
          name: 'Teoría',
          time: 842,
        },
        {
          name: 'Paso cuadro',
          time: 911,
        },
        {
          name: 'Cuadro con salida',
          time: 920,
        },
        {
          name: 'Cuadro girado',
          time: 928,
        },
        {
          name: 'Con música',
          time: 938,
        },
      ]
    },
  ],
},
{
  id: "003",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/003/Front/HLS/Session+003+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/003/Back/HLS/Session+003+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/003/Front/HLS/Session+003+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/003/Back/HLS/Session+003+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/003/Front/HLS/Session+003+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/003/Back/HLS/Session+003+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/003/Front/Thumbnails/Session+003+-+Custom-Poster.jpg',
  details: roaster[roasterMap['alma-y-cesar']],
  category: categories[categoryMap.ritmoslatinos],
  classType: {
    slug: ['movement'],
  },
  videoInfo: {
    about: 'Continuamos con los principios del Danzón, ahora con cuatro nuevos pasos, arriba, abajo, vaivén y el paso "V".',
    description: 'Ahora que ya conoces el paso básico del Danzón, anímate a seguir creciendo tu repertorio con estos 4 nuevos pasos.',
    relatesTo: 'Ritmos Latinos, Danza, Baile Fitness',
    recommended: 'El baile es un excelente ejercicio que ayuda a fortalecer el corazón, pero además poco a poco mejora tu memoria, flexibilidad y resistencia.',
    tools: 'Utiliza la cámara trasera para no perder detalle en los pasos.<br>Con el modo espejo, te será más fácil seguir las indicaciones para manos y piés.',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['002', '001', '005'],
  sections: [
    {
      name: 'Introducción',
      time: 0,
      sub: [
        {
          name: 'Demostración',
          time: 0,
        },
        {
          name: 'Conceptos Básicos',
          time: 42,
        },
      ]
    },
    {
      name: 'Arriba',
      time: 79,
      sub: [
        {
          name: 'Paso con cuenta',
          time: 90,
        },
        {
          name: 'Con música',
          time: 110,
        },
        {
          name: 'Frente a la pareja',
          time: 133,
        },
        {
          name: 'Descripción de pies',
          time: 159,
        },
        {
          name: 'Con música',
          time: 198,
        },
        {
          name: 'Posición cerrada',
          time: 217,
        },
        {
          name: 'Con música',
          time: 246,
        },
      ]
    },
    {
      name: 'Abajo',
      time: 267,
      sub: [
        {
          name: 'Técnica',
          time: 267,
        },
        {
          name: 'Paso con cuenta',
          time: 290,
        },
        {
          name: 'Con música',
          time: 303,
        },
        {
          name: 'Cuenta de la dama',
          time: 344,
        },
        {
          name: 'Cuenta del hombre',
          time: 363,
        },
        {
          name: 'Con música',
          time: 379,
        },
        {
          name: 'Técnica de posición cerrada',
          time: 402,
        },
        {
          name: 'Posición cerrada con música',
          time: 422,
        },
      ]
    },
    {
      name: 'Vaivén',
      time: 455,
      sub: [
        {
          name: 'Técnica',
          time: 455,
        },
        {
          name: 'Paso con cuenta',
          time: 472,
        },
        {
          name: 'Paso de dama',
          time: 488,
        },
        {
          name: 'Pisadas de dama',
          time: 506,
        },
        {
          name: 'Paso del hombre',
          time: 525,
        },
        {
          name: 'Pisadas del hombre',
          time: 541,
        },
        {
          name: 'Con música',
          time: 556,
        },
        {
          name: 'Frente a la pareja',
          time: 574,
        },
        {
          name: 'Con música',
          time: 594,
        },
        {
          name: 'Posición cerrada',
          time: 617,
        },
        {
          name: 'Con música',
          time: 655,
        },
      ]
    },
    {
      name: 'Paso "V"',
      time: 677,
      sub: [
        {
          name: 'Demostración',
          time: 677,
        },
        {
          name: 'Técnica',
          time: 714,
        },
        {
          name: 'Paso con cuenta',
          time: 732,
        },
        {
          name: 'Pisada de hombre',
          time: 773,
        },
        {
          name: 'Pisada de dama',
          time: 817,
        },
        {
          name: 'Con música',
          time: 852,
        },
        {
          name: 'Frente a la pareja',
          time: 870,
        },
        {
          name: 'Técnica',
          time: 897,
        },
        {
          name: 'Con música',
          time: 937,
        },
        {
          name: 'Cuenta en posición cerrada',
          time: 955,
        },
      ]
    },
    {
      name: 'Ensamble',
      time: 1014,
      sub: [
        {
          name: 'Marcación',
          time: 1014,
        },
        {
          name: 'Descansos en Danzón',
          time: 1065,
        },
        {
          name: 'Con música',
          time: 1101,
        },
      ]
    },
  ],
},
{
  id: "004",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/004/Front/HLS/Session+004+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/004/Back/HLS/Session+004+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/004/Front/HLS/Session+004+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/004/Back/HLS/Session+004+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/004/Front/HLS/Session+004+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/004/Back/HLS/Session+004+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/004/Front/Thumbnails/Session+004+-+Custom-Poster.jpg',
  details: roaster[roasterMap['johnatan']],
  category: categories[categoryMap.yoga],
  isFree: true,
  classType: {
    slug: ['movement', 'free']
  },
  videoInfo: {
    about: 'Te mostramos cuatro posturas básicas de Yoga y sus combinaciones aplicadas a trabajo cardiovascular.',
    description: 'En esta sesión Johnatan te enseña a realizar tres posturas de Guerrero y el Guerrero Extendido. Además realizaremos una rutina de cardio basada en estas posturas.',
    relatesTo: 'Danza, Baile Fitness, Calistenia, AcroYoga, Flex',
    recommended: 'El calentamiento articular en esta sesión te permitirán relajar y activar varios grupos musculares de tu cuerpo.<br>Al realizar las posturas de guerreros empezarás a notar mejorías y cambios en tu cuerpo, pero lo más importante podrás trabajar tus músculos y ganar flexibilidad al mismo tiempo.<br>Con el trabajo cardiovascular de esta sesión puedes mejorar tu condición física y fortalecer tu cuerpo.',
    tools: 'Puedes cambiar la cámara frontal a la trasera para apreciar mejor los movimientos. <br>Activa el modo espejo cuando tengas que realizar movimientos con los lados izquierdo o derecho.',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['005', '001', '002'],
  sections: [
    {
      name: 'Calentamiento Articular',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Cuello',
          time: 34,
        },
        {
          name: 'Hombros',
          time: 1 * 60 + 25,
        },
        {
          name: 'Muñecas',
          time: 2 * 60 + 7,
        },
        {
          name: 'Cadera',
          time: 2 * 60 + 23,
        },
        {
          name: 'Rodillas',
          time: 3 * 60 + 43,
        },
        {
          name: 'Tobillos',
          time: 4 * 60 + 7,
        },
      ]
    },
    {
      name: 'Preparación para Guerreros',
      time: 4 * 60 + 36,
      sub: [
        {
          name: 'Introducción',
          time: 4 * 60 + 36,
        },
        {
          name: 'Espalda',
          time: 5 * 60 + 5,
        },
        {
          name: 'Costado derecho',
          time: 7 * 60 + 15,
        },
        {
          name: 'Costado izquierdo',
          time: 7 * 60 + 39,
        },
        {
          name: 'Arco de la espalda',
          time: 7 * 60 + 50,
        },
        {
          name: 'Estiramiento de espalda',
          time: 8 * 60 + 31,
        },
      ]
    },
    {
      name: 'Guerrero I',
      time: 12 * 60 + 4,
      sub: [
        {
          name: 'Beneficios',
          time: 12 * 60 + 4,
        },
        {
          name: 'Postura',
          time: 12 * 60 + 35,
        },
        {
          name: 'Postura de brazos',
          time: 14 * 60 + 13,
        },
      ]
    },
    {
      name: 'Guerrero II',
      time: 15 * 60 + 25,
      sub: [
        {
          name: 'Transición a Guerrero II',
          time: 15 * 60 + 25,
        },
        {
          name: 'Postura de brazos',
          time: 15 * 60 + 50,
        },
      ]
    },
    {
      name: 'Guerrero III',
      time: 17 * 60 + 5,
      sub: [
        {
          name: 'Guerrero Extendido',
          time: 17 * 60 + 5,
        },
        {
          name: 'Transición a Guerrero III',
          time: 18 * 60 + 12,
        },
      ]
    },
    {
      name: 'Trabajo Cardiovascular',
      time: 17 * 60 + 5,
      sub: [
        {
          name: 'Introducción',
          time: 21 * 60 + 23,
        },
        {
          name: 'Guerrero I',
          time: 22 * 60 + 2,
        },
        {
          name: 'Guerrero II',
          time: 22 * 60 + 11,
        },
        {
          name: 'Guerrero Extendido',
          time: 22 * 60 + 20,
        },
        {
          name: 'Guerrero III',
          time: 22 * 60 + 30,
        },
        {
          name: 'Cambio de lado',
          time: 22 * 60 + 38,
        },
      ]
    },
    {
      name: 'Relajación',
      time: 24 * 60 + 4,
      sub: [
        {
          name: 'Respiración',
          time: 24 * 60 + 4,
        },
        {
          name: 'Relajación',
          time: 24 * 60 + 31,
        },
      ]
    },
  ],
},
{
  id: "005",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/005/Front/HLS/Session+005+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/005/Back/HLS/Session+005+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/005/Front/HLS/Session+005+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/005/Back/HLS/Session+005+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/005/Front/HLS/Session+005+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/005/Back/HLS/Session+005+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/005/Front/Thumbnails/Session+005+-+Custom-Poster.jpg',
  details: roaster[roasterMap['johnatan']],
  category: categories[categoryMap.yoga],
  classType: {
    slug: ['skill'],
  },
  videoInfo: {
    about: 'Aprende sobre la respiración alternada en Yoga',
    description: 'Te mostramos diferentes ejercicios de respiración para lograr una mayor relajación y un mejor rendimiento en tus actividades diarias. Cambia la respiración agitada por una respiración profunda',
    relatesTo: 'Danza, Baile Fitness, Calistenia, AcroYoga, Flex',
    recommended: 'Tener una respiración consciente y controlada te ayudará a mantener tu cuerpo mejor oxigenado, te mantendrá más atento y tranquilo en situaciones de stress. <br>A menor stress en tu vida aumenta la probabilidad de tener una mejor salud.<br> Al aprender a expulsar correctamente todo el aire almacenado en los pulmones mejorarás tu capacidad pulmonar gradualmente.<br> El estiramiento de la cadera junto con una respiración controlada pueden ayudarte a relajar el nervio ciático.',
    tools: 'Utiliza la cámara trasera para ver la sesión de perfil y así puedas identificar mejor cada postura. Junto con la cámara frontal, utiliza el modo espejo para seguir los movimientos de forma más intuitiva.',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['004', '001', '003'],
  sections: [
    {
      name: 'Estiramiento',
      time: 0,
      sub: [
        {
          name: 'La Respiración',
          time: 0,
        },
        {
          name: 'Postura',
          time: 1 * 60 + 51,
        },
        {
          name: 'Espalda',
          time: 2 * 60 + 52,
        },
        {
          name: 'Sobre la respiración',
          time: 3 * 60 + 51,
        },
        {
          name: 'Torsión de espalda',
          time: 9 * 60 + 37,
        },
        {
          name: 'Cadera',
          time: 11 * 60 + 45,
        },
        {
          name: 'Respiración',
          time: 13 * 60 + 28,
        },
      ]
    },
    {
      name: 'Respiración Alternada',
      time: 14 * 60 + 37,
      sub: [
        {
          name: 'Técnica',
          time: 14 * 60 + 37,
        },
        {
          name: 'Respiración alternada',
          time: 16 * 60 + 3,
        },
        {
          name: 'Misma fosa',
          time: 18 * 60 + 44,
        },
        {
          name: 'Respiración en tres tiempos',
          time: 20 * 60 + 24,
        },
        {
          name: 'Respiración en cuatro tiempos',
          time: 23 * 60 + 42,
        },
        {
          name: 'Recomendaciones',
          time: 25 * 60 + 15,
        },
      ]
    },
  ],
},
{
  id: "006",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/006/Front/HLS/Session+006+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/006/Back/HLS/Session+006+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/006/Front/HLS/Session+006+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/006/Back/HLS/Session+006+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/006/Front/HLS/Session+006+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/006/Back/HLS/Session+006+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/006/Front/Thumbnails/Session+006+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['warm-up']
  },
  videoInfo: {
    about: 'Calentamiento y Estiramiento general con el método RAO',
    description: 'Manten tus músculos y articulaciones preparados para tu entrenamiento.',
    relatesTo: 'Danza, Baile Fitness, Calistenia, Flex',
    recommended: 'Antes de realizar cualquier rutina de ejercicios es importante realizar ejercicios de calentamiento para preparar músculos y articulaciones para el ejecicios. De esta forma vas a evitar lesiones y aprovecharás mejor tu entrenamiento.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['001', '004', '005'],
  sections: [
    {
      name: 'Estiramiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Hombros',
          time: 1 * 60 + 9,
        },
        {
          name: 'Antebrazos',
          time: 1 * 60 + 51,
        },
        {
          name: 'Cabeza',
          time: 2 * 60 + 23,
        },
        {
          name: 'Corvas',
          time: 3 * 60 + 34,
        },
        {
          name: 'Cuello',
          time: 4 * 60 + 35,
        },
        {
          name: 'Hombros',
          time: 5 * 60 + 37,
        },
        {
          name: 'Abdomen',
          time: 6 * 60 + 54,
        },
        {
          name: 'Meditación media',
          time: 7 * 60 + 23,
        },
        {
          name: 'Tendones',
          time: 8 * 60 + 7,
        },
        {
          name: 'Desarticulación',
          time: 8 * 60 + 38,
        },
        {
          name: 'Plegado',
          time: 9 * 60 + 44,
        },
        {
          name: 'Segunda',
          time: 10 * 60 + 20,
        },
        {
          name: 'Plegado',
          time: 12 * 60 + 56,
        },
        {
          name: 'Espalda',
          time: 13 * 60 + 25,
        },
      ]
    },
    {
      name: 'Movimiento articular',
      time: 15 * 60 + 46,
      sub: [
        {
          name: 'Introducción',
          time: 15 * 60 + 46,
        },
        {
          name: 'Saltos en X',
          time: 16 * 60 + 6,
        },
        {
          name: 'Flexión de piernas',
          time: 17 * 60 + 50,
        },
        {
          name: 'Rodillas',
          time: 20 * 60 + 1,
        },
        {
          name: 'Tobillo',
          time: 20 * 60 + 41,
        },
      ]
    },
    {
      name: 'Aumento de temperatura',
      time: 21 * 60 + 47,
      sub: [
        {
          name: 'Introducción',
          time: 21 * 60 + 47,
        },
        {
          name: 'Burpee',
          time: 22 * 60 + 12,
        },
        {
          name: 'Plancha',
          time: 24 * 60 + 10,
        },
      ]
    },
  ],
},
{
  id: "007",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/007/Front/HLS/Session+007+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/007/Back/HLS/Session+007+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/007/Front/HLS/Session+007+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/007/Back/HLS/Session+007+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/007/Front/HLS/Session+007+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/007/Back/HLS/Session+007+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/007/Front/Thumbnails/Session+007+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Fortalecimiento de hombros, escencial para realizar movimientos acrobáticos.',
    description: 'Realizando esta serie de ejercicios podrás fortalecer tus hombros, una parte importante de tu cuerpo que debes trabajar para realizar con mayor facilidad otras acrobacias y movimientos.',
    relatesTo: 'Danza, Baile Fitness, Calistenia, Flex',
    recommended: 'Si te gustan las acrobacias debes de fortalezar todo tu cuerpo, en esta sesión te mostramos ejercicios para activar los hombros.<br>También los puedes realizar como complemento a tu terapia física a un ritmo más ligero.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.',
    equipment: 'Liga o banda fitness',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['006', '004', '002'],
  sections: [
    {
      name: 'Movimiento Articular',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Hombros',
          time: 1 * 60 + 19,
        },
        {
          name: 'Brazos arriba',
          time: 1 * 60 + 58,
        },
        {
          name: 'Axilas',
          time: 2 * 60 + 35,
        },
        {
          name: 'Circulos',
          time: 2 * 60 + 56,
        },
        {
          name: 'Presiones',
          time: 3 * 60 + 26,
        },
      ]
    },
    {
      name: 'Fortalecimiento con Liga',
      time: 4 * 60 + 12,
      sub: [
        {
          name: 'A la cintura',
          time: 4 * 60 + 12,
        },
        {
          name: 'Al pecho',
          time: 5 * 60 + 8,
        },
        {
          name: 'A la cabeza',
          time: 5 * 60 + 39,
        },
        {
          name: 'A la espalda',
          time: 6 * 60 + 3,
        },
        {
          name: 'A la cadera',
          time: 6 * 60 + 44,
        },
        {
          name: 'Subiendo hombros',
          time: 7 * 60 + 22,
        },
        {
          name: 'Abrir liga',
          time: 8 * 60 + 7,
        },
        {
          name: 'Biceps',
          time: 8 * 60 + 37,
        },
      ]
    },
    {
      name: 'Fortalecimiento',
      time: 9 * 60 + 20,
      sub: [
        {
          name: 'Muñecas',
          time: 9 * 60 + 20,
        },
        {
          name: 'Plancha y contracción escapular',
          time: 11 * 60 + 28,
        },
        {
          name: 'Push up',
          time: 14 * 60 + 16,
        },
        {
          name: 'Estiramiento',
          time: 17 * 60 + 34,
        },
        {
          name: 'Macarenas',
          time: 18 * 60 + 36,
        },
        {
          name: 'Lagartijas',
          time: 19 * 60 + 54,
        },
      ]
    },
  ],
},
{
  id: "008",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/008/Front/HLS/Session+008+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/008/Back/HLS/Session+008+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/008/Front/HLS/Session+008+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/008/Back/HLS/Session+008+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/008/Front/HLS/Session+008+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/008/Back/HLS/Session+008+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/008/Front/Thumbnails/Session+008+-+Custom-Poster.jpg',
  details: roaster[roasterMap['guillo']],
  category: categories[categoryMap.gimnasia],
  classType: {
    slug: ['skill'],
  },
  videoInfo: {
    about: 'Bases para el parado de manos',
    description: 'Lograr la perfección en cada movimiento requiere de tiempo y práctica, aquí te mostramos el paso a paso para lograr un parado de manos perfecto.',
    relatesTo: 'Danza, Baile Fitness, Calistenia, Flex',
    recommended: 'Lograr un parado de manos requiere de un entrenamiento específico, te recomendamos practicar estos movimientos al menos de 2 a 3 veces por semana, de 30 a 45 minutos para proteger tus articulaciones.<br>Una vez que hayas fortalecido muñecas, hombros y core puedes empezar a incrementar el tiempo de entrenamiento.<br> Puedes realizar los ejercicios de calentamiento para empezar a fortalezar tu cuerpo antes de intentar el parado de manos. <br>Si ya te sientes listo para intentarlo, te recomendamos que primero te ayudes de una silla y después de la pared, te mostramos cómo en este video.<br>Mejora tu postura, equilibrio y fuerza en las manos con estos movimientos para facilitar tu parado de manos.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: null,
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['001', '002', '005'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Cabeza',
          time: 1 * 60 + 24,
        },
        {
          name: 'Hombros',
          time: 1 * 60 + 44,
        },
        {
          name: 'Codos',
          time: 1 * 60 + 58,
        },
        {
          name: 'Torso',
          time: 2 * 60 + 40,
        },
        {
          name: 'Cintura',
          time: 2 * 60 + 46,
        },
        {
          name: 'Rodillas',
          time: 3 * 60 + 6,
        },
        {
          name: 'Piés',
          time: 3 * 60 + 12,
        },
        {
          name: 'Piernas',
          time: 3 * 60 + 26,
        },
        {
          name: 'Rodillas',
          time: 3 * 60 + 37,
        },
      ]
    },
    {
      name: 'Cardio',
      time: 3 * 60 + 50,
      sub: [
        {
          name: 'Introducción',
          time: 3 * 60 + 50,
        },
        {
          name: 'Trotar',
          time: 4 * 60 + 5,
        },
        {
          name: 'Jumping Jacks',
          time: 4 * 60 + 56,
        },
        {
          name: 'Tijeras',
          time: 5 * 60 + 27,
        },
        {
          name: 'Jogging',
          time: 5 * 60 + 51,
        },
        {
          name: 'Talones',
          time: 6 * 60 + 3,
        },
      ]
    },
    {
      name: 'Fortalecimiento de muñecas',
      time: 6 * 60 + 17,
      sub: [
        {
          name: 'Introducción',
          time: 6 * 60 + 17,
        },
        {
          name: 'Muñecas',
          time: 8 * 60 + 16,
        },
        {
          name: 'Puños',
          time: 9 * 60 + 1,
        },
        {
          name: 'Dedos',
          time: 9 * 60 + 55,
        },
      ]
    },
    {
      name: 'Fortalecimiento de hombros',
      time: 12 * 60 + 30,
      sub: [
        {
          name: 'Introducción',
          time: 12 * 60 + 30,
        },
        {
          name: 'Estiramientos',
          time: 12 * 60 + 55,
        },
        {
          name: 'Cobra',
          time: 14 * 60 + 47,
        },
        {
          name: 'Perrito',
          time: 14 * 60 + 58,
        },
        {
          name: 'Postura de meditación',
          time: 15 * 60 + 11,
        },
      ]
    },
    {
      name: 'Estiramiento de piernas',
      time: 16 * 60 + 4,
      sub: [
        {
          name: 'Mariposa',
          time: 16 * 60 + 4,
        },
        {
          name: 'Pike',
          time: 16 * 60 + 23,
        },
        {
          name: 'Straddle',
          time: 16 * 60 + 43,
        },
      ]
    },
    {
      name: 'Preparación',
      time: 17 * 60 + 27,
      sub: [
        {
          name: 'Introducción',
          time: 17 * 60 + 27,
        },
        {
          name: 'Push Ups Escapulares',
          time: 18 * 60 + 13,
        },
        {
          name: 'Propiocepción',
          time: 20 * 60 + 12,
        },
        {
          name: 'Secuencia: Abdomen I',
          time: 21 * 60 + 36,
        },
      ]
    },
    {
      name: 'Parado de manos',
      time: 27 * 60 + 15,
      sub: [
        {
          name: 'Técnica',
          time: 27 * 60 + 15,
        },
        {
          name: 'Elevación de cadera',
          time: 27 * 60 + 52,
        },
        {
          name: 'Elevación con silla',
          time: 29 * 60 + 39,
        },
        {
          name: 'Elevación de pierna',
          time: 30 * 60 + 42,
        },
        {
          name: 'Variación de Elefantes',
          time: 33 * 60 + 3,
        },
        {
          name: 'Elefantes',
          time: 34 * 60 + 3,
        },
        {
          name: 'Parado de manos con silla',
          time: 34 * 60 + 30,
        },
        {
          name: 'Parado de manos en pared',
          time: 35 * 60 + 49,
        },
        {
          name: 'Parado de manos en piso',
          time: 37 * 60 + 19,
        },
      ]
    },
    {
      name: 'Estiramiento',
      time: 39 * 60 + 12,
      sub: [
        {
          name: 'Técnica',
          time: 39 * 60 + 12,
        },
        {
          name: 'Pike',
          time: 39 * 60 + 32,
        },
        {
          name: 'Straddle',
          time: 40 * 60 + 9,
        },
        {
          name: 'Bolita',
          time: 40 * 60 + 42,
        },
        {
          name: 'Cobra',
          time: 41 * 60 + 12,
        },
        {
          name: 'Perrito',
          time: 41 * 60 + 30,
        },
        {
          name: 'Postura de meditación',
          time: 41 * 60 + 54,
        },
      ]
    },
  ],
},
{
  id: "009",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/009/Front/HLS/Session+009+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/009/Back/HLS/Session+009+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/009/Front/HLS/Session+009+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/009/Back/HLS/Session+009+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/009/Front/HLS/Session+009+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/009/Back/HLS/Session+009+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/009/Front/Thumbnails/Session+009+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Flat Back - Fortalecimiento y flexibilidad de espalda',
    description: 'Mantener una espalda fuerte es fundamental para cualquier tipo de actividad, con esta serie de ejercicios podrás lograr una mejor postura.<br>Si presentas dolores de espalda frequentemente te recomendamos realizar estos ejercicios para que la fortalezcas y tengas una mejor movilidad.',
    relatesTo: 'Danza, Baile Fitness, Calistenia, Flex, Gimnasia',
    recommended: '',
    tools: '',
    equipment: null,
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['001', '008', '006'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Hombros',
          time: 45,
        },
        {
          name: 'Cabeza',
          time: 1 * 60 + 15,
        },
        {
          name: 'Espalda',
          time: 1 * 60 + 49,
        },
        {
          name: 'Estiramiento de espalda',
          time: 2 * 60 + 32,
        },
        {
          name: 'Cobra',
          time: 3 * 60 + 30,
        },
        {
          name: 'Meditación media',
          time: 3 * 60 + 54,
        },
        {
          name: 'Tobillos',
          time: 4 * 60 + 19,
        },
      ]
    },
    {
      name: 'Flat Back',
      time: 4 * 60 + 53,
      sub: [
        {
          name: 'Introducción',
          time: 4 * 60 + 53,
        },
        {
          name: 'Movimiento articular',
          time: 5 * 60 + 50,
        },
        {
          name: 'Fortalecimiento',
          time: 9 * 60 + 42,
        },
        {
          name: 'Alargamiento',
          time: 14 * 60 + 14,
        },
        {
          name: 'Postura',
          time: 18 * 60 + 11,
        },
        {
          name: 'Mariposas con ajuste',
          time: 22 * 60 + 10,
        },
        {
          name: 'Plancha I',
          time: 24 * 60 + 54,
        },
        {
          name: 'Plancha II',
          time: 27 * 60 + 20,
        },
      ]
    },
  ],
},
{
  id: "010",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/010/Front/HLS/Session+010+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/010/Back/HLS/Session+010+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/010/Front/HLS/Session+010+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/010/Back/HLS/Session+010+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/010/Front/HLS/Session+010+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/010/Back/HLS/Session+010+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/010/Front/Thumbnails/Session+010+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  isFree: true,
  classType: {
    slug: ['skill', 'free'],
  },
  videoInfo: {
    about: 'Aprende la técnica para realizar un back-roll.',
    description: 'El back-roll es un elemento de la acrobacia de piso, el cuál combina la fuerza, la elasticidad y el control corporal.',
    relatesTo: 'Danza, Baile Fitness, Calistenia, Flex, Gimnasia',
    recommended: '',
    tools: 'Utiliza la cámara trasera para ver los movimientos de ambos ángulos para corregir tu postura al realizar cada ejercicio.<br>Utiliza la herramienta de espejo para que sea más sencillo seguir los movimientos.',
    equipment: null,
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['006', '008', '007'],
  sections: [
    {
      name: 'Estiramiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Hombros',
          time: 50,
        },
        {
          name: 'Cabeza',
          time: 1 * 60 + 23,
        },
        {
          name: 'Giro de brazos',
          time: 1 * 60 + 59,
        },
        {
          name: 'Espalda',
          time: 2 * 60 + 16,
        },
        {
          name: 'Squat',
          time: 4 * 60 + 30,
        },
        {
          name: 'Plegado',
          time: 5 * 60 + 59,
        },
      ]
    },
    {
      name: 'Back roll',
      time: 6 * 60 + 48,
      sub: [
        {
          name: 'Fortalecimiento de hombros',
          time: 6 * 60 + 48,
        },
        {
          name: 'Entrada',
          time: 8 * 60 + 30,
        },
        {
          name: 'Medio giro',
          time: 10 * 60 + 22,
        },
        {
          name: 'A velocidad normal',
          time: 15 * 60 + 47,
        },
        {
          name: 'Progresión I',
          time: 18 * 60 + 39,
        },
        {
          name: 'Combinación de elementos',
          time: 19 * 60 + 50,
        },
      ]
    },
    {
      name: 'Back roll izquierdo',
      time: 21 * 60 + 4,
      sub: [
        {
          name: 'Marcación',
          time: 21 * 60 + 4,
        },
        {
          name: 'Aleteo de murciélago',
          time: 22 * 60 + 31,
        },
        {
          name: 'Combinación de elementos',
          time: 23 * 60 + 1,
        },
        {
          name: 'Combinación a ambos lados',
          time: 26 * 60 + 21,
        },
      ]
    },
  ],
},
{
  id: "011",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/011/Front/HLS/Session+011+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/011/Back/HLS/Session+011+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/011/Front/HLS/Session+011+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/011/Back/HLS/Session+011+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/011/Front/HLS/Session+011+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/011/Back/HLS/Session+011+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/011/Front/Thumbnails/Session+011+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['skill'],
  },
  videoInfo: {
    about: 'Técnica para parado de cabeza',
    description: 'Aprende este elemento y combinalo con otros elementos para complementar tus coreografías.',
    relatesTo: 'Danza, Baile Fitness, Calistenia, Flex, Gimnasia, Hip Hop',
    recommended: 'Recuerda que en todas las sesiones es importante realizar un calentamiento previo, puedes encontrar otros videos con calentamientos generales de diferentes disciplinas que puedes realizar antes de hacer los movimientos de esta sesión.<br>O puedes realizar un calentamiento específico según el grupo muscular que vayas a utilizar en los elementos.',
    tools: '',
    equipment: null,
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['001', '010', '006'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Cabeza',
          time: 43,
        },
        {
          name: 'Hombros',
          time: 1 *60 + 38,
        },
        {
          name: 'Espalda',
          time: 3 *60 + 8,
        },
        {
          name: 'Cobra',
          time: 5 *60 + 25,
        },
        {
          name: 'Meditación media',
          time: 5 *60 + 46,
        },
        {
          name: 'Cuello',
          time: 6 *60 + 19,
        },
        {
          name: 'Corvas',
          time: 7 *60 + 39,
        },
        {
          name: 'Squat',
          time: 8 *60 + 8,
        },
      ]
    },
    {
      name: 'Movimientos Basicos',
      time: 9 * 60 + 50,
      sub: [
        {
          name: 'Introducción',
          time: 9 * 60 + 50,
        },
        {
          name: 'Preparación',
          time: 10 * 60 + 49,
        },
        {
          name: 'Progresión de piernas',
          time: 12 * 60 + 32,
        },
        {
          name: 'Estabilidad en pared',
          time: 13 * 60 + 36,
        },
        {
          name: 'Postura de ajuste',
          time: 18 * 60 + 53,
        },
        {
          name: 'Postura de triangulo',
          time: 22 * 60 + 40,
        },
        {
          name: 'Estabilidad en piso',
          time: 25 * 60 + 25,
        },
        {
          name: 'Head Stand',
          time: 28 * 60 + 35,
        },
      ]
    },
    {
      name: 'Muelleos',
      time: 29 * 60 + 39,
      sub: [
        {
          name: 'Introducción',
          time: 29 * 60 + 39,
        },
        {
          name: 'Muelleos con piernas estiradas',
          time: 29 * 60 + 55,
        },
        {
          name: 'Recomendaciones',
          time: 31 * 60 + 2,
        },
      ]
    },
  ],
},
{
  id: "012",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/012/Front/HLS/Session+012+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/012/Back/HLS/Session+012+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/012/Front/HLS/Session+012+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/012/Back/HLS/Session+012+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/012/Front/HLS/Session+012+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/012/Back/HLS/Session+012+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/012/Front/Thumbnails/Session+012+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['movement']
  },
  videoInfo: {
    about: 'Tripoide, practica esta variación del parado de cabeza.',
    description: 'Trabaja tus abdominales, hombros y espalda con este ejercicio.',
    relatesTo: 'Danza, Baile Fitness, Calistenia, Flex, Gimnasia, Hip Hop',
    recommended: 'Recuerda que en todas las sesiones es importante realizar un calentamiento previo, puedes encontrar otros videos con calentamientos generales de diferentes disciplinas que puedes realizar antes de hacer los movimientos de esta sesión.<br>O puedes realizar un calentamiento específico según el grupo muscular que vayas a utilizar en los elementos.',
    tools: '',
    equipment: null,
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['006', '010', '008'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Cabeza',
          time: 1 * 60 + 13,
        },
        {
          name: 'Hombros',
          time: 2 * 60 + 9,
        },
        {
          name: 'Espalda',
          time: 3 * 60 + 48,
        },
      ]
    },
    {
      name: 'Estiramiento',
      time: 6 * 60 + 34,
      sub: [
        {
          name: 'Flex',
          time: 6 * 60 + 34,
        },
        {
          name: 'Segunda',
          time: 7 * 60 + 10,
        },
      ]
    },
    {
      name: 'Tripoide',
      time: 8 * 60 + 5,
      sub: [
        {
          name: 'Fortalecimiento de abdomen',
          time: 8 * 60 + 5,
        },
        {
          name: 'Fortalecimiento de la postura',
          time: 11 * 60 + 14,
        },
        {
          name: 'Fortalecimiento con piernas estiradas',
          time: 15 * 60 + 2,
        },
        {
          name: 'Fortalecimiento en pared',
          time: 16 * 60 + 52,
        },
        {
          name: 'Técnica de tripoide',
          time: 22 * 60 + 53,
        },
        {
          name: 'Ejemplo incorrecto',
          time: 27 * 60 + 12,
        },
        {
          name: 'Tripoide desde plancha',
          time: 29 * 60 + 12,
        },
        {
          name: 'Recomendaciones',
          time: 30 * 60 + 53,
        },
      ]
    },
  ],
},
{
  id: "013",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/013/Front/HLS/Session+013+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/013/Back/HLS/Session+013+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/013/Front/HLS/Session+013+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/013/Back/HLS/Session+013+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/013/Front/HLS/Session+013+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/013/Back/HLS/Session+013+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/013/Front/Thumbnails/Session+013+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Trabajo de squat con el método RAO.',
    description: 'Mejora tu flexibilidad evitando lesiones. Trabaja tus abductores junto con el resto de los músculos de la pierna para obtener mejores resultados.',
    relatesTo: 'Danza, Baile Fitness, Calistenia, Flex, Gimnasia, Hip Hop',
    recommended: 'Recuerda que en todas las sesiones es importante realizar un calentamiento previo, puedes encontrar otros videos con calentamientos generales de diferentes disciplinas que puedes realizar antes de hacer los movimientos de esta sesión.<br>O puedes realizar un calentamiento específico según el grupo muscular que vayas a utilizar en los elementos.',
    tools: '',
    equipment: null,
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['006', '012', '008'],
  sections: [
    {
      name: 'Estiramiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Corvas',
          time: 1 * 60 + 49,
        },
        {
          name: 'Técnica',
          time: 3 * 60 + 45,
        },
        {
          name: 'Abductores',
          time: 4 * 60 + 21,
        },
        {
          name: 'Cuadriceps',
          time: 4 * 60 + 56,
        },
      ]
    },
    {
      name: 'Movimiento Articular',
      time: 5 * 60 + 30,
      sub: [
        {
          name: 'Introducción',
          time: 5 * 60 + 30,
        },
        {
          name: 'Flexiones de piernas',
          time: 5 * 60 + 36,
        },
        {
          name: 'Flexiones de rodilla',
          time: 7 * 60 + 15,
        },
        {
          name: 'Plié',
          time: 8 * 60 + 16,
        },
        {
          name: 'Muelleos en plegado',
          time: 9 * 60 + 34,
        },
      ]
    },
    {
      name: 'Aumento de temperatura',
      time: 10 * 60 + 29,
      sub: [
        {
          name: 'Introducción',
          time: 10 * 60 + 29,
        },
        {
          name: 'Burpee en squat',
          time: 11 * 60 + 25,
        },
        {
          name: 'Estiramiento en segunda',
          time: 14 * 60 + 16,
        },
        {
          name: 'Recomendaciones',
          time: 15 * 60 + 42,
        },
        {
          name: 'Squat con flat-back',
          time: 17 * 60 + 9,
        },
        {
          name: 'Estiramiento en segunda II',
          time: 19 * 60 + 8,
        },
      ]
    },
    {
      name: 'Full training',
      time: 20 * 60 + 43,
      sub: [
        {
          name: 'Introducción',
          time: 20 * 60 + 43,
        },
        {
          name: 'Patadas en punta (Básico)',
          time: 21 * 60 + 4,
        },
        {
          name: 'Patadas en punta (Intermedio)',
          time: 23 * 60 + 39,
        },
        {
          name: 'Estiramiento en segunda',
          time: 25 * 60 + 41,
        },
      ]
    },
    {
      name: 'Estiramiento',
      time: 26 * 60 + 34,
      sub: [
        {
          name: 'Introducción',
          time: 26 * 60 + 34,
        },
        {
          name: 'Muelleos en squat (Básico)',
          time: 26 * 60 + 52,
        },
        {
          name: 'Muelleos en squat (Intermedio)',
          time: 28 * 60 + 23,
        },
        {
          name: 'Recomendaciones',
          time: 31 * 60 + 15,
        },
      ]
    },
  ],
},
{
  id: "014",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/014/Front/HLS/Session+014+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/014/Back/HLS/Session+014+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/014/Front/HLS/Session+014+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/014/Back/HLS/Session+014+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/014/Front/HLS/Session+014+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/014/Back/HLS/Session+014+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/014/Front/Thumbnails/Session+014+-+Custom-Poster.jpg',
  details: roaster[roasterMap['mary-y-john']],
  category: categories[categoryMap.acroyoga],
  isFree: true,
  classType: {
    slug: ['training', 'free']
  },
  videoInfo: {
    about: 'Ejercicios en pareja',
    description: 'Activa tu cuerpo con esta serie de ejercicios y además hazlo en pareja, diviertete y trabaja tu cuerpo al mismo tiempo.',
    relatesTo: 'Danza, Flex, Gimnasia, Yoga, Calentamiento',
    recommended: 'Recuerda que en todas las sesiones es importante realizar un calentamiento previo, puedes encontrar otros videos con calentamientos generales de diferentes disciplinas que puedes realizar antes de hacer los movimientos de esta sesión.<br>O puedes realizar un calentamiento específico según el grupo muscular que vayas a utilizar en los elementos.',
    tools: '',
    equipment: 'tapete de yoga',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['004', '005', '006'],
  sections: [
    {
      name: 'Movimiento Articular',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Cabeza',
          time: 48,
        },
        {
          name: 'Hombros',
          time: 1 * 60 + 31,
        },
        {
          name: 'Muñecas',
          time: 2 * 60 + 9,
        },
        {
          name: 'Cadera',
          time: 3 * 60 + 3,
        },
        {
          name: 'Rodillas',
          time: 4 * 60 + 14,
        },
        {
          name: 'Tobillos',
          time: 4 * 60 + 44,
        },
      ]
    },
    {
      name: 'Fortalecimiento',
      time: 5 * 60 + 15,
      sub: [
        {
          name: 'Introducción',
          time: 5 * 60 + 15,
        },
        {
          name: 'Flexiones',
          time: 5 * 60 + 31,
        },
        {
          name: 'Flexiones (cambio de lado)',
          time: 9 * 60 + 14,
        },
        {
          name: 'Abdomen',
          time: 11 * 60 + 13,
        },
        {
          name: 'Sentadillas',
          time: 17 * 60 + 24,
        },
        {
          name: 'Desplantes',
          time: 19 * 60 + 20,
        },
        {
          name: 'Cambio de peso en squat',
          time: 20 * 60 + 36,
        },
        {
          name: 'Recomendaciones',
          time: 21 * 60 + 43,
        },
      ]
    },
  ],
},
{
  id: "015",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/015/Front/HLS/Session+015+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/015/Back/HLS/Session+015+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/015/Front/HLS/Session+015+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/015/Back/HLS/Session+015+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/015/Front/HLS/Session+015+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/015/Back/HLS/Session+015+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/015/Front/Thumbnails/Session+015+-+Custom-Poster.jpg',
  details: roaster[roasterMap['mary-y-john']],
  category: categories[categoryMap.acroyoga],
  classType: {
    slug: ['movement']
  },
  videoInfo: {
    about: 'Pajarito y Back Bird',
    description: 'Esta es la posición básica para la mayoría de las posiciones en Acroyoga. Trabaja tu cuerpo, confianza y comunicación con tu pareja.',
    relatesTo: 'Danza, Flex, Gimnasia, Yoga, Calentamiento',
    recommended: 'Recuerda que en todas las sesiones es importante realizar un calentamiento previo, puedes encontrar otros videos con calentamientos generales de diferentes disciplinas que puedes realizar antes de hacer los movimientos de esta sesión.<br>O puedes realizar un calentamiento específico según el grupo muscular que vayas a utilizar en los elementos.<br>Es importante empezar a fortalecer la zona del core y las piernas antes de intentar estos movimientos, por lo que te recomendamos practicar las sesiones de acondicionamiento para que te ayuden a mejorar tu fuerza y control de estas partes del cuerpo.',
    tools: '',
    equipment: '2 tapetes de yoga',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['004', '014', '006'],
  sections: [
    {
      name: 'Postura de base',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Preparación',
          time: 1 * 60 + 12,
        },
        {
          name: 'Postura',
          time: 2 * 60 + 32,
        },
        {
          name: 'Posición de manos',
          time: 3 * 60 + 22,
        },
        {
          name: 'Posición de piés',
          time: 4 * 60 + 43,
        },
      ]
    },
    {
      name: 'Postura del Volador',
      time: 7 * 60 + 48,
      sub: [
        {
          name: 'Calibración del peso',
          time: 7 * 60 + 19,
        },
        {
          name: 'Posición de la espalda',
          time: 7 * 60 + 48,
        },
        {
          name: 'Flexiones a brazos extendidos',
          time: 9 * 60,
        },
        {
          name: 'Errores comunes',
          time: 9 * 60 + 47,
        },
      ]
    },
    {
      name: 'Pajarito',
      time: 10 * 60 + 58,
      sub: [
        {
          name: 'Calibraciones',
          time: 10 * 60 + 58,
        },
        {
          name: 'Técnica',
          time: 13 * 60 + 50,
        },
        {
          name: 'Vuelo',
          time: 14 * 60 + 33,
        },
        {
          name: 'Correcciones',
          time: 15 * 60 + 8,
        },
        {
          name: 'Sin manos',
          time: 16 * 60 + 3,
        },
        {
          name: 'Recomendaciones',
          time: 16 * 60 + 47,
        },
        {
          name: 'Vuelo con pared',
          time: 18 * 60 + 49,
        },
      ]
    },
    {
      name: 'Back Bird',
      time: 20 * 60 + 10,
      sub: [
        {
          name: 'Calibraciónes',
          time: 20 * 60 + 10,
        },
        {
          name: 'Técnica',
          time: 22 * 60 + 13,
        },
        {
          name: 'Descenso',
          time: 23 * 60 + 10,
        },
        {
          name: 'Recomendaciones',
          time: 23 * 60 + 21,
        },
        {
          name: 'Sin manos',
          time: 24 * 60 + 50,
        },
      ]
    },
  ],
},
{
  id: "016",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/016/Front/HLS/Session+016+-+Front_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/016/Front/Thumbnails/Session+016+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['skill'],
  },
  videoInfo: {
    about: 'Animal Flow - Elefante, Rana. Lagartija y Mono.',
    description: 'Animal Flow es una técnica que pertenece a la Danza Contemporanea.<br>Su nombre se toma ya que los movimientos son una copia de movimientos de animales.<br>Desarrolla más flexibilidad, fuerza y mejora tu coordinación practicando estos movimientos.',
    relatesTo: 'Flex, Gimnasia, Yoga, Calentamiento, Danza Jazz',
    recommended: 'Recuerda que en todas las sesiones es importante realizar un calentamiento previo, puedes encontrar otros videos con calentamientos generales de diferentes disciplinas que puedes realizar antes de hacer los movimientos de esta sesión.<br>O puedes realizar un calentamiento específico según el grupo muscular que vayas a utilizar en los elementos.<br>',
    tools: '',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['006', '012', '011'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: '¿Qué es Animal Flow?',
          time: 0,
        },
        {
          name: 'Cabeza',
          time: 1 * 60 + 26,
        },
        {
          name: 'Hombros',
          time: 2 * 60 + 0,
        },
        {
          name: 'Cintura',
          time: 2 * 60 + 50,
        },
        {
          name: 'Piernas',
          time: 3 * 60 + 17,
        },
        {
          name: 'Piés',
          time: 4 * 60 + 3,
        },
        {
          name: 'Brazos',
          time: 4 * 60 + 41,
        },
        {
          name: 'Estiramiento',
          time: 5 * 60 + 27,
        },
      ]
    },
    {
      name: 'Elefante',
      time: 7 * 60 + 47,
      sub: [
        {
          name: 'Introducción',
          time: 7 * 60 + 47,
        },
        {
          name: 'Postura inicial',
          time: 8 * 60 + 59,
        },
        {
          name: 'Movimiento',
          time: 9 * 60 + 46,
        },
        {
          name: 'Ida y Vuelta',
          time: 11 * 60 + 6,
        },
        {
          name: 'Movimiento de los brazos',
          time: 12 * 60 + 7,
        },
      ]
    },
    {
      name: 'Rana',
      time: 13 * 60 + 13,
      sub: [
        {
          name: 'Introducción',
          time: 13 * 60 + 13,
        },
        {
          name: 'Fortalecimiento',
          time: 13 * 60 + 53,
        },
        {
          name: 'Movimiento',
          time: 16 * 60 + 37,
        },
        {
          name: 'Desplazamientos',
          time: 17 * 60 + 58,
        },
      ]
    },
    {
      name: 'Mono',
      time: 19 * 60 + 12,
      sub: [
        {
          name: 'Introducción',
          time: 19 * 60 + 12,
        },
        {
          name: 'Movimiento Principiante',
          time: 19 * 60 + 40,
        },
        {
          name: 'Movimiento Intermedio',
          time: 21 * 60 + 17,
        },
        {
          name: 'Desplazamientos',
          time: 22 * 60 + 38,
        },
      ]
    },
    {
      name: 'Lagartija',
      time: 24 * 60 + 3,
      sub: [
        {
          name: 'Introducción',
          time: 24 * 60 + 3,
        },
        {
          name: 'Postura inicial',
          time: 24 * 60 + 40,
        },
        {
          name: 'Desplazamiento - Básico',
          time: 26 * 60 + 34,
        },
        {
          name: 'Desplazamiento - Intermedio',
          time: 27 * 60 + 41,
        },
        {
          name: 'Desplazamiento - Avanzado',
          time: 28 * 60 + 39,
        },
        {
          name: 'Recomendaciones',
          time: 29 * 60 + 49,
        },
        {
          name: 'Combinación',
          time: 30 * 60 + 38,
        },
      ]
    },
  ],
},
{
  id: "017",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/017/Front/HLS/Session+017+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/017/Back/HLS/Session+017+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/017/Front/HLS/Session+017+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/017/Back/HLS/Session+017+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/017/Front/HLS/Session+017+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/017/Back/HLS/Session+017+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/017/Front/Thumbnails/Session+017+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['skill'],
  },
  videoInfo: {
    about: 'Equilibrio a un codo, sube de nivel.',
    description: 'Continuamos con las progresiones, si ya puedes parte de cabeza y estas dominando el parado sobre el codo, continúa mejorando tus skills con el siguiente movimiento.',
    relatesTo: 'Flex, Gimnasia, Yoga, Calentamiento',
    recommended: 'Recuerda que en todas las sesiones es importante realizar un calentamiento previo, puedes encontrar otros videos con calentamientos generales de diferentes disciplinas que puedes realizar antes de hacer los movimientos de esta sesión.<br>O puedes realizar un calentamiento específico según el grupo muscular que vayas a utilizar en los elementos.<br>',
    tools: '',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['006', '012', '011'],
  sections: [
    {
      name: 'Movimiento Articular',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Cabeza',
          time: 1 * 60 + 39,
        },
        {
          name: 'Hombros',
          time: 2 * 60 + 11,
        },
        {
          name: 'Hombros en piso',
          time: 2 * 60 + 39,
        },
        {
          name: 'Plank Push-ups',
          time: 4 * 60 + 12,
        },
        {
          name: 'Plancha a un brazo',
          time: 6 * 60 + 38,
        },
        {
          name: 'Pike con patada hacia atrás',
          time: 9 * 60 + 43,
        },
      ]
    },
    {
      name: 'Fortalecimiento',
      time: 10 * 60 + 40,
      sub: [
        {
          name: 'Recomendaciones',
          time: 10 * 60 + 40,
        },
        {
          name: 'Patada hacia atrás en base',
          time: 12 * 60 + 36,
        },
        {
          name: 'Base sobre pared',
          time: 14 * 60 + 33,
        },
        {
          name: 'Técnica',
          time: 16 * 60 + 39,
        },
        {
          name: 'Base en agrupamiento',
          time: 17 * 60 + 50,
        },
        {
          name: 'Abdominal en flat-back',
          time: 19 * 60 + 45,
        },
      ]
    },
    {
      name: 'Equilibro',
      time: 22 * 60 + 33,
      sub: [
        {
          name: 'Introducción',
          time: 22 * 60 + 33,
        },
        {
          name: 'Equilibrio de codos',
          time: 22 * 60 + 59,
        },
        {
          name: 'Equilibrio de tripoide',
          time: 23 * 60 + 56,
        },
        {
          name: 'Equilibrio a un codo',
          time: 24 * 60 + 27,
        },
        {
          name: 'Recomendaciones',
          time: 26 * 60 + 4,
        },
        {
          name: 'Combinación',
          time: 27 * 60 + 50,
        },
      ]
    },
  ],
},
{
  id: "018",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/018/Front/HLS/Session+018+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/018/Back/HLS/Session+018+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/018/Front/HLS/Session+018+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/018/Back/HLS/Session+018+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/018/Front/HLS/Session+018+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/018/Back/HLS/Session+018+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/018/Front/Thumbnails/Session+018+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Mejora tu Split',
    description: 'En esta sesión nos enfocamos a mejorar tu split, repite esta serie de movimientos para que poco a poco puedas mejorar tu flexibilidad y principalmente el split.',
    relatesTo: 'Flex, Gimnasia, Yoga, Calentamiento',
    recommended: 'Los ejercicios de calentamiento y estiramiento son ideales para corregir posturas y activar músculos que generalmente no trabajamos.<br>Si tienes problemas con el nervio ciático puedes hacer los ejercicios de estiramiento, principalmente el de Isquiones.<br>Recuerda que en todas las sesiones es importante realizar un calentamiento previo, puedes encontrar otros videos con calentamientos generales de diferentes disciplinas que puedes realizar antes de hacer los movimientos de esta sesión.<br>O puedes realizar un calentamiento específico según el grupo muscular que vayas a utilizar en los elementos.',
    tools: '',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['006', '018', '008'],
  sections: [
    {
      name: 'Estiramiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Corvas',
          time: 1 * 60 + 17,
        },
        {
          name: 'Cadera',
          time: 1 * 60 + 52,
        },
        {
          name: 'Pike',
          time: 3 * 60 + 38,
        },
        {
          name: 'Cuadriceps',
          time: 4 * 60 + 20,
        },
        {
          name: 'Talones',
          time: 5 * 60 + 3,
        },
        {
          name: 'Isquiones',
          time: 5 * 60 + 54,
        },
        {
          name: 'Plegado',
          time: 6 * 60 + 58,
        },
      ]
    },
    {
      name: 'Movimiento Articular',
      time: 7 * 60 + 23,
      sub: [
        {
          name: 'High Knees',
          time: 7 * 60 + 23,
        },
        {
          name: 'Pliés en flat-back',
          time: 8 * 60 + 52,
        },
        {
          name: 'Giros de Abductor',
          time: 9 * 60 + 59,
        },
        {
          name: 'Pliés en flat-back',
          time: 11 * 60 + 18,
        },
      ]
    },
    {
      name: 'Aumento de Temperatura',
      time: 11 * 60 + 47,
      sub: [
        {
          name: 'Introducción',
          time: 11 * 60 + 47,
        },
        {
          name: 'Burpees',
          time: 12 * 60 + 37,
        },
        {
          name: 'Squat',
          time: 14 * 60 + 42,
        },
        {
          name: 'Técnica',
          time: 15 * 60 + 39,
        },
        {
          name: 'Flexiones',
          time: 16 * 60,
        },
        {
          name: 'Burpees',
          time: 18 * 60 + 1,
        },
        {
          name: 'Squat',
          time: 18 * 60 + 42,
        },
        {
          name: 'Flexiones',
          time: 20 * 60 + 37,
        },
      ]
    },
    {
      name: 'Alargamiento de Split',
      time: 21 * 60 + 45,
      sub: [
        {
          name: 'Introducción',
          time: 21 * 60 + 45,
        },
        {
          name: 'Cuarta',
          time: 21 * 60 + 59,
        },
        {
          name: 'Patada hacia atrás',
          time: 25 * 60 + 48,
        },
        {
          name: 'Patada en plegado',
          time: 26 * 60 + 34,
        },
        {
          name: 'Split en piso',
          time: 27 * 60 + 49,
        },
        {
          name: 'Recomendaciones',
          time: 29 * 60 + 30,
        },
        {
          name: 'Split',
          time: 31 * 60 + 59,
        },
      ]
    },
  ],
},
{
  id: "019",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/019/Front/HLS/Session+019+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/019/Back/HLS/Session+019+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/019/Front/HLS/Session+019+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/019/Back/HLS/Session+019+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/019/Front/HLS/Session+019+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/019/Back/HLS/Session+019+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/019/Front/Thumbnails/Session+019+-+Custom-Poster.jpg',
  details: roaster[roasterMap['angie-campirano']],
  category: categories[categoryMap.flex],
  classType: {
    slug: ['warm-up', 'free']
  },
  isFree: true,
  videoInfo: {
    about: 'Calentamiento para tren inferior',
    description: 'Trabaja tu flexibilidad para conseguir la elongación de tu cuerpo, tener músculos, tendones, ligamentos y articulaciones con mejor plasticidad y extensibilidad.',
    relatesTo: 'Gimnasia, Yoga, Calentamiento, Danza Acrobática',
    recommended: 'Mientras mejor sea tu calentamiento mejor será tu flexibilidad, realizar cualquier tipo de ejecicio o actividad en general te será más sencillo.<br><br> Puedes conseguir ser tan flexible como desees pero es importante empezar poco a poco.<br><br> En estas sesiones nos vamos a enfocar en preparar tu cuerpo de forma progresiva, para que junto con tu constancia puedas realizar movimientos más complejos sin lesionarte.',
    tools: '',
    equipment: 'Tapete de Yoga y toalla',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['018', '004', '008'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'High Knees',
          time: 48,
        },
        {
          name: 'Toque de talones',
          time: 2 * 60 + 18,
        },
        {
          name: 'Patadas al frente',
          time: 3 * 60 + 25,
        },
        {
          name: 'Flexión de rodillas',
          time: 4 * 60 + 40,
        },
      ]
    },
    {
      name: 'Movilidad Articular',
      time: 6 * 60 + 2,
      sub: [
        {
          name: 'Introducción',
          time: 6 * 60 + 2,
        },
        {
          name: 'Extensiones laterales de rodilla',
          time: 6 * 60 + 17,
        },
        {
          name: 'Extensión de pierna',
          time: 8 * 60 + 31,
        },
        {
          name: 'Toque de puntas',
          time: 11 * 60 + 17,
        },
      ]
    },
    {
      name: 'Aumento de Temperatura',
      time: 14 * 60 + 21,
      sub: [
        {
          name: 'Introducción',
          time: 14 * 60 + 21,
        },
        {
          name: 'Desplantes',
          time: 14 * 60 + 35,
        },
        {
          name: 'Extensiones posteriores de pierna',
          time: 17 * 60 + 15,
        },
        {
          name: 'Flexo-extensiones en cuarta',
          time: 19 * 60 + 57,
        },
        {
          name: 'Extensiones posteriores en 6 puntos',
          time: 23 * 60 + 31,
        },
        {
          name: 'Extensiones',
          time: 26 * 60 + 17,
        },
        {
          name: 'Extensión de cuadriceps',
          time: 28 * 60 + 54,
        },
      ]
    },
    {
      name: 'Estiramiento',
      time: 31 * 60 + 58,
      sub: [
        {
          name: 'Introducción',
          time: 31 * 60 + 58,
        },
        {
          name: 'Medio Split',
          time: 32 * 60 + 18,
        },
        {
          name: 'Extensión en cuarta flexionanda',
          time: 34 * 60 + 54,
        },
        {
          name: 'Estiramiento y flexión',
          time: 36 * 60 + 53,
        },
        {
          name: 'Estiramiento',
          time: 39 * 60 + 46,
        },
      ]
    },
  ],
},
{
  id: "020",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/020/Front/HLS/Session+020+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/020/Back/HLS/Session+020+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/020/Front/HLS/Session+020+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/020/Back/HLS/Session+020+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/020/Front/HLS/Session+020+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/020/Back/HLS/Session+020+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/020/Front/Thumbnails/Session+020+-+Custom-Poster.jpg',
  details: roaster[roasterMap.ekbars],
  category: categories[categoryMap.calistenia],
  isFree: true,
  classType: {
    slug: ['warm-up', 'free']
  },
  videoInfo: {
    about: 'Calentamiento Calistenico',
    description: 'Prepárate para realizar tus entrenamientos con esta rutina de ejercicios. <br><br>No importa si nunca has hecho ejercicio o quieres retomar tu actividad física, en esta sesión te llevamos paso a paso para que hagas del ejercicio un buen hábito.',
    relatesTo: 'Gimnasia, Yoga, Calentamiento, Flex',
    recommended: 'Te recomendamos realizar esta serie de ejercicios como calentamiento antes de realizar cualquier trabajo físico. <br><br>Si quieres empezar a ejercitarte pero no sabes en donde empezar, este es el lugar.<br><br>Las sesiones de Calistenia están diseñadas para que las sigas de forma progresiva, por lo que te recomendamos que al menos una vez las sigas en orden.',
    tools: '',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['008', '005', '019'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Cabeza',
          time: 1 * 60 + 8,
        },
        {
          name: 'Hombros',
          time: 2 * 60 + 35,
        },
        {
          name: 'Dorsal',
          time: 7 * 60 + 15,
        },
        {
          name: 'Codos',
          time: 8 * 60 + 38,
        },
        {
          name: 'Muñecas',
          time: 10 * 60 + 35,
        },
        {
          name: 'Core',
          time: 12 * 60 + 40,
        },
        {
          name: 'Cadera',
          time: 13 * 60 + 16,
        },
        {
          name: 'Elevación de rodilla',
          time: 14 * 60 + 47,
        },
        {
          name: 'Femoral',
          time: 15 * 60 + 34,
        },
        {
          name: 'Elevación Rodilla - Femoral',
          time: 16 * 60 + 15,
        },
        {
          name: 'Tobillos',
          time: 17 * 60 + 9,
        },
      ]
    },
    {
      name: 'Elevación de Temperatura',
      time: 19 * 60 + 19,
      sub: [
        {
          name: 'Introducción',
          time: 19 * 60 + 19,
        },
        {
          name: 'Jumping Jacks',
          time: 19 * 60 + 34,
        },
        {
          name: 'Tijeras',
          time: 20 * 60 + 36,
        },
        {
          name: 'Patada hacia atrás',
          time: 21 * 60 + 40,
        },
        {
          name: 'Saltos',
          time: 22 * 60 + 23,
        },
        {
          name: 'Mountain Climbers',
          time: 23 * 60 + 10,
        },
        {
          name: 'High Knees',
          time: 24 * 60 + 9,
        },
        {
          name: 'Recomendaciones',
          time: 25 * 60 + 5,
        },
      ]
    },
  ],
},
{
  id: "021",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/021/Front/HLS/Session+021+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/021/Back/HLS/Session+021+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/021/Front/HLS/Session+021+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/021/Back/HLS/Session+021+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/021/Front/HLS/Session+021+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/021/Back/HLS/Session+021+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/021/Front/Thumbnails/Session+021+-+Custom-Poster.jpg',
  details: roaster[roasterMap["angie-campirano"]],
  category: categories[categoryMap.flex],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Flexibilidad para el tren inferior',
    description: 'Con esta serie de ejercicios podrás poco a poco mejorar tu split sin sufrir lesiones en el camino.<br>En esta sesión nos enfocaremos en el movimiento de músculos y articulaciones del tren inferior con el objetivo de prepararlos para el trabajo del Split.',
    relatesTo: 'Gimnasia, Yoga, Calentamiento, Danza',
    recommended: 'Antes de realizar estos movimientos, siempre tienes que realizar un calentamiento previo, puedes iniciar con un calentamiento para tren inferior primero.<br><br>Esta es una sesión ideal para principiantes que buscan mejorar su flexibilidad.<br><br>Lograr una mejor flexibilidad es un trabajo de constancia, no hay una receta mágica por lo que te recomendamos ser paciente y trabajar estos ejercicios al menos 2 veces por semana.',
    tools: '',
    equipment: 'Tapete de Yoga',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['019', '005', '006'],
  sections: [
    {
      name: 'Aumento de Temperatura',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Tijeras',
          time: 1 * 60 + 8,
        },
        {
          name: 'Codo a rodilla',
          time: 2 * 60 + 28,
        },
        {
          name: 'Tijeras al frente',
          time: 3 * 60 + 42,
        },
        {
          name: 'Mano a talón',
          time: 4 * 60 + 36,
        },
        {
          name: 'Extensiónes posteriores',
          time: 5 * 60 + 49,
        },
      ]
    },
    {
      name: 'Movimiento Articular',
      time: 7 * 60 + 22,
      sub: [
        {
          name: 'Introducción',
          time: 7 * 60 + 22,
        },
        {
          name: 'Extensión anterior de pierna',
          time: 7 * 60 + 39,
        },
        {
          name: 'Extensión posterior de pierna',
          time: 9 * 60 + 59,
        },
        {
          name: 'Toque de puntas',
          time: 12 * 60 + 19,
        },
        {
          name: 'Toque de puntas con flexión',
          time: 13 * 60 + 46,
        },
      ]
    },
    {
      name: 'Elasticidad',
      time: 15 * 60 + 0,
      sub: [
        {
          name: 'Introducción',
          time: 15 * 60 + 0,
        },
        {
          name: 'Flexiones y extensiones',
          time: 15 * 60 + 25,
        },
        {
          name: 'Flexión de rodilla',
          time: 17 * 60 + 27,
        },
        {
          name: 'Extensiones isométricas',
          time: 18 * 60 + 31,
        },
        {
          name: 'Extensiónes en gladiador',
          time: 21 * 60 + 29,
        },
        {
          name: 'Isométricos en posición A',
          time: 25 * 60 + 0,
        },
        {
          name: 'Extensión de cuadriceps',
          time: 29 * 60 + 3,
        },
        {
          name: 'Extensión en medio split',
          time: 32 * 60 + 41,
        },
        {
          name: 'Extensiones con pierna flexionada',
          time: 37 * 60 + 52,
        },
        {
          name: 'Preparación para Split',
          time: 39 * 60 + 9,
        },
      ]
    },
  ],
},
{
  id: "022",
  streams: {
    _360: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/022/Front/HLS/Session+022+-+Front_360.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/022/Back/HLS/Session+022+-+Back_360.m3u8',
    },
    _540: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/022/Front/HLS/Session+022+-+Front_540.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/022/Back/HLS/Session+022+-+Back_540.m3u8',
    },
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/022/Front/HLS/Session+022+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/022/Back/HLS/Session+022+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/022/Front/Thumbnails/Session+022+-+Custom-Poster.jpg',
  details: roaster[roasterMap.ekbars],
  category: categories[categoryMap.calistenia],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Rutina Full Body - Principiantes',
    description: 'Las rutinas Full Body tienen como objetivo trabajar todas las partes del cuerpo sin concentrarse en alguna en particular. Son ideales para generar más masa muscular y reducir la grasa del cuerpo.',
    relatesTo: 'Gimnasia, Yoga, Calentamiento, Danza, Flex',
    recommended: 'Continua tu progresión con esta rutina de Calistenia, ideal para principiantes o intermedios que quieran mejorar su condición física y corregir sus posturas.<br><br>Si quieres empezar a ejercitarte pero no sabes en donde empezar, este es el lugar.<br><br>Las sesiones de Calistenia están diseñadas para que las sigas de forma progresiva, por lo que te recomendamos que al menos una vez las sigas en orden.',
    tools: '',
    equipment: 'Botella de agua o similar.',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['020', '006', '008'],
  sections: [
    {
      name: 'Movimientos',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Lagartijas en pared',
          time: 1 * 60 + 12,
        },
        {
          name: 'Extensiones de cuadriceps',
          time: 1 * 60 + 36,
        },
        {
          name: 'Plancha en pared',
          time: 2 * 60 + 0,
        },
        {
          name: 'Bent rows',
          time: 2 * 60 + 42,
        },
        {
          name: 'Hip thrust',
          time: 3 * 60 + 22,
        },
      ]
    },
    {
      name: 'AMRAP - 25 minutos',
      time: 4 * 60 + 13,
      sub: [
        {
          name: 'Introducción',
          time: 4 * 60 + 13,
        },
        {
          name: 'Lagartijas - 12 reps',
          time: 4 * 60 + 50,
        },
        {
          name: 'Extensiones - 16 reps',
          time: 5 * 60 + 16,
        },
        {
          name: 'Plancha - 30 segundos',
          time: 6 * 60 + 5,
        },
        {
          name: 'Bent rows - 14 reps',
          time: 7 * 60 + 9,
        },
        {
          name: 'Hip thrust - 16 reps',
          time: 7 * 60 + 53,
        },
      ]
    },
    {
      name: 'Movimientos Aeróbicos',
      time: 28 * 60 + 41,
      sub: [
        {
          name: 'Introducción',
          time: 28 * 60 + 41,
        },
        {
          name: 'Burpees',
          time: 29 * 60 + 45,
        },
        {
          name: 'High Knees',
          time: 30 * 60 + 12,
        },
        {
          name: 'Mountain Climbers',
          time: 30 * 60 + 29,
        },
        {
          name: 'Press Jacks',
          time: 30 * 60 + 58,
        },
      ]
    },
    {
      name: 'Aeróbicos - 8 minutos',
      time: 31 * 60 + 18,
      sub: [
        {
          name: 'Introducción',
          time: 31 * 60 + 18,
        },
        {
          name: 'Burpees - 1 minuto',
          time: 31 * 60 + 29,
        },
        {
          name: 'High Knees - 1 minuto',
          time: 32 * 60 + 32,
        },
        {
          name: 'Mountain Climbers - 1 minuto',
          time: 33 * 60 + 38,
        },
        {
          name: 'Press Jacks - 1 minuto',
          time: 34 * 60 + 37,
        },
      ]
    },
  ],
},
{
  id: "023",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/023/Front/HLS/Session+023+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/023/Back/HLS/Session+023+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/023/Front/Thumbnails/Session+023+-+Custom-Poster.jpg',
  details: roaster[roasterMap.ekbars],
  category: categories[categoryMap.calistenia],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Full Body II',
    description: 'La adaptación neuro-muscular te permitirá mejorar la coordinación de los músculos involucrados en cada movimiento. Las rutinas Full Body tienen como objetivo trabajar todas las partes del cuerpo sin concentrarse en alguna en particular. Son ideales para generar más masa muscular y reducir la grasa del cuerpo.',
    relatesTo: 'Gimnasia, Yoga, Calentamiento, Danza, Flex',
    recommended: 'Continua tu progresión con esta rutina de Calistenia, ideal para principiantes o intermedios que quieran mejorar su condición física y corregir sus posturas.<br><br>Si quieres empezar a ejercitarte pero no sabes en donde empezar, este es el lugar.<br><br>Las sesiones de Calistenia están diseñadas para que las sigas de forma progresiva, por lo que te recomendamos que al menos una vez las sigas en orden.',
    tools: '',
    equipment: 'Botella de agua o similar',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['020', '006', '019'],
  sections: [
    {
      name: 'Movimientos',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Remos con peso',
          time: 56,
        },
        {
          name: 'Frog Pumps',
          time: 1 * 60 + 26,
        },
        {
          name: 'Plancha apoyando codos',
          time: 1 * 60 + 59,
        },
        {
          name: 'Push ups en desnivel',
          time: 2 * 60 + 0,
        },
        {
          name: 'Squat en isométrico',
          time: 2 * 60 + 37,
        },
      ]
    },
    {
      name: 'Remos con peso',
      time: 3 * 60 + 8,
      sub: [
        {
          name: 'Introducción',
          time: 3 * 60 + 8,
        },
        {
          name: '14 reps x 5 series',
          time: 3 * 60 + 12,
        },
      ]
    },
    {
      name: 'Frog Pumps',
      time: 6 * 60 + 29,
      sub: [
        {
          name: 'Introducción',
          time: 6 * 60 + 29,
        },
        {
          name: '16 reps x 5 series',
          time: 7 * 60 + 3,
        },
      ]
    },
    {
      name: 'Plancha apoyando codos',
      time: 11 * 60 + 0,
      sub: [
        {
          name: 'Introducción',
          time: 11 * 60 + 0,
        },
        {
          name: '30 segundos x 5 series',
          time: 11 * 60 + 20,
        },
      ]
    },
    {
      name: 'Push ups en desnivel',
      time: 16 * 60 + 23,
      sub: [
        {
          name: 'Introducción',
          time: 16 * 60 + 23,
        },
        {
          name: '12 reps x 5 series',
          time: 16 * 60 + 55,
        },
      ]
    },
    {
      name: 'Squat en isométrico',
      time: 19 * 60 + 42,
      sub: [
        {
          name: 'Introducción',
          time: 19 * 60 + 42,
        },
        {
          name: '30 segundos x 5 series',
          time: 20 * 60 + 29,
        },
      ]
    },
    {
      name: 'Movimientos',
      time: 24 * 60 + 19,
      sub: [
        {
          name: 'Introducción',
          time: 24 * 60 + 19,
        },
        {
          name: 'Jumping Jacks',
          time: 24 * 60 + 41,
        },
        {
          name: 'Mountain Climbers',
          time: 25 * 60 + 15,
        },
        {
          name: 'Jugglers',
          time: 26 * 60 + 8,
        },
        {
          name: 'High Knees',
          time: 26 * 60 + 36,
        },
      ]
    },
    {
      name: 'Rutina Aeróbica x 8 minutos',
      time: 26 * 60 + 54,
      sub: [
        {
          name: 'Introducción',
          time: 26 * 60 + 54,
        },
        {
          name: 'Jumping Jacks x 30 reps',
          time: 27 * 60 + 5,
        },
        {
          name: 'Mountain Climbers x 40 reps',
          time: 27 * 60 + 46,
        },
        {
          name: 'Jugglers x 20 reps',
          time: 28 * 60 + 25,
        },
        {
          name: 'High Knees x 40 reps',
          time: 29 * 60 + 23,
        },
      ]
    },
  ],
},
{
  id: "024",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/024/Front/HLS/Session+024+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/024/Back/HLS/Session+024+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/024/Front/Thumbnails/Session+024+-+Custom-Poster.jpg',
  details: roaster[roasterMap["angie-campirano"]],
  category: categories[categoryMap.flex],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Flexibilidad para el tren superior',
    description: 'Si tu objetivo es lograr un arco, empieza por mejorar tu flexibilidad en tren superior.<br>Daremos una introducción a los movimientos para elongar músculos y articulaciones de la espalda y hombros.',
    relatesTo: 'Gimnasia, Yoga, Calentamiento, Danza, Calistenia',
    recommended: 'Antes de realizar estos movimientos, siempre tienes que realizar un calentamiento previo, puedes iniciar con un calentamiento para tren inferior primero.<br><br>Esta es una sesión ideal para principiantes que buscan mejorar su flexibilidad.<br><br>Lograr una mejor flexibilidad es un trabajo de constancia, no hay una receta mágica por lo que te recomendamos ser paciente y trabajar estos ejercicios al menos 2 veces por semana.',
    tools: '',
    equipment: 'Tapete de Yoga, botella de agua o similar',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['019', '009', '021'],
  sections: [
    {
      name: 'Aumento de Temperatura',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Mountain Climbers',
          time: 1 * 60 + 20,
        },
        {
          name: 'Toques de deltoides con trote',
          time: 2 * 60 + 42,
        },
        {
          name: 'Recorridos laterales',
          time: 3 * 60 + 43,
        },
        {
          name: 'Toques anteriores con trote',
          time: 4 * 60 + 50,
        },
        {
          name: 'Diagonal Chops con peso',
          time: 5 * 60 + 55,
        },
      ]
    },
    {
      name: 'Movimiento Articular',
      time: 6 * 60 + 59,
      sub: [
        {
          name: 'Introducción',
          time: 6 * 60 + 59,
        },
        {
          name: 'Rotación de cadera',
          time: 7 * 60 + 20,
        },
        {
          name: 'Círculos de hombros',
          time: 9 * 60 + 38,
        },
        {
          name: 'Toque de puntas con rotación',
          time: 11 * 60 + 4,
        },
        {
          name: 'Flexo-extensión de cadera',
          time: 12 * 60 + 47,
        },
        {
          name: 'Extensión de brazos',
          time: 14 * 60 + 11,
        },
      ]
    },
    {
      name: 'Elasticidad',
      time: 15 * 60 + 55,
      sub: [
        {
          name: 'Introducción',
          time: 15 * 60 + 55,
        },
        {
          name: 'Protracción y retracción de espalda y pelvis',
          time: 16 * 60 + 29,
        },
        {
          name: 'Extensión de espalda',
          time: 18 * 60 + 4,
        },
        {
          name: 'Extension de piernas',
          time: 19 * 60 + 49,
        },
        {
          name: 'Extensión de espalda y piernas',
          time: 21 * 60 + 19,
        },
        {
          name: "M's con brazos",
          time: 22 * 60 + 52,
        },
      ]
    },
    {
      name: 'Estiramiento',
      time: 25 * 60 + 0,
      sub: [
        {
          name: 'Introducción',
          time: 25 * 60 + 0,
        },
        {
          name: 'Extensión de pecho',
          time: 25 * 60 + 27,
        },
        {
          name: 'Extensión de espalda',
          time: 28 * 60 + 22,
        },
        {
          name: 'Extensión en cuna',
          time: 31 * 60 + 12,
        },
        {
          name: 'Extensión en Half Bridge',
          time: 34 * 60 + 1,
        },
        {
          name: 'Cobra',
          time: 37 * 60 + 36,
        },
        {
          name: "Child's Pose",
          time: 39 * 60 + 27,
        },
      ]
    },
  ],
},
{
  id: "025",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/025/Front/HLS/Session+025+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/025/Back/HLS/Session+025+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/025/Front/Thumbnails/Session+025+-+Custom-Poster.jpg',
  details: roaster[roasterMap['alma-y-cesar']],
  category: categories[categoryMap.ritmoslatinos],
  classType: {
    slug: ['movement']
  },
  videoInfo: {
    about: 'Planchas, sincopados, lúcela y ocho en esta sesión de Danzón',
    description: 'En esta sesión aprenderemos más pasos de Danzón para que puedas bailar una canción completa sin repetir los pasos.',
    relatesTo: 'Ritmos Latinos, Danza, Baile Fitness',
    recommended: 'El baile es un excelente ejercicio que ayuda a fortalecer el corazón, pero además poco a poco mejora tu memoria, flexibilidad y resistencia.',
    tools: 'Utiliza la cámara trasera para no perder detalle en los pasos.<br>Con el modo espejo, te será más fácil seguir las indicaciones para manos y piés.',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['002', '003', '006'],
  sections: [
    {
      name: 'Introducción',
      time: 0,
      sub: [
        {
          name: 'Demostración',
          time: 0,
        },
        {
          name: 'Introducción',
          time: 36,
        }
      ]
    },
    {
      name: 'Planchas',
      time: 1 * 60 + 3,
      sub: [
        {
          name: 'Paso con cuenta',
          time: 1 * 60 + 3,
        },
        {
          name: 'Paso de dama',
          time: 1 * 60 + 46,
        },
        {
          name: 'Paso de hombre',
          time: 2 * 60 + 52,
        },
        {
          name: 'De frente a la pareja',
          time: 3 * 60 + 40,
        },
        {
          name: 'Posición cerrada',
          time: 4 * 60 + 1,
        },
        {
          name: 'Con música',
          time: 4 * 60 + 39,
        },
      ]
    },
    {
      name: 'Sincopados',
      time: 5 * 60 + 8,
      sub: [
        {
          name: 'Con cuenta',
          time: 5 * 60 + 8,
        },
        {
          name: 'Paso de dama',
          time: 5 * 60 + 26,
        },
        {
          name: 'Paso de hombre',
          time: 6 * 60 + 12,
        },
        {
          name: 'De frente a la pareja',
          time: 6 * 60 + 58,
        },
        {
          name: 'Posición cerrada',
          time: 7 * 60 + 23,
        },
        {
          name: 'Con música',
          time: 8 * 60 + 11,
        },
      ]
    },
    {
      name: 'Lúcela',
      time: 8 * 60 + 47,
      sub: [
        {
          name: 'Con cuenta',
          time: 8 * 60 + 47,
        },
        {
          name: 'Paso de dama',
          time: 9 * 60 + 12,
        },
        {
          name: 'Paso de hombre',
          time: 10 * 60 + 19,
        },
        {
          name: 'De frente a la pareja',
          time: 11 * 60 + 7,
        },
        {
          name: 'Posición cerrada',
          time: 11 * 60 + 32,
        },
        {
          name: 'Con música',
          time: 11 * 60 + 53,
        },
      ]
    },
    {
      name: 'Ocho',
      time: 12 * 60 + 30,
      sub: [
        {
          name: 'Introducción',
          time: 12 * 60 + 30,
        },
        {
          name: 'Con cuenta',
          time: 12 * 60 + 54,
        },
        {
          name: 'Paso de dama',
          time: 13 * 60 + 17,
        },
        {
          name: 'Paso de hombre',
          time: 14 * 60 + 0,
        },
        {
          name: 'De frente a la pareja',
          time: 14 * 60 + 40,
        },
        {
          name: 'Posición cerrada',
          time: 15 * 60 + 7,
        },
        {
          name: 'Con música',
          time: 15 * 60 + 42,
        },
      ]
    },
    {
      name: 'Ensamble',
      time: 16 * 60 + 36,
      sub: [
        {
          name: 'Introducción',
          time: 16 * 60 + 36,
        },
        {
          name: 'Con cuenta',
          time: 16 * 60 + 53,
        },
        {
          name: 'Con música',
          time: 18 * 60 + 0,
        },
      ]
    },
  ],
},
{
  id: "026",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/026/Front/HLS/Session+026+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/026/Back/HLS/Session+026+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/026/Front/Thumbnails/Session+026+-+Custom-Poster.jpg',
  details: roaster[roasterMap['alma-y-cesar']],
  category: categories[categoryMap.ritmoslatinos],
  classType: {
    slug: ['combo']
  },
  videoInfo: {
    about: 'Culminamos con nuestro curso básico de Danzón.',
    description: 'En esta última sesión de este primer curso básico agregamos cuatro nuevos pasos y aplicamos todos los pasos anteriores en una canción. ¡No te lo pierdas!',
    relatesTo: 'Ritmos Latinos, Danza, Baile Fitness',
    recommended: 'El baile es un excelente ejercicio que ayuda a fortalecer el corazón, pero además poco a poco mejora tu memoria, flexibilidad y resistencia.',
    tools: 'Utiliza la cámara trasera para no perder detalle en los pasos.<br>Con el modo espejo, te será más fácil seguir las indicaciones para manos y piés.',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['002', '003', '025'],
  sections: [
    {
      name: 'Introducción',
      time: 0,
      sub: [
        {
          name: 'Demostración',
          time: 0,
        },
        {
          name: 'Introducción',
          time: 36,
        }
      ]
    },
    {
      name: 'Triángulo',
      time: 0 * 60 + 51,
      sub: [
        {
          name: 'Introducción',
          time: 0 * 60 + 51,
        },
        {
          name: 'Agarre',
          time: 1 * 60 + 3,
        },
        {
          name: 'Pisada de dama',
          time: 1 * 60 + 31,
        },
        {
          name: 'Cuenta de dama',
          time: 2 * 60 + 10,
        },
        {
          name: 'Estilo de brazos',
          time: 2 * 60 + 24,
        },
        {
          name: 'Pisada de hombre',
          time: 2 * 60 + 43,
        },
        {
          name: 'Cuenta de hombre',
          time: 3 * 60 + 32,
        },
        {
          name: 'Estilo de brazos',
          time: 3 * 60 + 45,
        },
        {
          name: 'De frente a la pareja',
          time: 4 * 60 + 3,
        },
        {
          name: 'Con agarre',
          time: 4 * 60 + 24,
        },
        {
          name: 'Con música',
          time: 4 * 60 + 56,
        },
      ]
    },
    {
      name: 'Tu y Yo',
      time: 5 * 60 + 32,
      sub: [
        {
          name: 'Introducción',
          time: 5 * 60 + 32,
        },
        {
          name: 'Cuenta de frente',
          time: 5 * 60 + 46,
        },
        {
          name: 'Paso de dama',
          time: 6 * 60 + 3,
        },
        {
          name: 'Paso de hombre',
          time: 6 * 60 + 56,
        },
        {
          name: 'De frente a la pareja',
          time: 7 * 60 + 38,
        },
        {
          name: 'Posición cerrada',
          time: 8 * 60 + 3,
        },
        {
          name: 'Con música',
          time: 8 * 60 + 24,
        },
      ]
    },
    {
      name: 'Viborita',
      time: 9 * 60 + 4,
      sub: [
        {
          name: 'Introducción',
          time: 9 * 60 + 4,
        },
        {
          name: 'Cuenta de frente',
          time: 9 * 60 + 38,
        },
        {
          name: 'Paso de dama',
          time: 10 * 60 + 7,
        },
        {
          name: 'Paso de hombre',
          time: 11 * 60 + 17,
        },
        {
          name: 'De frente a la pareja',
          time: 12 * 60 + 29,
        },
        {
          name: 'Posición cerrada',
          time: 12 * 60 + 52,
        },
        {
          name: 'Con música',
          time: 13 * 60 + 19,
        },
      ]
    },
    {
      name: 'Paseo del hombre',
      time: 14 * 60 + 9,
      sub: [
        {
          name: 'Introducción',
          time: 14 * 60 + 9,
        },
        {
          name: 'Cuenta de frente',
          time: 14 * 60 + 54,
        },
        {
          name: 'Paso de dama',
          time: 15 * 60 + 16,
        },
        {
          name: 'Paso de hombre',
          time: 15 * 60 + 54,
        },
        {
          name: 'De frente a la pareja',
          time: 16 * 60 + 33,
        },
        {
          name: 'Posición cerrada',
          time: 16 * 60 + 54,
        },
        {
          name: 'Con música',
          time: 17 * 60 + 14,
        },
      ]
    },
    {
      name: 'Ensamble',
      time: 17 * 60 + 46,
      sub: [
        {
          name: 'Introducción',
          time: 17 * 60 + 46,
        },
        {
          name: 'Con cuenta',
          time: 18 * 60 + 1,
        },
        {
          name: 'Con música',
          time: 18 * 60 + 47,
        },
      ]
    },
    {
      name: 'Resumen pasos básicos',
      time: 20 * 60 + 24,
      sub: [
        {
          name: 'Introducción',
          time: 20 * 60 + 24,
        },
        {
          name: 'Descanso',
          time: 20 * 60 + 45,
        },
        {
          name: 'Paso Cuadro',
          time: 21 * 60 + 3,
        },
        {
          name: 'Cuadro con salida',
          time: 21 * 60 + 10,
        },
        {
          name: 'Cuadro girado',
          time: 21 * 60 + 17,
        },
        {
          name: 'Arriba',
          time: 22 * 60 + 0,
        },
        {
          name: 'Abajo',
          time: 22 * 60 + 7,
        },
        {
          name: 'Vaivén',
          time: 22 * 60 + 14,
        },
        {
          name: 'Paso "V"',
          time: 22 * 60 + 21,
        },
        {
          name: 'Planchas',
          time: 22 * 60 + 28,
        },
        {
          name: 'Sincopados',
          time: 22 * 60 + 35,
        },
        {
          name: 'Lúcela',
          time: 22 * 60 + 42,
        },
        {
          name: 'Ochos',
          time: 22 * 60 + 50,
        },
        {
          name: 'Triángulo',
          time: 23 * 60 + 35,
        },
        {
          name: 'Tú y Yo',
          time: 23 * 60 + 42,
        },
        {
          name: 'Viborita',
          time: 23 * 60 + 49,
        },
        {
          name: 'Paseo del hombre',
          time: 24 * 60 + 2,
        },
      ]
    },
  ],
},
{
  id: "027",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/027/Front/HLS/Session+027+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/027/Back/HLS/Session+027+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/027/Front/Thumbnails/Session+027+-+Custom-Poster.jpg',
  details: roaster[roasterMap["cesar-zamudio"]],
  category: categories[categoryMap.bailefitness],
  classType: {
    slug: ['combo']
  },
  videoInfo: {
    about: 'Ejercítate al ritmo de la Cúmbia, el Merengue y un poco de Reggaetón.',
    description: 'El baile fitness no solo te permitirá mejorar tu condición física, además mejorará tu coordinación y mejorará la forma en la que sigues el ritmo de la música.',
    relatesTo: 'Ritmos Latinos, Danza, Calistenia',
    recommended: 'Acompañanos al ritmo de la música y ¡no pares!. <br>Actívate con esta rutina de ejercicios y al mismo tiempo mejora tu coordinación, agilidad, ritmo y condición física.',
    tools: 'Realiza la rutina completa con la cámara frontal, cuando repitas la rutina hazlo con la cámara trasera para que cada vez tu postura sea mejor.',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['020', '006', '002'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Pierna',
          time: 42,
        },
        {
          name: 'Brazos',
          time: 2 * 60 + 43,
        },
        {
          name: 'Estiramiento',
          time: 3 * 60 + 25,
        },
      ]
    },
    {
      name: 'Cumbia',
      time: 4 * 60 + 55,
      sub: [
        {
          name: 'Introducción',
          time: 4 * 60 + 55,
        },
        {
          name: 'Doble',
          time: 5 * 60 + 17,
        },
        {
          name: 'Colombiano',
          time: 5 * 60 + 42,
        },
        {
          name: 'Mambo',
          time: 6 * 60 + 28,
        },
        {
          name: 'Marcha',
          time: 7 * 60 + 6,
        },
        {
          name: 'Rutina Cardiovascular',
          time: 7 * 60 + 57,
        },
      ]
    },
    {
      name: 'Merengue',
      time: 12 * 60 + 47,
      sub: [
        {
          name: 'Introducción',
          time: 12 * 60 + 47,
        },
        {
          name: 'Marcha',
          time: 13 * 60 + 0,
        },
        {
          name: 'Laterales',
          time: 13 * 60 + 14,
        },
        {
          name: 'Doble',
          time: 13 * 60 + 36,
        },
        {
          name: 'Paso "V"',
          time: 13 * 60 + 54,
        },
        {
          name: 'Elevaciones',
          time: 14 * 60 + 13,
        },
        {
          name: 'Contracciones',
          time: 14 * 60 + 34,
        },
        {
          name: 'Balanceo con giro',
          time: 14 * 60 + 54,
        },
        {
          name: 'Rutina Cardiovascular',
          time: 15 * 60 + 15,
        },
      ]
    },
    {
      name: 'Reggaeton',
      time: 19 * 60 + 54,
      sub: [
        {
          name: 'Introducción',
          time: 19 * 60 + 54,
        },
        {
          name: 'Descanso',
          time: 20 * 60 + 11,
        },
        {
          name: 'Urbano y Sincopado',
          time: 20 * 60 + 35,
        },
        {
          name: 'Doble más cadereo',
          time: 21 * 60 + 12,
        },
        {
          name: '3 Estocadas más giro',
          time: 21 * 60 + 54,
        },
        {
          name: 'Sencillo - Doble y Contracciones',
          time: 22 * 60 + 39,
        },
        {
          name: 'Rutina Cardiovascular',
          time: 23 * 60 + 15,
        },
      ]
    },
    {
      name: 'Estiramiento',
      time: 28 * 60 + 20,
      sub: [
        {
          name: 'Introducción',
          time: 28 * 60 + 20,
        },
        {
          name: 'Respiración',
          time: 28 * 60 + 27,
        },
        {
          name: 'Tren superior',
          time: 28 * 60 + 43,
        },
        {
          name: 'Tren inferior',
          time: 30 * 60 + 4,
        },
      ]
    },
  ],
},
{
  id: "028",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/028/Front/HLS/Session+028+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/028/Back/HLS/Session+028+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/028/Front/Thumbnails/Session+028+-+Custom-Poster.jpg',
  details: roaster[roasterMap.ekbars],
  category: categories[categoryMap.calistenia],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Full Body, cinco ejercicios, cuatro series cada uno.',
    description: 'Continuamos con las progresiones para que inicies tu camino en la Calistenia acompañado de los mejores coaches de EK Bars.<br>Recuerda que antes de iniciar cada rutina tienes que realizar un calentamiento previo, para esto tenemos las diferentes sesiones que abordan calentamientos generales o específicos dependiendo la zona que vas a trabajar.',
    relatesTo: 'Baile Fitness, Gimnasia, Danza, Flex',
    recommended: '',
    tools: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['020', '023', '027'],
  sections: [
    {
      name: 'Push Ups x 4 series',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Push ups con rodillas x 12 reps.',
          time: 1 * 60 + 15,
        },
      ]
    },
    {
      name: 'Sentadilla Isométrica x 4 series',
      time: 7 * 60 + 19,
      sub: [
        {
          name: 'Introducción',
          time: 7 * 60 + 19,
        },
        {
          name: 'Sentadilla Isométrica x 30 segs.',
          time: 7 * 60 + 39,
        },
      ]
    },
    {
      name: 'Plancha x 4 series',
      time: 12 * 60 + 5,
      sub: [
        {
          name: 'Introducción',
          time: 12 * 60 + 5,
        },
        {
          name: 'Plancha x 30 segs.',
          time: 12 * 60 + 41,
        },
      ]
    },
    {
      name: 'Remos x 4 series',
      time: 18 * 60 + 38,
      sub: [
        {
          name: 'Introducción',
          time: 18 * 60 + 38,
        },
        {
          name: 'Remos x 12 reps.',
          time: 18 * 60 + 47,
        },
      ]
    },
    {
      name: 'Single Leg Hip Thrust x 4 series',
      time: 22 * 60 + 45,
      sub: [
        {
          name: 'Introducción',
          time: 22 * 60 + 45,
        },
        {
          name: 'Single Leg Hip Thrust x 12 reps.',
          time: 23 * 60 + 2,
        },
        {
          name: 'Recomendaciones',
          time: 29 * 60 + 34,
        },
      ]
    },
  ],
},
{
  id: "029",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/029/Front/HLS/Session+029+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/029/Back/HLS/Session+029+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/029/Front/Thumbnails/Session+029+-+Custom-Poster.jpg',
  details: roaster[roasterMap["javier-basilio"]],
  category: categories[categoryMap.defensapersonal],
  classType: {
    slug: ['training', 'free']
  },
  videoInfo: {
    about: '¿Por qué aprender defensa personal?',
    description: 'En esta sesión hablamos sobre las acciones que debes tomar en cuenta para hacerte cargo de tu propia seguridad. <br>La violencia genera más violencia y aquí te enseñaremos técnicas para evitar las agresiones en general.',
    relatesTo: 'Yoga, Calistenia, Flex',
    recommended: 'En defensa personal lo más importante es conservar la vida, para eso nos enfocamos en la prevención de situaciones de riesgo y cómo actuar cuando no pudimos evitar una.<br>Aprende a cómo prevenir agresiones y sobre la diferencia entre Deportes de contacto y la defensa personal.',
    tools: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  isFree: true,
  related: ['005', '020', '019'],
  sections: [
    {
      name: 'Introducción',
      time: 0,
      sub: [
        {
          name: '¿Por qué aprender defensa personal?',
          time: 0,
        },
        {
          name: 'Prevención',
          time: 1 * 60 + 53,
        },
        {
          name: 'Deportes vs Situaciones de riesgo',
          time: 2 * 60 + 54,
        },
      ]
    },
    {
      name: 'Diferencias entre Defensa Personal y Deporte',
      time: 7 * 60 + 18,
      sub: [
        {
          name: 'Introducción',
          time: 7 * 60 + 18,
        },
        {
          name: 'Ambientes controlados',
          time: 8 * 60 + 12,
        },
        {
          name: 'Planeación',
          time: 9 * 60 + 10,
        },
        {
          name: 'Terreno',
          time: 10 * 60 + 4,
        },
        {
          name: 'Manejo táctico de conflicto',
          time: 11 * 60 + 12,
        },
      ]
    },
    {
      name: '¿Cómo prevenir una agresión?',
      time: 13 * 60 + 18,
      sub: [
        {
          name: 'Observa tu entorno',
          time: 13 * 60 + 18,
        },
        {
          name: 'Evita llamar la atención',
          time: 15 * 60 + 20,
        },
        {
          name: 'El stress lo cambia todo',
          time: 16 * 60 + 30,
        },
        {
          name: 'Lo más importante es tu vida',
          time: 20 * 60 + 58,
        },
        {
          name: 'Conclusiones',
          time: 22 * 60 + 38,
        },
      ]
    }
  ],
},
{
  id: "030",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/030/Front/HLS/Session+030+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/030/Back/HLS/Session+030+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/030/Front/Thumbnails/Session+030+-+Custom-Poster.jpg',
  details: roaster[roasterMap.ekbars],
  category: categories[categoryMap.calistenia],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Full Body IV',
    description: 'La progresión neuro-muscular te permitirá adaptar tu cuerpo a los movimientos que utilizaremos en las rutinas.<br>Esta progresión es necesaria antes de intentar realizar rutinas de nivel intermedio, ya que lo que buscamos es realizar pocos ejercicios con posturas que se acerquen a la perfección en lugar de hacer muchas repeticiones con posturas incorrectas.<br>Recuerda que antes de iniciar cada rutina tienes que realizar un calentamiento previo, para esto tenemos las diferentes sesiones que abordan calentamientos generales o específicos dependiendo la zona que vas a trabajar.',
    relatesTo: 'Baile Fitness, Gimnasia, Danza, Flex',
    recommended: '',
    tools: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['020', '028', '027'],
  sections: [
    {
      name: 'Movimientos',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Push ups con rodillas',
          time: 1 * 60 + 2,
        },
        {
          name: 'Jugglers',
          time: 1 * 60 + 22,
        },
        {
          name: 'Hip thrust con banda',
          time: 1 * 60 + 34,
        },
        {
          name: 'Medios burpees',
          time: 2 * 60 + 19,
        },
        {
          name: 'Australian pull-ups',
          time: 2 * 60 + 40,
        },
        {
          name: 'Mountain climbers',
          time: 3 * 60 + 24,
        },
        {
          name: 'Sentadillas en silla',
          time: 3 * 60 + 42,
        },
        {
          name: 'Burpees',
          time: 4 * 60 + 11,
        },
        {
          name: 'Plancha con rodillas',
          time: 4 * 60 + 29,
        },
      ]
    },
    {
      name: 'AMRAP x 30 mins',
      time: 4 * 60 + 58,
      sub: [
        {
          name: 'Introducción',
          time: 4 * 60 + 58,
        },
        {
          name: 'Push ups con rodillas x 10 reps',
          time: 5 * 60 + 8,
        },
        {
          name: 'Jugglers x 20 reps',
          time: 5 * 60 + 26,
        },
        {
          name: 'Hip thrust con banda x 16 reps',
          time: 6 * 60 + 10,
        },
        {
          name: 'Medios burpees x 20 reps',
          time: 6 * 60 + 53,
        },
        {
          name: 'Australian pull-ups x 12 reps',
          time: 7 * 60 + 28,
        },
        {
          name: 'Mountain climbers x 40 reps',
          time: 8 * 60 + 13,
        },
        {
          name: 'Sentadillas en silla x 16 reps',
          time: 8 * 60 + 51,
        },
        {
          name: 'Burpees x 20 reps',
          time: 9 * 60 + 32,
        },
        {
          name: 'Plancha con rodillas x 30 segs',
          time: 10 * 60 + 27,
        },
      ]
    },
  ],
},
{
  id: "031",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/031/Front/HLS/Session+031+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/031/Back/HLS/Session+031+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/031/Front/Thumbnails/Session+031+-+Custom-Poster.jpg',
  details: roaster[roasterMap["angie-campirano"]],
  category: categories[categoryMap.flex],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Elongación y flexibilidad del tren superior',
    description: 'Si tu objetivo es lograr un arco, empieza por mejorar tu flexibilidad en tren superior.<br>En esta sesión continuamos con la progresión mejorar la flexibilidad de músculus y articulaciones.',
    relatesTo: 'Gimnasia, Yoga, Calentamiento, Danza, Calistenia',
    recommended: 'Antes de realizar estos movimientos, siempre tienes que realizar un calentamiento previo, puedes iniciar con un calentamiento para tren inferior primero.<br><br>Esta es una sesión ideal para principiantes que buscan mejorar su flexibilidad.<br><br>Lograr una mejor flexibilidad es un trabajo de constancia, no hay una receta mágica por lo que te recomendamos ser paciente y trabajar estos ejercicios al menos 2 veces por semana.',
    tools: '',
    equipment: 'Tapete de Yoga, liga de resistencia o pashmina o bufanda o sudadera o similar',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['021', '015', '024'],
  sections: [
    {
      name: 'Aumento de Temperatura',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Rotación de cadera en plancha',
          time: 1 * 60 + 24,
        },
        {
          name: 'Mummy Kicks',
          time: 2 * 60 + 36,
        },
        {
          name: 'Jumping jacks',
          time: 3 * 60 + 39,
        },
        {
          name: 'Abdomen',
          time: 4 * 60 + 54,
        },
        {
          name: 'Rotaciones de cadera',
          time: 6 * 60 + 9,
        },
      ]
    },
    {
      name: 'Movimiento Articular',
      time: 7 * 60 + 23,
      sub: [
        {
          name: 'Introducción',
          time: 7 * 60 + 23,
        },
        {
          name: 'Toque de punta alternado',
          time: 7 * 60 + 55,
        },
        {
          name: 'Extensiones de pecho',
          time: 9 * 60 + 20,
        },
        {
          name: 'Toque de punta y rotación',
          time: 10 * 60 + 29,
        },
        {
          name: 'Toque de puntas en "A"',
          time: 11 * 60 + 35,
        },
        {
          name: 'Torsión de hombros',
          time: 12 * 60 + 47,
        },
        {
          name: 'Muñecas',
          time: 14 * 60 + 0,
        },
        {
          name: 'Toque de deltoines',
          time: 15 * 60 + 6,
        },
      ]
    },
    {
      name: 'Elasticidad',
      time: 16 * 60 + 21,
      sub: [
        {
          name: 'Introducción',
          time: 16 * 60 + 21,
        },
        {
          name: 'Protracción y retracción con rotación',
          time: 16 * 60 + 37,
        },
        {
          name: 'Extensión lumbar',
          time: 19 * 60 + 22,
        },
        {
          name: 'Lagartijas en cobra',
          time: 20 * 60 + 55,
        },
        {
          name: 'Extensiones de pecho con liga',
          time: 24 * 60 + 20,
        },
        {
          name: "Extension de piernas",
          time: 26 * 60 + 58,
        },
        {
          name: "Extensión de lumbar y piernas",
          time: 28 * 60 + 43,
        },
      ]
    },
    {
      name: 'Estiramiento',
      time: 30 * 60 + 9,
      sub: [
        {
          name: 'Introducción',
          time: 30 * 60 + 9,
        },
        {
          name: 'Extensión lumbar',
          time: 31 * 60 + 2,
        },
        {
          name: "Child's pose",
          time: 33 * 60 + 29,
        },
        {
          name: 'Alargamiento de pecho',
          time: 34 * 60 + 7,
        },
        {
          name: 'Canasta con agarre interior',
          time: 36 * 60 + 42,
        },
        {
          name: 'Medio puente',
          time: 39 * 60 + 14,
        },
        {
          name: "Plegado",
          time: 41 * 60 + 51,
        },
      ]
    },
  ],
},
{
  id: "032",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/032/Front/HLS/Session+032+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/032/Back/HLS/Session+032+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/032/Front/Thumbnails/Session+032+-+Custom-Poster.jpg',
  details: roaster[roasterMap.ekbars],
  category: categories[categoryMap.calistenia],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Full Body V',
    description: 'La progresión neuro-muscular te permitirá adaptar tu cuerpo a los movimientos que utilizaremos en las rutinas.<br>Esta progresión es necesaria antes de intentar realizar rutinas de nivel intermedio, ya que lo que buscamos es realizar pocos ejercicios con posturas que se acerquen a la perfección en lugar de hacer muchas repeticiones con posturas incorrectas.<br>Recuerda que antes de iniciar cada rutina tienes que realizar un calentamiento previo, para esto tenemos las diferentes sesiones que abordan calentamientos generales o específicos dependiendo la zona que vas a trabajar.',
    relatesTo: 'Baile Fitness, Gimnasia, Danza, Flex',
    recommended: '',
    tools: '',
    equipment: 'Liga',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['020', '030', '008'],
  sections: [
    {
      name: 'Movimientos',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Push ups abiertas',
          time: 1 * 60 + 3,
        },
        {
          name: 'Push ups neutras',
          time: 1 * 60 + 20,
        },
        {
          name: 'Push ups cerradas',
          time: 1 * 60 + 34,
        },
        {
          name: 'Sentadilla asistida',
          time: 1 * 60 + 50,
        },
        {
          name: 'Plancha en rodillas',
          time: 2 * 60 + 16,
        },
        {
          name: 'Australian pull ups abiertas',
          time: 2 * 60 + 38,
        },
        {
          name: 'Australian pull ups neutras',
          time: 2 * 60 + 57,
        },
        {
          name: 'Australian pull ups cerradas',
          time: 3 * 60 + 1,
        },
        {
          name: 'Hip thrust con liga',
          time: 3 * 60 + 13,
        },
      ]
    },
    {
      name: 'Cuatro Rounds en menos de 30 mins.',
      time: 3 * 60 + 45,
      sub: [
        {
          name: 'Introducción',
          time: 3 * 60 + 45,
        },
        {
          name: 'Combinación de push ups x 12',
          time: 3 * 60 + 53,
        },
        {
          name: 'Sentadilla asistida x 14',
          time: 4 * 60 + 39,
        },
        {
          name: 'Plancha en rodillas x 30 segs.',
          time: 5 * 60 + 40,
        },
        {
          name: 'Combinación de australian pull ups',
          time: 6 * 60 + 29,
        },
        {
          name: 'Hip thrust con liga x 10',
          time: 7 * 60 + 19,
        },
      ]
    },
  ],
},
{
  id: "033",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/033/Front/HLS/Session+033+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/033/Back/HLS/Session+033+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/033/Front/Thumbnails/Session+033+-+Custom-Poster.jpg',
  details: roaster[roasterMap["javier-basilio"]],
  category: categories[categoryMap.defensapersonal],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Postura básica ante una agresión',
    description: 'Tenemos que aprender a evitar las confrontaciones mediante la comunicación, pero si ya no hay más opciones en esta sesión te enseñamos una postura básica que te ayudará a defenderte ante una agresión.<br>La violencia genera más violencia y aquí te enseñaremos técnicas para evitar las agresiones en general.',
    relatesTo: 'Yoga, Calistenia, Flex',
    recommended: 'En defensa personal lo más importante es conservar la vida, para eso nos enfocamos en la prevención de situaciones de riesgo y cómo actuar cuando no pudimos evitar una.<br>Aprende a cómo prevenir agresiones y sobre la diferencia entre Deportes de contacto y la defensa personal.',
    tools: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['029', '020', '019'],
  sections: [
    {
      name: 'Posicionamiento básico',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Proteger la cabeza',
          time: 1 * 60 + 49,
        },
        {
          name: 'Posición de manos',
          time: 6 * 60 + 29,
        },
        {
          name: 'Dirección de la vista',
          time: 7 * 60 + 40,
        },
        {
          name: 'Cuello y cervicales',
          time: 9 * 60 + 42,
        },
      ]
    },
    {
      name: 'Protección del core',
      time: 13 * 60 + 53,
      sub: [
        {
          name: 'Introducción',
          time: 13 * 60 + 53,
        },
        {
          name: 'Codos',
          time: 14 * 60 + 22,
        },
        {
          name: 'Abdomen',
          time: 15 * 60 + 54,
        },
        {
          name: 'Parado correcto',
          time: 17 * 60 + 43,
        },
      ]
    },
    {
      name: 'Posición de sumisión',
      time: 20 * 60 + 58,
      sub: [
        {
          name: 'Escalada de violencia',
          time: 20 * 60 + 58,
        },
        {
          name: 'Importancia de la comunicación',
          time: 24 * 60 + 43,
        },
        {
          name: 'Recomendaciones',
          time: 16 * 60 + 30,
        },
      ]
    }
  ],
},
{
  id: "034",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/034/Front/HLS/Session+034+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/034/Back/HLS/Session+034+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/034/Front/Thumbnails/Session+034+-+Custom-Poster.jpg',
  details: roaster[roasterMap["guillo-y-kei"]],
  category: categories[categoryMap.gimnasia],
  classType: {
    slug: ['training', 'free']
  },
  videoInfo: {
    about: 'Hand Stand I - Fortalecimiento',
    description: 'Guillo y Kei traén para tí una serie de cuatro sesiones que desglosan los ejercicios necesarios parado de manos perfecto.<br>Esta es la primera entrega.',
    relatesTo: 'Danza, Baile Fitness, Calistenia, Flex',
    recommended: 'Lograr un parado de manos requiere de un entrenamiento específico, te recomendamos practicar estos movimientos al menos de 2 a 3 veces por semana, de 30 a 45 minutos para proteger tus articulaciones.<br>Una vez que hayas fortalecido muñecas, hombros y core puedes empezar a incrementar el tiempo de entrenamiento.<br> Puedes realizar los ejercicios de calentamiento para empezar a fortalezar tu cuerpo antes de intentar el parado de manos. <br>Si ya te sientes listo para intentarlo, te recomendamos que primero te ayudes de una silla y después de la pared, te mostramos cómo en este video.<br>Mejora tu postura, equilibrio y fuerza en las manos con estos movimientos para facilitar tu parado de manos.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: 'Tapete de Yoga o colchoneta, Liga fitness',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  isFree: true,
  related: ['008', '002', '005'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Cabeza',
          time: 3 * 60 + 9,
        },
        {
          name: 'Hombros',
          time: 3 * 60 + 37,
        },
        {
          name: 'Pecho',
          time: 4 * 60 + 7,
        },
        {
          name: 'Torso',
          time: 4 * 60 + 39,
        },
        {
          name: 'Cintura',
          time: 4 * 60 + 49,
        },
        {
          name: 'Rodillas',
          time: 5 * 60 + 9,
        },
        {
          name: 'Piés',
          time: 5 * 60 + 46,
        },
        {
          name: 'Sentadillas',
          time: 6 * 60 + 10,
        },
      ]
    },
    {
      name: 'Cardio',
      time: 6 * 60 + 21,
      sub: [
        {
          name: 'Introducción',
          time: 6 * 60 + 21,
        },
        {
          name: 'Trotar',
          time: 6 * 60 + 48,
        },
        {
          name: 'Elevación de rodillas',
          time: 7 * 60 + 11,
        },
        {
          name: 'Talones hacia atrás',
          time: 7 * 60 + 37,
        },
        {
          name: 'Saltos',
          time: 8 * 60 + 9,
        },
        {
          name: 'Jumping Jacks',
          time: 8 * 60 + 28,
        },
        {
          name: 'Tijeras',
          time: 8 * 60 + 48,
        },
        {
          name: 'Saltos con giro de cadera',
          time: 9 * 60 + 3,
        },
      ]
    },
    {
      name: 'Movilidad articular',
      time: 9 * 60 + 46,
      sub: [
        {
          name: 'Arriba, abajo, piso',
          time: 9 * 60 + 46,
        },
        {
          name: 'Enfrente, en medio, atrás',
          time: 10 * 60 + 32,
        },
        {
          name: 'Toque cruzados',
          time: 10 * 60 + 55,
        },
        {
          name: 'Desplantes alternados',
          time: 11 * 60 + 23,
        },
        {
          name: 'Kozak',
          time: 11 * 60 + 37,
        },
        {
          name: 'Cobra',
          time: 12 * 60 + 13,
        },
        {
          name: 'Perrito',
          time: 12 * 60 + 53,
        },
        {
          name: 'Mariposa',
          time: 13 * 60 + 37,
        },
        {
          name: 'Plegado a una pierna',
          time: 14 * 60 + 10,
        },
        {
          name: 'Flat back',
          time: 14 * 60 + 57,
        },
        {
          name: 'Sandwich',
          time: 15 * 60 + 27,
        },
        {
          name: 'Straddle',
          time: 15 * 60 + 42,
        },
      ]
    },
    {
      name: 'Fortalecimiento articular',
      time: 16 * 60 + 46,
      sub: [
        {
          name: 'Introducción',
          time: 16 * 60 + 46,
        },
        {
          name: 'Muñecas',
          time: 17 * 60 + 2,
        },
        {
          name: 'Hombros',
          time: 21 * 60 + 1,
        },
        {
          name: 'Cuello',
          time: 23 * 60 + 5,
        },
        {
          name: 'Core',
          time: 26 * 60 + 23,
        },
        {
          name: 'Reto I',
          time: 29 * 60 + 57,
        },
      ]
    },
  ],
},
{
  id: "035",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/035/Front/HLS/Session+035+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/035/Back/HLS/Session+035+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/035/Front/Thumbnails/Session+035+-+Custom-Poster.jpg',
  details: roaster[roasterMap["guillo-y-kei"]],
  category: categories[categoryMap.gimnasia],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Hand Stand II - Tuck y Pike',
    description: 'Recuerda combinar tus sesiones de entrenamiento con descansos.<br>Te recomendamos entrenar entre dos a tres veces por semana ya que este tipo de entrenamientos son más demandantes así que necesitarás un descanso adecuado.<br>',
    relatesTo: 'Danza, Baile Fitness, Calistenia, Flex',
    recommended: 'Lograr un parado de manos requiere de un entrenamiento específico, te recomendamos practicar estos movimientos al menos de 2 a 3 veces por semana, de 30 a 45 minutos para proteger tus articulaciones.<br>Una vez que hayas fortalecido muñecas, hombros y core puedes empezar a incrementar el tiempo de entrenamiento.<br> Puedes realizar los ejercicios de calentamiento para empezar a fortalezar tu cuerpo antes de intentar el parado de manos. <br>Si ya te sientes listo para intentarlo, te recomendamos que primero te ayudes de una silla y después de la pared, te mostramos cómo en este video.<br>Mejora tu postura, equilibrio y fuerza en las manos con estos movimientos para facilitar tu parado de manos.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: 'Tapete de Yoga o colchoneta, Liga fitness, Silla o similar, Pared',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['034', '002', '005'],
  sections: [
    {
      name: 'Movimientos',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Tuck',
          time: 1 * 60 + 20,
        },
        {
          name: 'Pike',
          time: 2 * 60 + 46,
        },
      ]
    },
    {
      name: 'Fortalecimiento',
      time: 4 * 60 + 32,
      sub: [
        {
          name: 'X-Planche',
          time: 4 * 60 + 32,
        },
        {
          name: 'Inverted cast wall',
          time: 6 * 60 + 48,
        },
        {
          name: 'Tuck hold',
          time: 8 * 60 + 47,
        },
        {
          name: 'Dislocaciónes',
          time: 9 * 60 + 44,
        },
        {
          name: 'Tuck en silla',
          time: 11 * 60 + 1,
        },
        {
          name: 'Tuck con pierna estirada',
          time: 13 * 60 + 4,
        },
        {
          name: 'Hand Stand en Pike',
          time: 14 * 60 + 25,
        },
        {
          name: 'Tuck a Pike y pierna estirada',
          time: 15 * 60 + 56,
        },
        {
          name: 'Pike hand stand en pared',
          time: 17 * 60 + 36,
        },
        {
          name: 'Cast wall to walk',
          time: 18 * 60 + 43,
        },
        {
          name: 'Recomendaciones',
          time: 20 * 60 + 55,
        },
        {
          name: 'Reto II',
          time: 21 * 60 + 48,
        },
      ]
    },
    {
      name: 'Movilidad articular',
      time: 9 * 60 + 46,
      sub: [
        {
          name: 'Arriba, abajo, piso',
          time: 9 * 60 + 46,
        },
        {
          name: 'Enfrente, en medio, atrás',
          time: 10 * 60 + 32,
        },
        {
          name: 'Toque cruzados',
          time: 10 * 60 + 55,
        },
        {
          name: 'Desplantes alternados',
          time: 11 * 60 + 23,
        },
        {
          name: 'Kozak',
          time: 11 * 60 + 37,
        },
        {
          name: 'Cobra',
          time: 12 * 60 + 13,
        },
        {
          name: 'Perrito',
          time: 12 * 60 + 53,
        },
        {
          name: 'Mariposa',
          time: 13 * 60 + 37,
        },
        {
          name: 'Plegado a una pierna',
          time: 14 * 60 + 10,
        },
        {
          name: 'Flat back',
          time: 14 * 60 + 57,
        },
        {
          name: 'Sandwich',
          time: 15 * 60 + 27,
        },
        {
          name: 'Straddle',
          time: 15 * 60 + 42,
        },
      ]
    },
    {
      name: 'Fortalecimiento articular',
      time: 16 * 60 + 46,
      sub: [
        {
          name: 'Introducción',
          time: 16 * 60 + 46,
        },
        {
          name: 'Muñecas',
          time: 17 * 60 + 2,
        },
        {
          name: 'Hombros',
          time: 21 * 60 + 1,
        },
        {
          name: 'Cuello',
          time: 23 * 60 + 5,
        },
        {
          name: 'Core',
          time: 26 * 60 + 23,
        },
        {
          name: 'Reto I',
          time: 29 * 60 + 57,
        },
      ]
    },
  ],
},
{
  id: "036",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/036/Front/HLS/Session+036+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/036/Back/HLS/Session+036+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/036/Front/Thumbnails/Session+036+-+Custom-Poster.jpg',
  details: roaster[roasterMap["juan-carlos-lopez"]],
  category: categories[categoryMap.danzajazz],
  classType: {
    slug: ['combo']
  },
  videoInfo: {
    about: 'Fundamentos de Danza Jazz',
    description: 'Aprende las base de este estilo de danza y experimenta los beneficios que te aporta practicarla. <br>Pero principalmente vamos a pasar un rato muy agradable practicando Danza Jazz.',
    relatesTo: 'Danza Acrobática, Baile Fitness, Breaking, Flex',
    recommended: 'En esta sesión a parte del calentamiento y el cardio nos enfocaremos en ejercicios de movilidad y coordinación, todo al ritmo de la música, importantísimos para mejorar nuestras habilidades de danza.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['026', '017', '027'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Cabeza',
          time: 2 * 60 + 7,
        },
        {
          name: 'Hombros',
          time: 2 * 60 + 41,
        },
        {
          name: 'Espalda',
          time: 3 * 60 + 7,
        },
        {
          name: 'Piernas',
          time: 3 * 60 + 41,
        },
        {
          name: 'Torsiones',
          time: 6 * 60 + 23,
        },
        {
          name: 'Planchas',
          time: 7 * 60 + 32,
        },
        {
          name: 'Torsión con brazos',
          time: 8 * 60 + 4,
        },
      ]
    },
    {
      name: 'Cardio',
      time: 8 * 60 + 38,
      sub: [
        {
          name: 'Introducción',
          time: 8 * 60 + 38,
        },
        {
          name: 'Jumping Jacks',
          time: 9 * 60 + 24,
        },
        {
          name: 'Tijeras',
          time: 9 * 60 + 49,
        },
        {
          name: 'Saltos laterales',
          time: 10 * 60 + 5,
        },
        {
          name: 'Saltos frente-atrás',
          time: 10 * 60 + 16,
        },
        {
          name: 'Saltos alternados a una pierna',
          time: 10 * 60 + 28,
        },
        {
          name: 'Salto con giros',
          time: 10 * 60 + 45,
        },
        {
          name: 'Toque de piso',
          time: 11 * 60 + 1,
        },
        {
          name: 'Desplantes y segunda',
          time: 11 * 60 + 17,
        },
        {
          name: 'Toque de piso y patada',
          time: 11 * 60 + 32,
        },
        {
          name: 'Correr',
          time: 12 * 60 + 4,
        },
        {
          name: 'Estiramiento',
          time: 12 * 60 + 18,
        },
      ]
    },
    {
      name: 'Movilidad',
      time: 13 * 60 + 20,
      sub: [
        {
          name: 'Introducción',
          time: 13 * 60 + 20,
        },
        {
          name: 'Torsión con brazos',
          time: 14 * 60 + 3,
        },
        {
          name: 'Alargamiento en segunda',
          time: 15 * 60 + 19,
        },
        {
          name: 'Blast push up con torsión',
          time: 17 * 60 + 9,
        },
        {
          name: 'Extensión de pecho con retracción',
          time: 18 * 60 + 43,
        },
        {
          name: 'Con música',
          time: 19 * 60 + 43,
        },
      ]
    },
    {
      name: 'Coordinación I',
      time: 24 * 60 + 36,
      sub: [
        {
          name: 'Introducción',
          time: 24 * 60 + 36,
        },
        {
          name: 'Relevé y plié',
          time: 25 * 60 + 14,
        },
        {
          name: 'Postura de brazos',
          time: 26 * 60 + 35,
        },
        {
          name: 'Combinación',
          time: 26 * 60 + 54,
        },
        {
          name: 'Con música',
          time: 27 * 60 + 34,
        },
      ]
    },
    {
      name: 'Coordinación II',
      time: 29 * 60 + 21,
      sub: [
        {
          name: 'Movimiento brazo derecho',
          time: 29 * 60 + 21,
        },
        {
          name: 'Movimiento brazo izquierdo',
          time: 30 * 60 + 9,
        },
        {
          name: 'Combinación',
          time: 30 * 60 + 23,
        },
        {
          name: 'Con música',
          time: 31 * 60 + 3,
        },
        {
          name: 'Cambio de lado',
          time: 32 * 60 + 25,
        },
      ]
    },
    {
      name: 'Enfriamiento',
      time: 34 * 60 + 23,
      sub: [
        {
          name: 'Introducción',
          time: 34 * 60 + 23,
        },
        {
          name: 'Espalda',
          time: 34 * 60 + 37,
        },
        {
          name: 'Piernas',
          time: 36 * 60 + 19,
        },
        {
          name: 'Torsión',
          time: 37 * 60 + 8,
        },
        {
          name: 'Cuello',
          time: 37 * 60 + 20,
        },
        {
          name: 'Recomendaciones',
          time: 37 * 60 + 41,
        },
      ]
    },
  ],
},
{
  id: "037",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/037/Front/HLS/Session+037+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/037/Back/HLS/Session+037+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/037/Front/Thumbnails/Session+037+-+Custom-Poster.jpg',
  details: roaster[roasterMap.didack],
  category: categories[categoryMap.breaking],
  classType: {
    slug: ['movement', 'free']
  },
  isFree: true,
  videoInfo: {
    about: 'Top Rock - Introducción al Breaking',
    description: 'El breaking, mejor conocido como Break Dance o B-boying o B-girling es una disciplina artística parte de la cultura Hip Hop.',
    relatesTo: 'Danza Acrobática, Baile Fitness, Danza Jazz, Ritmos Latinos',
    recommended: 'El breaking utiliza muchos movimientos dinámicos, todo tu cuerpo será expuesto a un ejercicio demandante por lo que es recomendable ejercitarlo y prepararlo antes de intentar estos movimientos.<br>Tal vez lo más característico de esta disciplina es que te permite expresar tus ideas, sentimientos y estados de ánimo mediante el baile.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['036', '027', '011'],
  sections: [
    {
      name: 'Introducción',
      time: 0,
      sub: [
        {
          name: 'Historia',
          time: 0,
        },
        {
          name: 'Top Rock',
          time: 58,
        },
        {
          name: 'Foot Work',
          time: 1 * 60 + 12,
        },
        {
          name: 'Freezes',
          time: 1 * 60 + 25,
        },
        {
          name: 'Power moves',
          time: 1 * 60 + 48,
        },
      ]
    },
    {
      name: 'Calentamiento',
      time: 2 * 60 + 12,
      sub: [
        {
          name: 'Introducción',
          time: 2 * 60 + 12,
        },
        {
          name: 'Top Rock',
          time: 3 * 60 + 11,
        },
        {
          name: 'Hombros',
          time: 3 * 60 + 31,
        },
        {
          name: 'Cadera',
          time: 4 * 60 + 13,
        },
        {
          name: 'Piés',
          time: 4 * 60 + 37,
        },
        {
          name: 'Saltos',
          time: 5 * 60 + 9,
        },
      ]
    },
    {
      name: 'Indian Step Crossover',
      time: 5 * 60 + 40,
      sub: [
        {
          name: 'Introducción',
          time: 5 * 60 + 40,
        },
        {
          name: 'Pisadas',
          time: 5 * 60 + 50,
        },
        {
          name: 'Postura de Manos',
          time: 6 * 60 + 24,
        },
        {
          name: 'Combinación',
          time: 6 * 60 + 46,
        },
        {
          name: 'Con música',
          time: 7 * 60 + 34,
        },
      ]
    },
    {
      name: 'Coordinación',
      time: 7 * 60 + 57,
      sub: [
        {
          name: 'Introducción',
          time: 7 * 60 + 57,
        },
        {
          name: 'Brazos abiertos',
          time: 8 * 60 + 11,
        },
        {
          name: 'Diagonales',
          time: 8 * 60 + 21,
        },
        {
          name: 'Frente a cintura',
          time: 8 * 60 + 40,
        },
        {
          name: 'Combinación',
          time: 9 * 60 + 0,
        },
        {
          name: 'Con música',
          time: 9 * 60 + 16,
        },
      ]
    },
    {
      name: 'Dinámicas',
      time: 9 * 60 + 54,
      sub: [
        {
          name: 'Introducción',
          time: 9 * 60 + 54,
        },
        {
          name: 'Desplazamiento al frente',
          time: 10 * 60 + 27,
        },
        {
          name: 'Desplazamiento hacia atrás',
          time: 10 * 60 + 54,
        },
        {
          name: 'Desplazamiento a la derecha',
          time: 11 * 60 + 36,
        },
        {
          name: 'Desplazamiento a la izquierda',
          time: 12 * 60 + 17,
        },
        {
          name: 'Desplazamiento en diagonal',
          time: 12 * 60 + 31,
        },
        {
          name: 'Con música',
          time: 13 * 60 + 5,
        },
      ]
    },
    {
      name: 'Salsa Step',
      time: 14 * 60 + 1,
      sub: [
        {
          name: 'Introducción',
          time: 14 * 60 + 1,
        },
        {
          name: 'Pisadas',
          time: 14 * 60 + 48,
        },
        {
          name: 'Postura de Manos',
          time: 15 * 60 + 40,
        },
        {
          name: 'Combinación',
          time: 16 * 60 + 20,
        },
        {
          name: 'Con música',
          time: 17 * 60 + 18,
        },
      ]
    },
    {
      name: 'Coordinación',
      time: 17 * 60 + 42,
      sub: [
        {
          name: 'Introducción',
          time: 17 * 60 + 42,
        },
        {
          name: 'Brazos abiertos',
          time: 17 * 60 + 57,
        },
        {
          name: 'Brazos en sentido contrario al pié',
          time: 18 * 60 + 23,
        },
        {
          name: 'Brazos extendidos con el pié',
          time: 18 * 60 + 47,
        },
        {
          name: 'Con música (3 x 2 x 3)',
          time: 19 * 60 + 10,
        },
      ]
    },
    {
      name: 'Dinámicas',
      time: 20 * 60 + 0,
      sub: [
        {
          name: 'Introducción',
          time: 20 * 60 + 0,
        },
        {
          name: 'Desplazamiento al frente',
          time: 20 * 60 + 16,
        },
        {
          name: 'Desplazamiento hacia atrás',
          time: 20 * 60 + 42,
        },
        {
          name: 'Desplazamiento a la derecha',
          time: 21 * 60 + 7,
        },
        {
          name: 'Desplazamiento a la izquierda',
          time: 21 * 60 + 41,
        },
        {
          name: 'Desplazamiento en diagonal',
          time: 22 * 60 + 18,
        },
        {
          name: 'Con música',
          time: 22 * 60 + 52,
        },
      ]
    },
    {
      name: 'Coreografía',
      time: 23 * 60 + 39,
      sub: [
        {
          name: 'Introducción',
          time: 23 * 60 + 39,
        },
        {
          name: 'Indian Step Crossover',
          time: 23 * 60 + 54,
        },
        {
          name: 'Salsa Step',
          time: 24 * 60 + 5,
        },
        {
          name: 'Indian Step en Diagonal',
          time: 24 * 60 + 17,
        },
        {
          name: 'Salsa Step con brazos extendidos al mismo pié',
          time: 24 * 60 + 26,
        },
        {
          name: 'Combinación',
          time: 24 * 60 + 40,
        },
        {
          name: 'Con música',
          time: 25 * 60 + 10,
        },
        {
          name: 'Recomendaciones',
          time: 25 * 60 + 52,
        },
      ]
    },
  ],
},
{
  id: "038",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/038/Front/HLS/Session+038+-+Front_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/038/Front/Thumbnails/Session+038+-+Custom-Poster.jpg',
  details: roaster[roasterMap["roberto-parra"]],
  category: categories[categoryMap.fisioterapia],
  classType: {
    slug: ['re-hab']
  },
  videoInfo: {
    about: '¿Dejar de hacer ejercicio ante una lesión?',
    description: 'Evita lesiones realizando ejercicios guiado por profesionales, pero ¿qué hacer cuando ya existe algún tipo de lesión?. <br>En esta sesión Robert te enseña qué hacer y qué no hacer cuando ya sufriste alguna lesión.<br>Además te muestra ejercicios de rehabilitación enfocados en el tobillo, una de las zonas con tendencia a lesionarse más frecuentemente.',
    relatesTo: 'Calistenia, Flexibilidad, Danza Acrobática',
    recommended: 'Tanto hombres como mujeres suelen lastimarse el tobillo al menos en laguna ocasión, ya sea de forma ligera o grave al nivel de una esguince o alguna fractura.<br>Si ese es tu caso, o conoces a alguien que le haya pasado, te recomendamos realizar los ejercicios de esta sesión.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: 'Disco de estabilidad o similar, liga, platos de entrenamiento o vasos o almohadas pequeñas.',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['019', '020', '066'],
  sections: [
    {
      name: 'Introducción',
      time: 0,
      sub: [
        {
          name: 'Problemáticas actuales',
          time: 0,
        },
        {
          name: 'Efectos de una lesión',
          time: 45,
        },
        {
          name: '¿Para qué sirve la porgresión en los ejercicios?',
          time: 1 * 60 + 37,
        },
        {
          name: '¿Qué es una esguince?',
          time: 1 * 60 + 50,
        },
        {
          name: 'Lesiones en el tobillo',
          time: 3 * 60 + 29,
        },
        {
          name: '¿Debo dejar de hacer ejercicio ante una lesión?',
          time: 4 * 60 + 38,
        },
      ]
    },
    {
      name: 'Rehabilitación etapa aguda',
      time: 5 * 60 + 41,
      sub: [
        {
          name: 'Tratamiento',
          time: 5 * 60 + 41,
        },
        {
          name: 'Dorsiflexión acostado',
          time: 6 * 60 + 29,
        },
        {
          name: 'Círculos a una pierna',
          time: 7 * 60 + 19,
        },
        {
          name: 'Círculos a una pierna sentido contrario',
          time: 7 * 60 + 54,
        },
        {
          name: 'Compresiones articulares',
          time: 8 * 60 + 9,
        },
        {
          name: 'Compresiones articulares en pared',
          time: 8 * 60 + 56,
        },
        {
          name: 'Compresiones articulares con talón',
          time: 9 * 60 + 23,
        },
      ]
    },
    {
      name: 'Rehabilitación segundo grado de lesión',
      time: 9 * 60 + 46,
      sub: [
        {
          name: 'Introducción',
          time: 9 * 60 + 46,
        },
        {
          name: 'Compresiones de pié',
          time: 9 * 60 + 59,
        },
        {
          name: 'Compresiones con disco',
          time: 10 * 60 + 10,
        },
        {
          name: 'Compresiones con talón en disco',
          time: 10 * 60 + 48,
        },
        {
          name: 'Compresiones con punta en disco',
          time: 10 * 60 + 53,
        },
        {
          name: 'Dorsiflexión con liga',
          time: 10 * 60 + 57,
        },
        {
          name: 'Peroneo (laterales) con liga',
          time: 11 * 60 + 33,
        },
        {
          name: 'Dorsiflexión con liga acostados',
          time: 11 * 60 + 59,
        },
        {
          name: 'Toque de platos 2 - 1',
          time: 12 * 60 + 43,
        },
        {
          name: 'Toque de platos 2 - 2',
          time: 13 * 60 + 9,
        },
        {
          name: 'Recomendaciones',
          time: 13 * 60 + 27,
        },
      ]
    },
    {
      name: 'Control, equilibrio y coordinación',
      time: 13 * 60 + 55,
      sub: [
        {
          name: 'Equilibrio bipodal en disco',
          time: 13 * 60 + 55,
        },
        {
          name: 'Equilibrio unipodal en disco',
          time: 14 * 60 + 9,
        },
        {
          name: 'Lanzamientos en unipodal',
          time: 14 * 60 + 16,
        },
        {
          name: 'Marcha tandem',
          time: 14 * 60 + 41,
        },
        {
          name: 'Brincos (Pliometría)',
          time: 15 * 60 + 14,
        },
        {
          name: 'Brincos con un pié',
          time: 15 * 60 + 46,
        },
        {
          name: 'Pasar la cuerda de izquierda a derecha',
          time: 15 * 60 + 56,
        },
        {
          name: 'Pasar la cuerda frente atrás',
          time: 16  * 60 + 17,
        },
        {
          name: 'Pasar la cuerda en lateral',
          time: 16  * 60 + 28,
        },
        {
          name: 'Recomendaciones',
          time: 16  * 60 + 40,
        },
      ]
    },
  ],
},
{
  id: "039",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/039/Front/HLS/Session+039+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/039/Back/HLS/Session+039+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/039/Front/Thumbnails/Session+039+-+Custom-Poster.jpg',
  details: roaster[roasterMap.yuri],
  category: categories[categoryMap.yogakids],
  classType: {
    slug: ['movement', 'free']
  },
  isFree: true,
  videoInfo: {
    about: 'Posturas básicas',
    description: 'En esta sesión iniciamos con serpiente, perro boca abajo, árbol y pelota',
    relatesTo: 'Yoga, Acroyoga, Flex, Calistenia',
    recommended: 'Es muy importante trabajar con la respiración, mientras más relajado te encuentres mejor podrás controlar tus emociones. <br> Puedes utilizar un globo o un juguete para ayudarte a visualizar tu respiración y poco a poco hacerlo de forma más conciente por tu cuenta.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: 'Tapete de Yoga, Pelota expandible, Globo',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['005', '010', '008'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Meditación',
          time: 16,
        },
        {
          name: 'Piés',
          time: 1 * 60 + 54,
        },
        {
          name: 'Rodillas',
          time: 2 * 60 + 45,
        },
        {
          name: 'Cadera',
          time: 3 * 60 + 4,
        },
        {
          name: 'Hombros',
          time: 3 * 60 + 48,
        },
        {
          name: 'Cabeza',
          time: 4 * 60 + 11,
        },
      ]
    },
    {
      name: 'Coordinación',
      time: 5 * 60 + 46,
      sub: [
        {
          name: 'Introducción',
          time: 5 * 60 + 46,
        },
        {
          name: 'Circulos con los brazos',
          time: 5 * 60 + 46,
        },
        {
          name: 'Circulos opuestos',
          time: 6 * 60 + 18,
        },
      ]
    },
    {
      name: 'Saludos al Sol',
      time: 6 * 60 + 50,
      sub: [
        {
          name: 'Saludo al Sol',
          time: 6 * 60 + 50,
        },
        {
          name: 'Saludo a la Tierra',
          time: 7 * 60 + 7,
        },
        {
          name: 'Serpiente',
          time: 7 * 60 + 16,
        },
        {
          name: 'Perro',
          time: 7 * 60 + 40,
        },
      ]
    },
    {
      name: 'Posturas',
      time: 9 * 60 + 42,
      sub: [
        {
          name: 'Serpiente',
          time: 9 * 60 + 42,
        },
        {
          name: 'Perro boca abajo',
          time: 10 * 60 + 23,
        },
        {
          name: 'Árbol',
          time: 11 * 60 + 0,
        },
        {
          name: 'Pelota',
          time: 11 * 60 + 54,
        },
      ]
    },
    {
      name: 'Respiración',
      time: 12 * 60 + 34,
      sub: [
        {
          name: 'Con Pelota Expandible',
          time: 12 * 60 + 34,
        },
        {
          name: 'Con Globo',
          time: 14 * 60 + 55,
        },
      ]
    },
    {
      name: 'Meditación',
      time: 16 * 60 + 12,
      sub: [
        {
          name: 'Estiramiento',
          time: 16 * 60 + 12,
        },
        {
          name: 'Meditación',
          time: 17 * 60 + 0,
        },
      ]
    },
  ],
},
{
  id: "040",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/040/Front/HLS/Session+040+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/040/Back/HLS/Session+040+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/040/Front/Thumbnails/Session+040+-+Custom-Poster.jpg',
  details: roaster[roasterMap.didack],
  category: categories[categoryMap.breaking],
  classType: {
    slug: ['movement']
  },
  videoInfo: {
    about: 'Foot work',
    description: 'En esta sesión nos concentraremos principalmente en el trabajo de piernas y cadera.<br>El breaking, mejor conocido como Break Dance o B-boying o B-girling es una disciplina artística parte de la cultura Hip Hop.',
    relatesTo: 'Danza Acrobática, Baile Fitness, Danza Jazz, Ritmos Latinos',
    recommended: 'El breaking utiliza muchos movimientos dinámicos, todo tu cuerpo será expuesto a un ejercicio demandante por lo que es recomendable ejercitarlo y prepararlo antes de intentar estos movimientos.<br>Tal vez lo más característico de esta disciplina es que te permite expresar tus ideas, sentimientos y estados de ánimo mediante el baile.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['036', '037', '011'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Demostración',
          time: 41,
        },
        {
          name: 'Muñecas',
          time: 1 * 60 + 8,
        },
        {
          name: 'Hombros',
          time: 1 * 60 + 42,
        },
        {
          name: 'Cuello',
          time: 2 * 60 + 8,
        },
        {
          name: 'Cadera',
          time: 2 * 60 + 29,
        },
        {
          name: 'Piernas',
          time: 2 * 60 + 48,
        },
        {
          name: 'Sentadilla x 15 segs.',
          time: 3 * 60 + 31,
        },
      ]
    },
    {
      name: 'Hook',
      time: 4 * 60 + 1,
      sub: [
        {
          name: 'Introducción',
          time: 4 * 60 + 1,
        },
        {
          name: 'Postura foot work',
          time: 4 * 60 + 19,
        },
        {
          name: 'Movimiento de piés',
          time: 4 * 60 + 42,
        },
        {
          name: 'Movimiento de manos',
          time: 5 * 60 + 14,
        },
        {
          name: 'Hook desde Top Rock',
          time: 7 * 60 + 13,
        },
        {
          name: 'Con fluidez',
          time: 8 * 60 + 26,
        },
        {
          name: 'Recomendaciones',
          time: 9 * 60 + 30,
        },
      ]
    },
    {
      name: 'One Step | Reloj | Sweep | Coffee Grinder',
      time: 9 * 60 + 59,
      sub: [
        {
          name: 'Introducción',
          time: 9 * 60 + 59,
        },
        {
          name: 'Demostración',
          time: 10 * 60 + 24,
        },
        {
          name: 'Movimiento de piés',
          time: 10 * 60 + 35,
        },
        {
          name: 'Fortalecimiento',
          time: 13 * 60 + 20,
        },
      ]
    },
    {
      name: 'One Step hacia atrás',
      time: 15 * 60 + 8,
      sub: [
        {
          name: 'Introducción',
          time: 15 * 60 + 8,
        },
        {
          name: 'Movimiento de piés',
          time: 15 * 60 + 22,
        },
        {
          name: 'Con música',
          time: 16 * 60 + 37,
        },
      ]
    },
    {
      name: '4 Balls Sweep',
      time: 17 * 60 + 12,
      sub: [
        {
          name: 'Introducción',
          time: 17 * 60 + 12,
        },
        {
          name: 'Power Sweep',
          time: 18 * 60 + 8,
        },
        {
          name: 'Variación 4 Balls',
          time: 21 * 60 + 1,
        },
        {
          name: 'Recomendaciones',
          time: 23 * 60 + 57,
        },
      ]
    },
  ],
},
{
  id: "041",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/041/Front/HLS/Session+041+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/041/Back/HLS/Session+041+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/041/Front/Thumbnails/Session+041+-+Custom-Poster.jpg',
  details: roaster[roasterMap["guillo-y-kei"]],
  category: categories[categoryMap.gimnasia],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Hand Stand III - Fortalecimiento',
    description: 'Trabajar la fuerza para lograr un mejor parado de manos es fundamental ya que esto te permitirá construir músculos que te ayudarán a sostener tu parado de manos.<br>Recuerda combinar tus sesiones de entrenamiento con descansos.<br>Te recomendamos entrenar entre dos a tres veces por semana ya que este tipo de entrenamientos son más demandantes así que necesitarás un descanso adecuado.<br>',
    relatesTo: 'Danza, Baile Fitness, Calistenia, Flex',
    recommended: 'Lograr un parado de manos requiere de un entrenamiento específico, te recomendamos practicar estos movimientos al menos de 2 a 3 veces por semana, de 30 a 45 minutos para proteger tus articulaciones.<br>Una vez que hayas fortalecido muñecas, hombros y core puedes empezar a incrementar el tiempo de entrenamiento.<br> Puedes realizar los ejercicios de calentamiento para empezar a fortalezar tu cuerpo antes de intentar el parado de manos. <br>Si ya te sientes listo para intentarlo, te recomendamos que primero te ayudes de una silla y después de la pared, te mostramos cómo en este video.<br>Mejora tu postura, equilibrio y fuerza en las manos con estos movimientos para facilitar tu parado de manos.',
    tools: 'Con el modo Loop puedes repetir la serie de entrenamiento para que la realices 2 o 3 veces según tu nivel fitness. <br>Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: 'Tapete de Yoga o colchoneta, Silla o similar.',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['034', '035', '008'],
  sections: [
    {
      name: 'Fortalecimiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Lagartijas para HS x 10 reps.',
          time: 55,
        },
        {
          name: 'Lagartijas abiertas x 10 reps.',
          time: 2 * 60 + 37,
        },
        {
          name: 'Lagartija en diamante x 10 reps.',
          time: 3 * 60 + 38,
        },
        {
          name: 'Fondos x 10 reps.',
          time: 4 * 60 + 48,
        },
        {
          name: 'Lagartijas con dedos x 10 reps.',
          time: 6 * 60 + 24,
        },
        {
          name: 'Pike Push up en piso x 10 reps.',
          time: 7 * 60 + 50,
        },
        {
          name: 'Pike Push up en silla x 8 reps.',
          time: 9 * 60 + 31,
        },
      ]
    },
    {
      name: 'Abdomen I',
      time: 11 * 60 + 20,
      sub: [
        {
          name: 'Introducción',
          time: 11 * 60 + 20,
        },
        {
          name: 'Serie en Hollow',
          time: 11 * 60 + 45,
        },
        {
          name: 'Serie en Laterales',
          time: 12 * 60 + 19,
        },
        {
          name: 'Serie en Dorsales',
          time: 13 * 60 + 3,
        },
        {
          name: 'Serie en Plancha',
          time: 14 * 60 + 5,
        },
        {
          name: 'Serie en Abdomen',
          time: 15 * 60 + 13,
        },
        {
          name: 'Recomendaciones',
          time: 17 * 60 + 0,
        },
      ]
    },
  ],
},
{
  id: "042",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/042/Front/HLS/Session+042+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/042/Back/HLS/Session+042+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/042/Front/Thumbnails/Session+042+-+Custom-Poster.jpg',
  details: roaster[roasterMap["guillo-y-kei"]],
  category: categories[categoryMap.gimnasia],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Hand Stand IV - Flex',
    description: 'Trabajar flexibilidad para elongar brazos y piernas te ayudará a tener mejor control en tu parado de manos.<br>Recuerda combinar tus sesiones de entrenamiento con descansos.<br>Te recomendamos entrenar entre dos a tres veces por semana ya que este tipo de entrenamientos son más demandantes así que necesitarás un descanso adecuado.<br>',
    relatesTo: 'Danza, Baile Fitness, Calistenia, Flex',
    recommended: 'Lograr un parado de manos requiere de un entrenamiento específico, te recomendamos practicar estos movimientos al menos de 2 a 3 veces por semana, de 30 a 45 minutos para proteger tus articulaciones.<br>Una vez que hayas fortalecido muñecas, hombros y core puedes empezar a incrementar el tiempo de entrenamiento.<br> Puedes realizar los ejercicios de calentamiento para empezar a fortalezar tu cuerpo antes de intentar el parado de manos. <br>Si ya te sientes listo para intentarlo, te recomendamos que primero te ayudes de una silla y después de la pared, te mostramos cómo en este video.<br>Mejora tu postura, equilibrio y fuerza en las manos con estos movimientos para facilitar tu parado de manos.',
    tools: 'Con el modo Loop puedes repetir la serie de entrenamiento para que la realices 2 o 3 veces según tu nivel fitness. <br>Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: 'Tapete de Yoga o colchoneta, Silla o similar.',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['034', '035', '036'],
  sections: [
    {
      name: 'Liberación Muscular',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Respiración Ventral',
          time: 1 * 60 + 35,
        },
        {
          name: 'Planta del pié',
          time: 3 * 60 + 37,
        },
        {
          name: 'Gemelos',
          time: 4 * 60 + 58,
        },
        {
          name: 'Muslos',
          time: 5 * 60 + 41,
        },
        {
          name: 'Cuadriceps',
          time: 6 * 60 + 45,
        },
        {
          name: 'Rótulas',
          time: 7 * 60 + 22,
        },
        {
          name: 'Espalda',
          time: 7 * 60 + 46,
        },
      ]
    },
    {
      name: 'Flexibilidad',
      time: 8 * 60 + 26,
      sub: [
        {
          name: 'Kozaks',
          time: 8 * 60 + 26,
        },
        {
          name: 'Guerrero',
          time: 9 * 60 + 18,
        },
        {
          name: 'Espalda',
          time: 9 * 60 + 49,
        },
        {
          name: 'Toques de piés cruzados',
          time: 10 * 60 + 11,
        },
        {
          name: 'Frente - atrás',
          time: 10 * 60 + 30,
        },
        {
          name: 'Atrás al Frente',
          time: 10 * 60 + 48,
        },
        {
          name: 'Camello',
          time: 10 * 60 + 59,
        },
        {
          name: 'Flexion en medio split',
          time: 11 * 60 + 47,
        },
        {
          name: 'Extensiones en Mariposa',
          time: 12 * 60 + 48,
        },
        {
          name: 'Medio Pike',
          time: 13 * 60 + 50,
        },
        {
          name: 'Pike',
          time: 15 * 60 + 19,
        },
        {
          name: 'Extensiones en Straddle',
          time: 15 * 60 + 48,
        },
        {
          name: 'Split',
          time: 18 * 60 + 19,
        },
        {
          name: 'Squat',
          time: 20 * 60 + 37,
        },
        {
          name: 'Extensión de Pecho',
          time: 21 * 60 + 53,
        },
        {
          name: 'Perrito',
          time: 23 * 60 + 3,
        },
        {
          name: 'Arco',
          time: 23 * 60 + 48,
        },
        {
          name: 'Muñecas',
          time: 25 * 60 + 51,
        },
        {
          name: 'Recomendaciones',
          time: 26 * 60 + 30,
        },
      ]
    },
  ],
},
{
  id: "043",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/043/Front/HLS/Session+043+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/043/Back/HLS/Session+043+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/043/Front/Thumbnails/Session+043+-+Custom-Poster.jpg',
  details: roaster[roasterMap.didack],
  category: categories[categoryMap.breaking],
  classType: {
    slug: ['movement']
  },
  videoInfo: {
    about: 'Top Rock - Salsa Back y Salsa Front',
    description: 'Retomamos el Salsa Step para agregar dos variaciones, Salsa Back y Salsa Front.<br>El breaking, mejor conocido como Break Dance o B-boying o B-girling es una disciplina artística parte de la cultura Hip Hop.',
    relatesTo: 'Danza Acrobática, Baile Fitness, Danza Jazz, Ritmos Latinos',
    recommended: 'El breaking utiliza muchos movimientos dinámicos, todo tu cuerpo será expuesto a un ejercicio demandante por lo que es recomendable ejercitarlo y prepararlo antes de intentar estos movimientos.<br>Tal vez lo más característico de esta disciplina es que te permite expresar tus ideas, sentimientos y estados de ánimo mediante el baile.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['036', '037', '040'],
  sections: [
    {
      name: 'Pre-calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Hombros',
          time: 26,
        },
        {
          name: 'Cintura',
          time: 52,
        },
        {
          name: 'Piés',
          time: 1 * 60 + 13,
        },
        {
          name: 'Saltos',
          time: 1 * 60 + 47,
        },
      ]
    },
    {
      name: 'Salsa Back',
      time: 2 * 60 + 0,
      sub: [
        {
          name: 'Introducción',
          time: 2 * 60 + 0,
        },
        {
          name: 'Desglose de piés',
          time: 2 * 60 + 32,
        },
        {
          name: 'Posición de las manos',
          time: 3 * 60 + 12,
        },
        {
          name: 'Detalles',
          time: 3 * 60 + 54,
        },
        {
          name: 'Con Música',
          time: 4 * 60 + 57,
        },
      ]
    },
    {
      name: 'Dinámicas',
      time: 5 * 60 + 16,
      sub: [
        {
          name: 'Introducción',
          time: 5 * 60 + 16,
        },
        {
          name: 'Al frente',
          time: 5 * 60 + 41,
        },
        {
          name: 'Hacia atrás',
          time: 7 * 60 + 5,
        },
        {
          name: 'A los lados',
          time: 8 * 60 + 8,
        },
      ]
    },
    {
      name: 'Coordinación',
      time: 10 * 60 + 25,
      sub: [
        {
          name: 'Introducción',
          time: 10 * 60 + 25,
        },
        {
          name: 'Brazos Abiertos',
          time: 11 * 60 + 10,
        },
        {
          name: 'Brazos al mismo lado',
          time: 11 * 60 + 21,
        },
        {
          name: 'Brazos a la cabeza',
          time: 12 * 60 + 10,
        },
        {
          name: 'Con música',
          time: 12 * 60 + 54,
        },
      ]
    },
    {
      name: 'Salsa Front',
      time: 13 * 60 + 20,
      sub: [
        {
          name: 'Introducción',
          time: 13 * 60 + 20,
        },
        {
          name: 'Movimiento de piés',
          time: 13 * 60 + 56,
        },
        {
          name: 'Movimiento de manos',
          time: 14 * 60 + 47,
        },
        {
          name: 'Detalles',
          time: 15 * 60 + 6,
        },
        {
          name: 'Con música',
          time: 16 * 60 + 31,
        },
        {
          name: 'Postura recomendada',
          time: 17 * 60 + 4,
        },
      ]
    },
    {
      name: 'Dinámicas',
      time: 18 * 60 + 0,
      sub: [
        {
          name: 'Introducción',
          time: 18 * 60 + 0,
        },
        {
          name: 'Al frente',
          time: 18 * 60 + 7,
        },
        {
          name: 'Hacia atrás',
          time: 19 * 60 + 42,
        },
        {
          name: 'A los lados',
          time: 21 * 60 + 12,
        },
      ]
    },
    {
      name: 'Coordinación',
      time: 24 * 60 + 4,
      sub: [
        {
          name: 'Introducción',
          time: 24 * 60 + 4,
        },
        {
          name: 'Brazos Abiertos',
          time: 24 * 60 + 37,
        },
        {
          name: 'Brazos hacia atrás',
          time: 24 * 60 + 49,
        },
        {
          name: 'Manos a la cabeza',
          time: 25 * 60 + 10,
        },
        {
          name: 'Con música',
          time: 25 * 60 + 31,
        },
        {
          name: 'Recomendaciones',
          time: 26 * 60 + 7,
        },
      ]
    },
  ],
},
{
  id: "044",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/044/Front/HLS/Session+044+-+Front_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/044/Front/Thumbnails/Session+044+-+Custom-Poster.jpg',
  details: roaster[roasterMap.didack],
  category: categories[categoryMap.breaking],
  classType: {
    slug: ['movement']
  },
  videoInfo: {
    about: 'Foot Work - Six Step y Five Step',
    description: 'En esta sesión veremos un poco de foot work para trabajar la fluidez de los piés.<br>El breaking, mejor conocido como Break Dance o B-boying o B-girling es una disciplina artística parte de la cultura Hip Hop.',
    relatesTo: 'Danza Acrobática, Baile Fitness, Danza Jazz, Ritmos Latinos',
    recommended: 'El breaking utiliza muchos movimientos dinámicos, todo tu cuerpo será expuesto a un ejercicio demandante por lo que es recomendable ejercitarlo y prepararlo antes de intentar estos movimientos.<br>Tal vez lo más característico de esta disciplina es que te permite expresar tus ideas, sentimientos y estados de ánimo mediante el baile.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['036', '018', '040'],
  sections: [
    {
      name: 'Pre-calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Cintura',
          time: 35,
        },
        {
          name: 'Piernas',
          time: 1 * 60 + 24,
        },
        {
          name: 'Sentadilla x 30 segs.',
          time: 2 * 60 + 0,
        },
        {
          name: 'Cuclillas x 20 segs.',
          time: 2 * 60 + 56,
        },
        {
          name: 'Saltos en cuclillas x 15 reps.',
          time: 3 * 60 + 33,
        },
        {
          name: 'Extensión de femur.',
          time: 3 * 60 + 53,
        },
      ]
    },
    {
      name: 'Six Step',
      time: 4 * 60 + 32,
      sub: [
        {
          name: 'Introducción',
          time: 4 * 60 + 32,
        },
        {
          name: 'Postura inicial',
          time: 4 * 60 + 55,
        },
        {
          name: 'Posición de las manos',
          time: 5 * 60 + 44,
        },
        {
          name: 'Posición de los piés',
          time: 6 * 60 + 33,
        },
        {
          name: 'Detalles',
          time: 9 * 60 + 43,
        },
        {
          name: 'Lado izquierdo',
          time: 10 * 60 + 36,
        },
        {
          name: 'Con música',
          time: 11 * 60 + 14,
        },
      ]
    },
    {
      name: 'Dinámicas',
      time: 11 * 60 + 44,
      sub: [
        {
          name: 'Introducción',
          time: 11 * 60 + 44,
        },
        {
          name: 'Cambio de dirección',
          time: 12 * 60 + 3,
        },
        {
          name: 'Con fluidez',
          time: 14 * 60 + 22,
        },
        {
          name: 'Con música',
          time: 15 * 60 + 32,
        },
      ]
    },
    {
      name: 'Fortalecimiento',
      time: 16 * 60 + 26,
      sub: [
        {
          name: 'Introducción',
          time: 16 * 60 + 26,
        },
        {
          name: 'Base de Foot Work x 15 segs.',
          time: 16 * 60 + 58,
        },
        {
          name: 'Base derecha x 15 segs.',
          time: 17 * 60 + 20,
        },
        {
          name: 'Base izquierda x 15 segs.',
          time: 17 * 60 + 37,
        },
      ]
    },
    {
      name: 'Five Step',
      time: 18 * 60 + 9,
      sub: [
        {
          name: 'Introducción',
          time: 18 * 60 + 9,
        },
        {
          name: 'Movimiento de piés',
          time: 18 * 60 + 28,
        },
        {
          name: 'Cambio de lado',
          time: 19 * 60 + 50,
        },
        {
          name: 'Detalles',
          time: 21 * 60 + 3,
        },
        {
          name: 'Con música',
          time: 23 * 60 + 20,
        },
      ]
    },
    {
      name: 'Combinaciones',
      time: 24 * 60 + 11,
      sub: [
        {
          name: 'Introducción',
          time: 24 * 60 + 11,
        },
        {
          name: '3 repeticiones',
          time: 24 * 60 + 45,
        },
        {
          name: 'Cambio de lado',
          time: 25 * 60 + 29,
        },
        {
          name: 'Recomendaciones',
          time: 26 * 60 + 44,
        },
      ]
    },
  ],
},
{
  id: "045",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/045/Front/HLS/Session+045+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/045/Back/HLS/Session+045+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/045/Front/Thumbnails/Session+045+-+Custom-Poster.jpg',
  details: roaster[roasterMap.didack],
  category: categories[categoryMap.breaking],
  classType: {
    slug: ['warm-up']
  },
  videoInfo: {
    about: 'Preparación para el Breaking',
    description: 'Es muy importante que antes de cada sesión realices un calentamiento adecuado para evitar lesiones durante y después de tu entrenamiento.<br>En esta sesión Didack tiene para tí un calentamiento ¡al estilo Breaking!<br>El breaking, mejor conocido como Break Dance o B-boying o B-girling es una disciplina artística parte de la cultura Hip Hop.',
    relatesTo: 'Danza Acrobática, Baile Fitness, Danza Jazz, Ritmos Latinos, Calistenia',
    recommended: 'El breaking utiliza muchos movimientos dinámicos, todo tu cuerpo será expuesto a un ejercicio demandante por lo que es recomendable ejercitarlo y prepararlo antes de intentar estos movimientos.<br>Tal vez lo más característico de esta disciplina es que te permite expresar tus ideas, sentimientos y estados de ánimo mediante el baile.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['036', '018', '044'],
  sections: [
    {
      name: 'Pre-calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Cabeza',
          time: 44,
        },
        {
          name: 'Cuello',
          time: 1 * 60 + 34,
        },
        {
          name: 'Hombros',
          time: 2 * 60 + 34,
        },
        {
          name: 'Codos',
          time: 3 * 60 + 7,
        },
        {
          name: 'Manos',
          time: 3 * 60 + 36,
        },
        {
          name: 'Muñecas',
          time: 3 * 60 + 58,
        },
        {
          name: 'Cadera',
          time: 4 * 60 + 25,
        },
        {
          name: 'Cintura',
          time: 6 * 60 + 1,
        },
        {
          name: 'Rodillas',
          time: 6 * 60 + 28,
        },
        {
          name: 'Piés',
          time: 8 * 60 + 1,
        },
      ]
    },
    {
      name: 'Calentamiento',
      time: 9 * 60 + 44,
      sub: [
        {
          name: 'Introducción',
          time: 9 * 60 + 44,
        },
        {
          name: 'Saltos',
          time: 10 * 60 + 18,
        },
        {
          name: 'Mountain Climbers x 30 reps',
          time: 11 * 60 + 12,
        },
        {
          name: 'Postura I x 20 segs',
          time: 12 * 60 + 28,
        },
        {
          name: 'Postura II x 20 segs',
          time: 13 * 60 + 5,
        },
        {
          name: 'Postura III x 30 segs',
          time: 13 * 60 + 38,
        },
      ]
    },
    {
      name: 'Estiramiento',
      time: 14 * 60 + 21,
      sub: [
        {
          name: 'Introducción',
          time: 14 * 60 + 21,
        },
        {
          name: 'Cuello',
          time: 14 * 60 + 43,
        },
        {
          name: 'Hombros',
          time: 15 * 60 + 12,
        },
        {
          name: 'Torso',
          time: 16 * 60 + 0,
        },
        {
          name: 'Cadera',
          time: 16 * 60 + 23,
        },
        {
          name: 'Extensión de piernas',
          time: 17 * 60 + 43,
        },
        {
          name: 'Torsión de espalda',
          time: 18 * 60 + 36,
        },
        {
          name: 'Mariposas',
          time: 19 * 60 + 34,
        },
        {
          name: 'Toque de puntas en medio loto',
          time: 20 * 60 + 44,
        },
        {
          name: 'Squat',
          time: 22 * 60 + 45,
        },
        {
          name: 'Plegado',
          time: 23 * 60 + 25,
        },
        {
          name: "Child's pose",
          time: 23 * 60 + 51,
        },
        {
          name: 'Cobra',
          time: 24 * 60 + 15,
        },
        {
          name: 'Recomendaciones',
          time: 24 * 60 + 50,
        },
      ]
    },
  ],
},
{
  id: "046",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/046/Front/HLS/Session+046+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/046/Back/HLS/Session+046+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/046/Front/Thumbnails/Session+046+-+Custom-Poster.jpg',
  details: roaster[roasterMap.didack],
  category: categories[categoryMap.breaking],
  classType: {
    slug: ['movement']
  },
  videoInfo: {
    about: 'Back Rocks',
    description: 'Aprende a utilizar tu espalda para realizar movimientos de Breaking sobre el piso.<br>Es muy importante que antes de cada sesión realices un calentamiento adecuado para evitar lesiones durante y después de tu entrenamiento.<br>En esta sesión Didack tiene para tí un calentamiento ¡al estilo Breaking!<br>El breaking, mejor conocido como Break Dance o B-boying o B-girling es una disciplina artística parte de la cultura Hip Hop.',
    relatesTo: 'Danza Acrobática, Baile Fitness, Danza Jazz, Ritmos Latinos, Calistenia',
    recommended: 'El breaking utiliza muchos movimientos dinámicos, todo tu cuerpo será expuesto a un ejercicio demandante por lo que es recomendable ejercitarlo y prepararlo antes de intentar estos movimientos.<br>Tal vez lo más característico de esta disciplina es que te permite expresar tus ideas, sentimientos y estados de ánimo mediante el baile.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['045', '018', '040'],
  sections: [
    {
      name: 'Fortalecimiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Posición base',
          time: 56,
        },
        {
          name: 'Pelvis',
          time: 1 * 60 + 47,
        },
        {
          name: 'Extensión de piernas',
          time: 3 * 60 + 43,
        },
        {
          name: 'Elevación de pelvis con pierna estirada',
          time: 5 * 60 + 37,
        },
      ]
    },
    {
      name: 'Back Rock',
      time: 7 * 60 + 24,
      sub: [
        {
          name: 'Introducción',
          time: 7 * 60 + 24,
        },
        {
          name: 'Movimiento base',
          time: 7 * 60 + 26,
        },
        {
          name: 'Correcciones',
          time: 8 * 60 + 44,
        },
        {
          name: 'Con música',
          time: 9 * 60 + 57,
        },
      ]
    },
    {
      name: 'Variación I',
      time: 11 * 60 + 8,
      sub: [
        {
          name: 'Introducción',
          time: 11 * 60 + 8,
        },
        {
          name: 'Posición base',
          time: 11 * 60 + 31,
        },
        {
          name: 'Hacia ambos lados',
          time: 12 * 60 + 28,
        },
        {
          name: 'Correcciones',
          time: 13 * 60 + 8,
        },
        {
          name: 'Con música',
          time: 13 * 60 + 36,
        },
      ]
    },
    {
      name: 'Variación II',
      time: 14 * 60 + 16,
      sub: [
        {
          name: 'Introducción',
          time: 14 * 60 + 16,
        },
        {
          name: 'Posición base',
          time: 14 * 60 + 33,
        },
        {
          name: 'Sin apoyar pierna derecha',
          time: 16 * 60 + 20,
        },
        {
          name: 'Hacia ambos lados',
          time: 17 * 60 + 2,
        },
        {
          name: 'Con música',
          time: 18 * 60 + 7,
        },
        {
          name: 'Recomendaciones',
          time: 18 * 60 + 53,
        },
      ]
    },
    {
      name: 'Rutina',
      time: 19 * 60 + 28,
      sub: [
        {
          name: 'Introducción',
          time: 19 * 60 + 28,
        },
        {
          name: 'Back Rock hacia ambos lados',
          time: 20 * 60 + 14,
        },
        {
          name: 'Variación I hacia ambos lados',
          time: 20 * 60 + 40,
        },
        {
          name: 'Variación II hacia ambos lados',
          time: 20 * 60 + 58,
        },
        {
          name: 'Fluidez y combinaciones',
          time: 21 * 60 + 18,
        },
        {
          name: 'Variaciones',
          time: 23 * 60 + 15,
        },
        {
          name: 'Relajación',
          time: 23 * 60 + 55,
        },
        {
          name: 'Recomendaciones',
          time: 25 * 60 + 6,
        },
      ]
    },
  ],
},
{
  id: "047",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/047/Front/HLS/Session+047+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/047/Back/HLS/Session+047+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/047/Front/Thumbnails/Session+047+-+Custom-Poster.jpg',
  details: roaster[roasterMap.yuri],
  category: categories[categoryMap.yogakids],
  classType: {
    slug: ['movement']
  },
  videoInfo: {
    about: 'Puente, Mesa, Gato y Camello',
    description: 'En esta sesión aprenderemos otros cuatro movimientos Puente, Mesa, Gato y Camello. Además nos divertiremos con un divertido juego, solo necesitas una servilleta y un popote.',
    relatesTo: 'Yoga, Acroyoga, Flex',
    recommended: 'Es muy importante trabajar con la respiración, mientras más relajado te encuentres mejor podrás controlar tus emociones. <br> Puedes utilizar un globo o un juguete para ayudarte a visualizar tu respiración y poco a poco hacerlo de forma más conciente por tu cuenta.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: 'Tapete de Yoga, Servilleta, Popote',
    audience: 'Todo tipo de público.',
    rate: '[A]',
    soundtrack: 'And The Sun Will Come Out Tomorrow &copy; 2020 D-NS Studio, by Carlos Vivanco.<br>Photograph &copy; by Ed Sheeran.',
  },
  related: ['005', '010', '039'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Cabeza',
          time: 24,
        },
        {
          name: 'Hombros',
          time: 1 * 60 + 57,
        },
        {
          name: 'Cadera',
          time: 2 * 60 + 23,
        },
        {
          name: 'Rodillas',
          time: 2 * 60 + 54,
        },
        {
          name: 'Piés',
          time: 3 * 60 + 8,
        },
        {
          name: 'Saltos de Tijera',
          time: 3 * 60 + 33,
        },
        {
          name: 'Saludos al Sol',
          time: 4 * 60 + 35,
        },
      ]
    },
    {
      name: 'Puente',
      time: 6 * 60 + 43,
      sub: [
        {
          name: 'Introducción',
          time: 6 * 60 + 43,
        },
        {
          name: 'Preparación',
          time: 7 * 60 + 7,
        },
        {
          name: 'Postura inicial',
          time: 8 * 60 + 18,
        },
      ]
    },
    {
      name: 'Mesa',
      time: 10 * 60 + 29,
      sub: [
        {
          name: 'Introducción',
          time: 10 * 60 + 29,
        },
        {
          name: 'Postura inicial',
          time: 10 * 60 + 40,
        },
        {
          name: 'A una mano',
          time: 10 * 60 + 48,
        },
        {
          name: 'Descanso',
          time: 12 * 60 + 40,
        },
      ]
    },
    {
      name: 'Gato',
      time: 13 * 60 + 0,
      sub: [
        {
          name: 'Introducción',
          time: 13 * 60 + 0,
        },
        {
          name: 'Postura inhalación',
          time: 13 * 60 + 22,
        },
        {
          name: 'Postura exhalación',
          time: 13 * 60 + 33,
        },
      ]
    },
    {
      name: 'Camello',
      time: 14 * 60 + 54,
      sub: [
        {
          name: 'Introducción',
          time: 14 * 60 + 54,
        },
        {
          name: 'Postura inicial',
          time: 15 * 60 + 0,
        },
        {
          name: 'A una mano',
          time: 15 * 60 + 29,
        },
        {
          name: 'Postura para principiantes',
          time: 16 * 60 + 1,
        },
        {
          name: 'Descanso',
          time: 16 * 60 + 40,
        },
      ]
    },
    {
      name: 'Juego con Popote',
      time: 17 * 60 + 28,
      sub: [
        {
          name: 'Introducción',
          time: 17 * 60 + 28,
        },
        {
          name: 'Bolitas con una servilleta',
          time: 17 * 60 + 38,
        },
        {
          name: 'Aventar con el popote',
          time: 17 * 60 + 52,
        },
        {
          name: 'Meditación',
          time: 19 * 60 + 20,
        },
      ]
    },
  ],
},
{
  id: "048",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/048/Front/HLS/Session+048+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/048/Back/HLS/Session+048+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/048/Front/Thumbnails/Session+048+-+Custom-Poster.jpg',
  details: roaster[roasterMap['johnatan']],
  category: categories[categoryMap.yoga],
  classType: {
    slug: ['skill']
  },
  videoInfo: {
    about: 'Saludo al Sol',
    description: 'En esta sesión John desglosa paso a paso todos los movimientos del Saludos al Sol.',
    relatesTo: 'Danza, Yoga Kids, Calistenia, AcroYoga, Flex',
    recommended: 'Al final es esta sesión dominarás completamente el Saludo al Sol y podrás ponerlo en práctica sin mayor problema en tus entrenamientos. <br>El calentamiento articular en esta sesión te permitirán relajar y activar varios grupos musculares de tu cuerpo.<br>Al realizar las posturas de guerreros empezarás a notar mejorías y cambios en tu cuerpo, pero lo más importante podrás trabajar tus músculos y ganar flexibilidad al mismo tiempo.<br>Con el trabajo cardiovascular de esta sesión puedes mejorar tu condición física y fortalecer tu cuerpo.',
    tools: 'Puedes cambiar la cámara frontal a la trasera para apreciar mejor los movimientos. <br>Activa el modo espejo cuando tengas que realizar movimientos con los lados izquierdo o derecho.',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['004', '005', '047'],
  sections: [
    {
      name: 'Teoría',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: '¿Qué es el Saludo al Sol?',
          time: 57,
        },
      ]
    },
    {
      name: 'Asanas',
      time: 1 * 60 + 59,
      sub: [
        {
          name: 'Postura de Montaña',
          time: 1 * 60 + 59,
        },
        {
          name: 'Saludo hacia arriba',
          time: 10 * 60 + 7,
        },
        {
          name: 'Inclinación al frente',
          time: 11 * 60 + 43,
        },
        {
          name: 'Guerrero',
          time: 15 * 60 + 41,
        },
        {
          name: 'Postura de Plancha',
          time: 16 * 60 + 10,
        },
        {
          name: 'Cobra',
          time: 17 * 60 + 33,
        },
        {
          name: 'Perro mirando abajo',
          time: 19 * 60 + 50,
        },
        {
          name: 'Postura de Montaña',
          time: 21 * 60 + 9,
        },
      ]
    },
    {
      name: 'Saludo al Sol',
      time: 22 * 60 + 15,
      sub: [
        {
          name: 'Introducción',
          time: 22 * 60 + 15,
        },
        {
          name: 'Ejecución',
          time: 22 * 60 + 59,
        },
        {
          name: 'Recomendaciones',
          time: 24 * 60 + 24,
        },
      ]
    },
    {
      name: 'Serie de Saludos al Sol',
      time: 26 * 60 + 48,
      sub: [
        {
          name: 'Introducción',
          time: 26 * 60 + 48,
        },
        {
          name: 'Inicio de la Serie',
          time: 26 * 60 + 55,
        },
        {
          name: 'Recomendaciones',
          time: 29 * 60 + 35,
        },
      ]
    },
  ],
},
{
  id: "049",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/049/Front/HLS/Session+049+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/049/Back/HLS/Session+049+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/049/Front/Thumbnails/Session+049+-+Custom-Poster.jpg',
  details: roaster[roasterMap['johnatan']],
  category: categories[categoryMap.yoga],
  classType: {
    slug: ['training', 're-hab']
  },
  videoInfo: {
    about: 'Flexibilidad de Espalda',
    description: 'Si pasas mucho tiempo sentado, en casa o en la oficina, acompañanos a realizar estos ejercicios que te ayudarán a relajar tu espalda.',
    relatesTo: 'Danza, Yoga Kids, Calistenia, AcroYoga, Flex',
    recommended: 'Si sufres de dolores de cuello o espalda, te recomendamos realizar esta serie de movimientos de manera rutinaria, para empezar a relajar los músculos de la espalda y que el dolor vaya reduciendose gradualmente.<br>El calentamiento articular en esta sesión te permitirán relajar y activar varios grupos musculares de tu cuerpo.<br>Al realizar las posturas de guerreros empezarás a notar mejorías y cambios en tu cuerpo, pero lo más importante podrás trabajar tus músculos y ganar flexibilidad al mismo tiempo.<br>Con el trabajo cardiovascular de esta sesión puedes mejorar tu condición física y fortalecer tu cuerpo.',
    tools: 'Puedes cambiar la cámara frontal a la trasera para apreciar mejor los movimientos. <br>Activa el modo espejo cuando tengas que realizar movimientos con los lados izquierdo o derecho.',
    equipment: 'Tapete de Yoga, Palo de escoba',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['005', '048', '009'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Brazos arriba',
          time: 1 * 60 + 56,
        },
        {
          name: 'Flexiones detrás de la espalda',
          time: 2 * 60 + 37,
        },
        {
          name: 'Codos flexionados x 10 tiempos',
          time: 3 * 60 + 14,
        },
        {
          name: 'Giros hacia atrás',
          time: 3 * 60 + 34,
        },
        {
          name: 'Recomendaciones',
          time: 5 * 60 + 16,
        },
        {
          name: 'Extensión de espalda I x 10 tiempos',
          time: 5 * 60 + 32,
        },
        {
          name: 'Extensión de espalda II x 10 tiempos',
          time: 5 * 60 + 59,
        },
        {
          name: 'Extensión con brazos arriba x 10 tiempos',
          time: 6 * 60 + 10,
        },
        {
          name: 'Extensión con brazos hacia atrás',
          time: 6 * 60 + 33,
        },
        {
          name: 'Extensión cerrada con brazos hacia arriba',
          time: 7 * 60 + 6,
        },
      ]
    },
    {
      name: 'Flexibilidad',
      time: 7 * 60 + 49,
      sub: [
        {
          name: 'Introducción',
          time: 7 * 60 + 49,
        },
        {
          name: 'Postura en piernas cruzadas',
          time: 8 * 60 + 11,
        },
        {
          name: 'Giro sobre el hombro',
          time: 8 * 60 + 50,
        },
        {
          name: 'Extensión al frente',
          time: 10 * 60 + 32,
        },
        {
          name: 'Extensión hacia atrás con mano arriba',
          time: 11 * 60 + 18,
        },
        {
          name: 'Extensión hacia atrás con codos',
          time: 13 * 60 + 2,
        },
        {
          name: 'Extensión hacia atrás',
          time: 13 * 60 + 30,
        },
        {
          name: 'Extensión de costado',
          time: 14 * 60 + 10,
        },
        {
          name: 'Extensión con brazos hacia arriba',
          time: 16 * 60 + 28,
        },
      ]
    },
    {
      name: 'Perro mirando abajo',
      time: 17 * 60 + 20,
      sub: [
        {
          name: 'Postura inicial',
          time: 17 * 60 + 20,
        },
        {
          name: 'Corrección de la postura',
          time: 18 * 60 + 35,
        },
        {
          name: 'Pierna estirada',
          time: 20 * 60 + 13,
        },
        {
          name: 'Apertura de cadera',
          time: 20 * 60 + 51,
        },
        {
          name: 'Mano a pantorrilla',
          time: 21 * 60 + 45,
        },
        {
          name: 'Mano a pantorrilla cruzada',
          time: 22 * 60 + 35,
        },
        {
          name: 'Cobra',
          time: 23 * 60 + 48,
        },
        {
          name: 'Extensión de Espalda',
          time: 25 * 60 + 22,
        },
        {
          name: 'Rodillas al pecho',
          time: 27 * 60 + 58,
        },
        {
          name: 'Recomendaciones',
          time: 28 * 60 + 43,
        },
      ]
    },
  ],
},
{
  id: "050",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/050/Front/HLS/Session+050+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/050/Back/HLS/Session+050+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/050/Front/Thumbnails/Session+050+-+Custom-Poster.jpg',
  details: roaster[roasterMap['johnatan']],
  category: categories[categoryMap.yoga],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Relajación Lumbar',
    description: 'Con ayuda de un tapete y una pared te mostramos como puedes relajar tu espalda baja.',
    relatesTo: 'Danza, Yoga Kids, Calistenia, AcroYoga, Flex',
    recommended: 'Esta serie de ejercicios está enfocada en relajar tu espalda baja, te recomendamos realizarlos al menos una vez por semana.<br>El calentamiento articular en esta sesión te permitirán relajar y activar varios grupos musculares de tu cuerpo.<br>Al realizar las posturas de guerreros empezarás a notar mejorías y cambios en tu cuerpo, pero lo más importante podrás trabajar tus músculos y ganar flexibilidad al mismo tiempo.<br>Con el trabajo cardiovascular de esta sesión puedes mejorar tu condición física y fortalecer tu cuerpo.',
    tools: 'Puedes cambiar la cámara frontal a la trasera para apreciar mejor los movimientos. <br>Activa el modo espejo cuando tengas que realizar movimientos con los lados izquierdo o derecho.',
    equipment: 'Tapete de Yoga, Pared',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['005', '048', '049'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Colocación del Tapete',
          time: 41,
        },
        {
          name: 'Posición inicial',
          time: 1 * 60 + 32,
        },
        {
          name: 'Extensiónes con rodilla flexionada',
          time: 2 * 60 + 40,
        },
        {
          name: 'Medio puente en pared',
          time: 6 * 60 + 5,
        },
        {
          name: 'Medio puente en pared con pierna estirada',
          time: 7 * 60 + 23,
        },
        {
          name: 'Elevación de cadera',
          time: 8 * 60 + 5,
        },
        {
          name: 'Extensión de pierna en pared',
          time: 9 * 60 + 4,
        },
        {
          name: 'Posición de Arado',
          time: 10 * 60 + 9,
        },
        {
          name: 'Mariposa en pared',
          time: 11 * 60 + 57,
        },
        {
          name: 'Medio loto en pared',
          time: 12 * 60 + 35,
        },
      ]
    },
    {
      name: 'Asanas',
      time: 14 * 60 + 9,
      sub: [
        {
          name: 'Introducción',
          time: 14 * 60 + 9,
        },
        {
          name: 'Posición del Corredor',
          time: 14 * 60 + 35,
        },
        {
          name: 'Mano izquierda por dentro',
          time: 16 * 60 + 11,
        },
        {
          name: 'Codo derecho al piso',
          time: 16 * 60 + 57,
        },
        {
          name: 'Extensión de brazo hacia arriba',
          time: 17 * 60 + 37,
        },
        {
          name: 'Perro mirando abajo',
          time: 18 * 60 + 10,
        },
        {
          name: 'Posición del Corredor',
          time: 18 * 60 + 39,
        },
        {
          name: 'Diagonal mano a pié',
          time: 21 * 60 + 55,
        },
        {
          name: 'Perro mirando abajo',
          time: 23 * 60 + 13,
        },
        {
          name: "Child's pose extendida",
          time: 25 * 60 + 17,
        },
        {
          name: 'Recomendaciones',
          time: 26 * 60 + 14,
        },
      ]
    },
  ],
},
{
  id: "051",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/051/Front/HLS/Session+051+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/051/Back/HLS/Session+051+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/051/Front/Thumbnails/Session+051+-+Custom-Poster.jpg',
  details: roaster[roasterMap["javier-basilio"]],
  category: categories[categoryMap.defensapersonal],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Aplicación de la Posición de Sumisión',
    description: 'En esta sesión ponemos en práctica la posición de sumisión y agregamos el elemento de toma de control.<br>Tenemos que aprender a evitar las confrontaciones mediante la comunicación, pero si ya no hay más opciones en esta sesión te enseñamos una postura básica que te ayudará a defenderte ante una agresión.<br>La violencia genera más violencia y aquí te enseñaremos técnicas para evitar las agresiones en general.',
    relatesTo: 'Yoga, Calistenia, Flex',
    recommended: 'En defensa personal lo más importante es conservar la vida, para eso nos enfocamos en la prevención de situaciones de riesgo y cómo actuar cuando no pudimos evitar una.<br>Aprende a cómo prevenir agresiones y sobre la diferencia entre Deportes de contacto y la defensa personal.',
    tools: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['029', '020', '033'],
  sections: [
    {
      name: 'Posición de Sumisión',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Importancia de la verbalización',
          time: 2 * 60 + 35,
        },
        {
          name: 'Reducir la escalada de violencia',
          time: 4 * 60 + 49,
        },
        {
          name: 'Posicionamiento correcto',
          time: 6 * 60 + 12,
        },
      ]
    },
    {
      name: 'Reacción ante una situación de stress',
      time: 11 * 60 + 40,
      sub: [
        {
          name: 'Introducción',
          time: 11 * 60 + 40,
        },
        {
          name: 'Posición de Sumisión al contacto',
          time: 11 * 60 + 59,
        },
        {
          name: 'Atención a las manos y diálogo',
          time: 12 * 60 + 27,
        },
        {
          name: 'Reacción ante el Stress',
          time: 13 * 60 + 25,
        },
        {
          name: 'Ejercicios para reaccionar ante Stress',
          time: 16 * 60 + 47,
        },
      ]
    },
    {
      name: 'Toma de Control',
      time: 17 * 60 + 3,
      sub: [
        {
          name: 'Introducción',
          time: 17 * 60 + 3,
        },
        {
          name: 'Acortar distancia',
          time: 19 * 60 + 16,
        },
        {
          name: 'Agarre con mano derecha',
          time: 20 * 60 + 13,
        },
        {
          name: 'Sujetar con izquierda',
          time: 20 * 60 + 24,
        },
        {
          name: 'Cabeza al hombro',
          time: 21 * 60 + 16,
        },
        {
          name: 'Aplicación',
          time: 22 * 60 + 8,
        },
        {
          name: 'Reinicio del ciclo ORDA',
          time: 22 * 60 + 42,
        },
      ]
    },
    {
      name: 'En práctica',
      time: 24 * 60 + 34,
      sub: [
        {
          name: 'Introducción',
          time: 24 * 60 + 34,
        },
        {
          name: 'Retroalimentación',
          time: 25 * 60 + 5,
        },
        {
          name: 'Correcciones',
          time: 26 * 60 + 20,
        },
      ]
    }
  ],
},
{
  id: "052",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/052/Front/HLS/Session+052+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/052/Back/HLS/Session+052+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/052/Front/Thumbnails/Session+052+-+Custom-Poster.jpg',
  details: roaster[roasterMap.didack],
  category: categories[categoryMap.breaking],
  classType: {
    slug: ['movement']
  },
  videoInfo: {
    about: 'Basic Rock',
    description: 'Amplia tu repertorio de Top Rocks con este movimiento, y aprende a combinarlo con otros pasos básicos como el Salsa Step.<br>Es muy importante que antes de cada sesión realices un calentamiento adecuado para evitar lesiones durante y después de tu entrenamiento.<br>En esta sesión Didack tiene para tí un calentamiento ¡al estilo Breaking!<br>El breaking, mejor conocido como Break Dance o B-boying o B-girling es una disciplina artística parte de la cultura Hip Hop.',
    relatesTo: 'Danza Acrobática, Baile Fitness, Danza Jazz, Ritmos Latinos, Calistenia',
    recommended: 'El breaking utiliza muchos movimientos dinámicos, todo tu cuerpo será expuesto a un ejercicio demandante por lo que es recomendable ejercitarlo y prepararlo antes de intentar estos movimientos.<br>Tal vez lo más característico de esta disciplina es que te permite expresar tus ideas, sentimientos y estados de ánimo mediante el baile.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['046', '018', '040'],
  sections: [
    {
      name: 'Pre-calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Cintura',
          time: 36,
        },
        {
          name: 'Piés',
          time: 1 * 60 + 8,
        },
      ]
    },
    {
      name: 'Basic Rock / Crossover',
      time: 1 * 60 + 50,
      sub: [
        {
          name: 'Introducción',
          time: 1 * 60 + 50,
        },
        {
          name: 'Movimiento base',
          time: 2 * 60 + 10,
        },
        {
          name: 'Con fluidez',
          time: 3 * 60 + 38,
        },
        {
          name: 'Con bouncing',
          time: 3 * 60 + 48,
        },
        {
          name: 'Con música',
          time: 4 * 60 + 45,
        },
        {
          name: 'Detalles',
          time: 5 * 60 + 18,
        },
      ]
    },
    {
      name: 'Basic Rock a los lados',
      time: 6 * 60 + 46,
      sub: [
        {
          name: 'Desglose del movimiento',
          time: 6 * 60 + 46,
        },
        {
          name: 'Hacia ambos lados con fluidez',
          time: 8 * 60 + 17,
        },
        {
          name: 'Cadereo',
          time: 8 * 60 + 44,
        },
        {
          name: 'Movimientos de las manos',
          time: 9 * 60 + 21,
        },
        {
          name: 'Dobles',
          time: 10 * 60 + 40,
        },
      ]
    },
    {
      name: 'Rutina',
      time: 12 * 60 + 0,
      sub: [
        {
          name: 'Introducción',
          time: 12 * 60 + 0,
        },
        {
          name: 'Basic Rock / Crossover',
          time: 12 * 60 + 20,
        },
        {
          name: 'Con patada',
          time: 12 * 60 + 34,
        },
        {
          name: 'Hacia los lados',
          time: 12 * 60 + 41,
        },
        {
          name: 'Dobles',
          time: 12 * 60 + 48,
        },
        {
          name: 'Con música',
          time: 13 * 60 + 24,
        },
      ]
    },
    {
      name: 'Dinámicas',
      time: 14 * 60 + 18,
      sub: [
        {
          name: 'Introducción',
          time: 14 * 60 + 18,
        },
        {
          name: 'Crossover al frente',
          time: 14 * 60 + 30,
        },
        {
          name: 'Crossover hacia atrás',
          time: 15 * 60 + 32,
        },
        {
          name: 'Crossover laterales',
          time: 17 * 60 + 8,
        },
        {
          name: 'Con música',
          time: 18 * 60 + 39,
        },
      ]
    },
    {
      name: 'Ensamble',
      time: 19 * 60 + 50,
      sub: [
        {
          name: 'Introducción',
          time: 19 * 60 + 50,
        },
        {
          name: 'Cross Step',
          time: 20 * 60 + 36,
        },
        {
          name: 'Crossover',
          time: 20 * 60 + 40,
        },
        {
          name: 'Salsa Step',
          time: 21 * 60 + 16,
        },
        {
          name: 'Salsa Back',
          time: 22 * 60 + 43,
        },
        {
          name: 'Salsa Front',
          time: 22 * 60 + 43,
        },
        {
          name: 'Sin música',
          time: 24 * 60 + 42,
        },
        {
          name: 'Con música',
          time: 26 * 60 + 3,
        },
        {
          name: 'Recomendaciones',
          time: 27 * 60 + 20,
        },
      ]
    },
  ],
},
{
  id: "053",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/053/Front/HLS/Session+053+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/053/Back/HLS/Session+053+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/053/Front/Thumbnails/Session+053+-+Custom-Poster.jpg',
  details: roaster[roasterMap.didack],
  category: categories[categoryMap.breaking],
  classType: {
    slug: ['movement']
  },
  videoInfo: {
    about: 'Shuffle',
    description: 'En esta sesión nos enfocaremos en el Foot Work, principalmente con el movimiento llamado Shuffle o conocido también como Scramble.<br>Es muy importante que antes de cada sesión realices un calentamiento adecuado para evitar lesiones durante y después de tu entrenamiento.<br>En esta sesión Didack tiene para tí un calentamiento ¡al estilo Breaking!<br>El breaking, mejor conocido como Break Dance o B-boying o B-girling es una disciplina artística parte de la cultura Hip Hop.',
    relatesTo: 'Danza Acrobática, Baile Fitness, Danza Jazz, Ritmos Latinos, Calistenia',
    recommended: 'El breaking utiliza muchos movimientos dinámicos, todo tu cuerpo será expuesto a un ejercicio demandante por lo que es recomendable ejercitarlo y prepararlo antes de intentar estos movimientos.<br>Tal vez lo más característico de esta disciplina es que te permite expresar tus ideas, sentimientos y estados de ánimo mediante el baile.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['046', '018', '052'],
  sections: [
    {
      name: 'Pre-calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Posición de Foot Work',
          time: 46,
        },
        {
          name: 'Lado a lado',
          time: 1 * 60 + 13,
        },
        {
          name: 'Estiramiento de Pelvis',
          time: 1 * 60 + 39,
        },
      ]
    },
    {
      name: 'Scrambles Laterales',
      time: 2 * 60 + 8,
      sub: [
        {
          name: 'Introducción',
          time: 2 * 60 + 8,
        },
        {
          name: 'Posición inicial',
          time: 2 * 60 + 39,
        },
        {
          name: 'Hook',
          time: 2 * 60 + 54,
        },
        {
          name: 'Scramble',
          time: 3 * 60 + 1,
        },
        {
          name: 'Sling',
          time: 3 * 60 + 54,
        },
        {
          name: 'Cambio de lado',
          time: 4 * 60 + 54,
        },
        {
          name: 'Con música',
          time: 6 * 60 + 19,
        },
      ]
    },
    {
      name: 'Scrambles hacia atrás',
      time: 7 * 60 + 55,
      sub: [
        {
          name: 'Introducción',
          time: 7 * 60 + 55,
        },
        {
          name: 'Posición inicial',
          time: 8 * 60 + 13,
        },
        {
          name: 'Scrambles',
          time: 8 * 60 + 25,
        },
        {
          name: 'Cruzados',
          time: 8 * 60 + 44,
        },
        {
          name: 'Con música',
          time: 9 * 60 + 11,
        },
      ]
    },
    {
      name: 'Walking',
      time: 9 * 60 + 56,
      sub: [
        {
          name: 'Introducción',
          time: 9 * 60 + 56,
        },
        {
          name: 'Desplazamiento',
          time: 10 * 60 + 25,
        },
        {
          name: 'Desplazamiento en foot work',
          time: 11 * 60 + 35,
        },
        {
          name: 'Movimiento de las manos',
          time: 11 * 60 + 59,
        },
        {
          name: 'Con música',
          time: 13 * 60 + 18,
        },
      ]
    },
    {
      name: 'Variación con rodilla',
      time: 13 * 60 + 56,
      sub: [
        {
          name: 'Introducción',
          time: 13 * 60 + 56,
        },
        {
          name: 'Desplazamiento en foot work',
          time: 14 * 60 + 11,
        },
        {
          name: 'Cambio de lado',
          time: 15 * 60 + 44,
        },
        {
          name: 'Con música',
          time: 16 * 60 + 8,
        },
      ]
    },
    {
      name: 'Ensamble',
      time: 16 * 60 + 59,
      sub: [
        {
          name: 'Introducción',
          time: 16 * 60 + 59,
        },
        {
          name: 'Combinación de Shuffles',
          time: 17 * 60 + 39,
        },
        {
          name: 'Con música',
          time: 19 * 60 + 34,
        },
        {
          name: 'Combinaciónes con One Step y Six Step',
          time: 20 * 60 + 21,
        },
        {
          name: 'Recomendaciones',
          time: 23 * 60 + 46,
        },
      ]
    },
  ],
},
{
  id: "054",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/054/Front/HLS/Session+054+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/054/Back/HLS/Session+054+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/054/Front/Thumbnails/Session+054+-+Custom-Poster.jpg',
  details: roaster[roasterMap.ekbars],
  category: categories[categoryMap.calistenia],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Full Body VI',
    description: 'Continuamos con las rutinas de adaptación neuro-muscular, recueda realizarlas en el orden recomendado y si necesitas pasar más tiempo en alguna hasta que la tengas dominada hazlo. La progresión neuro-muscular te permitirá adaptar tu cuerpo a los movimientos que utilizaremos en las rutinas.<br>Esta progresión es necesaria antes de intentar realizar rutinas de nivel intermedio, ya que lo que buscamos es realizar pocos ejercicios con posturas que se acerquen a la perfección en lugar de hacer muchas repeticiones con posturas incorrectas.<br>Recuerda que antes de iniciar cada rutina tienes que realizar un calentamiento previo, para esto tenemos las diferentes sesiones que abordan calentamientos generales o específicos dependiendo la zona que vas a trabajar.',
    relatesTo: 'Baile Fitness, Gimnasia, Danza, Flex',
    recommended: '',
    tools: '',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['020', '030', '008'],
  sections: [
    {
      name: 'Movimientos',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Push ups en desnivel',
          time: 1 * 60 + 0,
        },
        {
          name: 'Sentadillas asistidas',
          time: 1 * 60 + 58,
        },
        {
          name: 'Planchas con antebrazos estirados',
          time: 3 * 60 + 1,
        },
        {
          name: 'Australian Pull-ups',
          time: 3 * 60 + 38,
        },
        {
          name: 'Hip thrust libre',
          time: 4 * 60 + 46,
        },
      ]
    },
    {
      name: 'AMRAP - 25 mins.',
      time: 5 * 60 + 18,
      sub: [
        {
          name: 'Introducción',
          time: 5 * 60 + 18,
        },
        {
          name: 'Push ups en desnivel x 12 reps',
          time: 5 * 60 + 31,
        },
        {
          name: 'Sentadillas asistidas x 16 reps',
          time: 6 * 60 + 14,
        },
        {
          name: 'Planchas con antebrazos estirados x 30 segs',
          time: 7 * 60 + 20,
        },
        {
          name: 'Australian Pull-ups x 12 reps',
          time: 8 * 60 + 12,
        },
        {
          name: 'Hip thrust libre x 16 reps',
          time: 8 * 60 + 59,
        },
        {
          name: 'Recomendaciones',
          time: 29 * 60 + 6,
        },
      ]
    },
  ],
},
{
  id: "055",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/055/Front/HLS/Session+055+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/055/Back/HLS/Session+055+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/055/Front/Thumbnails/Session+055+-+Custom-Poster.jpg',
  details: roaster[roasterMap["angie-campirano"]],
  category: categories[categoryMap.flex],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Elongación del tren inferior',
    description: 'Entrena Flex para mejorar la elasticidad de articulaciones, músculos y ligamentos del tren inferior para poder tener una mayor apertura lateral en tu Squat.<br>En esta sesión continuamos con la progresión mejorar la flexibilidad de músculus y articulaciones.',
    relatesTo: 'Gimnasia, Yoga, Calentamiento, Danza, Calistenia',
    recommended: 'Antes de realizar estos movimientos, siempre tienes que realizar un calentamiento previo, puedes iniciar con un calentamiento para tren inferior primero.<br><br>Esta es una sesión ideal para principiantes que buscan mejorar su flexibilidad.<br><br>Lograr una mejor flexibilidad es un trabajo de constancia, no hay una receta mágica por lo que te recomendamos ser paciente y trabajar estos ejercicios al menos 2 veces por semana.',
    tools: '',
    equipment: 'Tapete de Yoga',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['024', '015', '031'],
  sections: [
    {
      name: 'Aumento de Temperatura',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Jumping Jacks',
          time: 56,
        },
        {
          name: 'Drop Squat',
          time: 2 * 60 + 33,
        },
        {
          name: 'Crunch Laterales',
          time: 4 * 60 + 20,
        },
        {
          name: 'Squat desde plancha',
          time: 6 * 60 + 0,
        },
        {
          name: 'Tijeras',
          time: 8 * 60 + 21,
        },
      ]
    },
    {
      name: 'Movimiento Articular',
      time: 9 * 60 + 45,
      sub: [
        {
          name: 'Introducción',
          time: 9 * 60 + 45,
        },
        {
          name: 'Rotación de cadera',
          time: 10 * 60 + 19,
        },
        {
          name: 'Flexión de rodillas',
          time: 12 * 60 + 58,
        },
        {
          name: 'Circulos a una pierna',
          time: 15 * 60 + 15,
        },
        {
          name: 'Elevación alternada rodilla - pierna',
          time: 18 * 60 + 8,
        },
      ]
    },
    {
      name: 'Elasticidad',
      time: 20 * 60 + 16,
      sub: [
        {
          name: 'Introducción',
          time: 20 * 60 + 16,
        },
        {
          name: 'Sentadilla con abducción lateral',
          time: 20 * 60 + 27,
        },
        {
          name: 'Abrir y cerrar en mariposa',
          time: 22 * 60 + 15,
        },
        {
          name: 'Cruces con apertura de piernas',
          time: 24 * 60 + 33,
        },
        {
          name: 'Flexiones al piso',
          time: 26 * 60 + 6,
        },
        {
          name: "Crunches en extensión de piernas",
          time: 28 * 60 + 16,
        },
      ]
    },
    {
      name: 'Estiramiento',
      time: 29 * 60 + 59,
      sub: [
        {
          name: 'Introducción',
          time: 30 * 60 + 9,
        },
        {
          name: 'Pancake',
          time: 30 * 60 + 54,
        },
        {
          name: 'Ranita',
          time: 33 * 60 + 25,
        },
        {
          name: 'Squat',
          time: 36 * 60 + 3,
        },
        {
          name: 'Recomendaciones',
          time: 38 * 60 + 27,
        },
      ]
    },
  ],
},
{
  id: "056",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/056/Front/HLS/Session+056+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/056/Back/HLS/Session+056+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/056/Front/Thumbnails/Session+056+-+Custom-Poster.jpg',
  details: roaster[roasterMap.ekbars],
  category: categories[categoryMap.calistenia],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Full Body VII',
    description: 'Esta es la última rutina de adaptación neuro-muscular, es la forma más fácil en la que tu cuerpo y tu mente se van a acondicionar para empezar a realizar ejercicios de calistenia, aprendiendo la forma y posturas correctas de realizar los ejercicios básicos. Recueda realizarlas en el orden recomendado y si necesitas pasar más tiempo en alguna hasta que la tengas dominada hazlo. La progresión neuro-muscular te permitirá adaptar tu cuerpo a los movimientos que utilizaremos en las rutinas.<br>Esta progresión es necesaria antes de intentar realizar rutinas de nivel intermedio, ya que lo que buscamos es realizar pocos ejercicios con posturas que se acerquen a la perfección en lugar de hacer muchas repeticiones con posturas incorrectas.<br>Recuerda que antes de iniciar cada rutina tienes que realizar un calentamiento previo, para esto tenemos las diferentes sesiones que abordan calentamientos generales o específicos dependiendo la zona que vas a trabajar.',
    relatesTo: 'Baile Fitness, Gimnasia, Danza, Flex',
    recommended: '',
    tools: '',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['020', '030', '054'],
  sections: [
    {
      name: 'Movimientos',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Push ups con rodillas',
          time: 52,
        },
        {
          name: 'Sentadillas asistidas',
          time: 1 * 60 + 33,
        },
        {
          name: 'Planchas con antebrazos',
          time: 2 * 60 + 12,
        },
        {
          name: 'Superman con jalón',
          time: 2 * 60 + 48,
        },
        {
          name: 'Hip thrust en silla',
          time: 3 * 60 + 33,
        },
      ]
    },
    {
      name: '6 Series - 30 segs x 30 segs',
      time: 4 * 60 + 19,
      sub: [
        {
          name: 'Introducción',
          time: 4 * 60 + 19,
        },
        {
          name: 'Push ups con rodillas x 30 segs',
          time: 4 * 60 + 29,
        },
        {
          name: 'Sentadillas asistidas x 30 segs',
          time: 6 * 60 + 9,
        },
        {
          name: 'Planchas con antebrazos x 30 segs',
          time: 7 * 60 + 10,
        },
        {
          name: 'Superman con jalón x 30 segs',
          time: 8 * 60 + 2,
        },
        {
          name: 'Hip thrust en silla x 30 segs',
          time: 9 * 60 + 6,
        },
      ]
    },
  ],
},
{
  id: "057",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/057/Front/HLS/Session+057+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/057/Back/HLS/Session+057+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/057/Front/Thumbnails/Session+057+-+Custom-Poster.jpg',
  details: roaster[roasterMap["javier-basilio"]],
  category: categories[categoryMap.defensapersonal],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Safe de muñecas',
    description: 'En esta clase te mostraremos la forma en la que puedes liberarte de un atacante cuando te quiera tomar por las muñecas.<br>Esta sesión va dirigida principalmente a las mujeres ya que tomar por las muñecas es una forma frecuente de iniciar una agresión contra las mujeres.<br>Tenemos que aprender a evitar las confrontaciones mediante la comunicación, pero si ya no hay más opciones en esta sesión te enseñamos una postura básica que te ayudará a defenderte ante una agresión.<br>La violencia genera más violencia y aquí te enseñaremos técnicas para evitar las agresiones en general.',
    relatesTo: 'Calistenia',
    recommended: 'En defensa personal lo más importante es conservar la vida, para eso nos enfocamos en la prevención de situaciones de riesgo y cómo actuar cuando no pudimos evitar una.<br>Aprende a cómo prevenir agresiones y sobre la diferencia entre Deportes de contacto y la defensa personal.',
    tools: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['051', '020', '033'],
  sections: [
    {
      name: 'Errores comunes',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Poner resistencia',
          time: 1 * 60 + 26,
        },
        {
          name: 'Tratar de liberarse',
          time: 2 * 60 + 33,
        },
      ]
    },
    {
      name: 'Safe de muñecas I',
      time: 4 * 60 + 32,
      sub: [
        {
          name: 'Introducción',
          time: 4 * 60 + 32,
        },
        {
          name: 'Posición de Sumisión',
          time: 4 * 60 + 39,
        },
        {
          name: 'Toma de control',
          time: 5 * 60 + 50,
        },
        {
          name: 'Paso uno',
          time: 7 * 60 + 25,
        },
        {
          name: 'Paso dos',
          time: 7 * 60 + 54,
        },
        {
          name: 'Fluido',
          time: 8 * 60 + 54,
        },
        {
          name: 'Simulación de situación de riesgo',
          time: 9 * 60 + 53,
        },
      ]
    },
    {
      name: 'Safe de muñecas II',
      time: 11 * 60 + 16,
      sub: [
        {
          name: 'Introducción',
          time: 11 * 60 + 16,
        },
        {
          name: 'Toma de control',
          time: 12 * 60 + 10,
        },
        {
          name: 'Agarre a mano cruzada',
          time: 13 * 60 + 11,
        },
        {
          name: 'Toma de control a dos manos',
          time: 15 * 60 + 35,
        },
        {
          name: 'Simulación de situación de riesgo',
          time: 16 * 60 + 39,
        },
      ]
    },
    {
      name: 'Contra-ataque',
      time: 20 * 60 + 54,
      sub: [
        {
          name: 'Demostración',
          time: 20 * 60 + 54,
        },
        {
          name: 'Reinicio del ciclo de pensamiento',
          time: 22 * 60 + 17,
        },
        {
          name: 'Demostración I',
          time: 23 * 60 + 29,
        },
        {
          name: 'Demostración II',
          time: 25 * 60 + 12,
        },
        {
          name: 'Demostración III',
          time: 27 * 60 + 32,
        },
        {
          name: 'Recomendaciones',
          time: 28 * 60 + 37,
        },
      ]
    },
  ],
},
{
  id: "058",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/058/Front/HLS/Session+058+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/058/Back/HLS/Session+058+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/058/Front/Thumbnails/Session+058+-+Custom-Poster.jpg',
  details: roaster[roasterMap.didack],
  category: categories[categoryMap.breaking],
  classType: {
    slug: ['movement']
  },
  videoInfo: {
    about: 'Head Spin',
    description: 'En esta sesión revisaremos un power-move de nivel intermedio, es muy importante realizar un calentamiento adecuado, principalmente en el cuello, ya que esta será la principal parte del cuerpo que utilizaremos en este movimiento.<br>Es muy importante que antes de cada sesión realices un calentamiento adecuado para evitar lesiones durante y después de tu entrenamiento.<br>En esta sesión Didack tiene para tí un calentamiento ¡al estilo Breaking!<br>El breaking, mejor conocido como Break Dance o B-boying o B-girling es una disciplina artística parte de la cultura Hip Hop.',
    relatesTo: 'Danza Acrobática, Baile Fitness, Danza Jazz, Ritmos Latinos, Calistenia',
    recommended: 'El breaking utiliza muchos movimientos dinámicos, todo tu cuerpo será expuesto a un ejercicio demandante por lo que es recomendable ejercitarlo y prepararlo antes de intentar estos movimientos.<br>Tal vez lo más característico de esta disciplina es que te permite expresar tus ideas, sentimientos y estados de ánimo mediante el baile.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['011', '045', '034'],
  sections: [
    {
      name: 'Requerimientos',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Head Freeze',
          time: 1 * 60 + 58,
        },
        {
          name: 'Head Stand',
          time: 3 * 60 + 23,
        },
        {
          name: 'One Hand Stand',
          time: 4 * 60 + 40,
        },
        {
          name: 'Renegade',
          time: 5 * 60 + 55,
        },
      ]
    },
    {
      name: 'Fortalecimiento',
      time: 7 * 60 + 3,
      sub: [
        {
          name: 'Introducción',
          time: 7 * 60 + 3,
        },
        {
          name: 'Arco con cabeza 3 x 20 segs.',
          time: 7 * 60 + 48,
        },
        {
          name: 'Pike con cabeza 2 x 20 segs.',
          time: 11 * 60 + 10,
        },
        {
          name: 'Head freeze con resistencia 2 x 15 segs.',
          time: 12 * 60 + 42,
        },
        {
          name: 'Head freeze con movimiento',
          time: 14 * 60 + 51,
        },
      ]
    },
    {
      name: 'Head Spin',
      time: 16 * 60 + 14,
      sub: [
        {
          name: 'Introducción',
          time: 16 * 60 + 14,
        },
        {
          name: 'Rotación base',
          time: 16 * 60 + 34,
        },
        {
          name: 'Rotación sin manos',
          time: 20 * 60 + 15,
        },
        {
          name: 'Rotación en head-spin',
          time: 21 * 60 + 56,
        },
        {
          name: 'Head-spin con impulso',
          time: 23 * 60 + 35,
        },
        {
          name: 'Mantener un spot',
          time: 25 * 60 + 19,
        },
        {
          name: 'Demostración',
          time: 25 * 60 + 50,
        },
        {
          name: 'Recomendaciones',
          time: 29 * 60 + 18,
        },
      ]
    },
  ],
},
{
  id: "059",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/059/Front/HLS/Session+059+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/059/Back/HLS/Session+059+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/059/Front/Thumbnails/Session+059+-+Custom-Poster.jpg',
  details: roaster[roasterMap.didack],
  category: categories[categoryMap.breaking],
  classType: {
    slug: ['movement']
  },
  videoInfo: {
    about: 'Back Spin',
    description: 'Te traemos otro ground power-move de nivel intermedio, aprende a dar vueltas en el piso con la espalda de forma segura para evitar lesiones en esta sesión.<br>Es muy importante que antes de cada sesión realices un calentamiento adecuado para evitar lesiones durante y después de tu entrenamiento.<br>En esta sesión Didack tiene para tí un calentamiento ¡al estilo Breaking!<br>El breaking, mejor conocido como Break Dance o B-boying o B-girling es una disciplina artística parte de la cultura Hip Hop.',
    relatesTo: 'Danza Acrobática, Baile Fitness, Danza Jazz, Ritmos Latinos, Calistenia',
    recommended: 'El breaking utiliza muchos movimientos dinámicos, todo tu cuerpo será expuesto a un ejercicio demandante por lo que es recomendable ejercitarlo y prepararlo antes de intentar estos movimientos.<br>Tal vez lo más característico de esta disciplina es que te permite expresar tus ideas, sentimientos y estados de ánimo mediante el baile.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['011', '048', '034'],
  sections: [
    {
      name: 'Requerimientos',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Head Stand',
          time: 1 * 60 + 5,
        },
        {
          name: 'Key Pose',
          time: 1 * 60 + 22,
        },
        {
          name: 'Renegade',
          time: 2 * 60 + 19,
        },
        {
          name: 'Back Rolls',
          time: 2 * 60 + 44,
        },
      ]
    },
    {
      name: 'Fortalecimiento',
      time: 3 * 60 + 19,
      sub: [
        {
          name: 'Introducción',
          time: 3 * 60 + 19,
        },
        {
          name: 'Columpios 3 x 10 reps.',
          time: 3 * 60 + 47,
        },
        {
          name: 'Círculos a una pierna 10 reps. de cada lado',
          time: 6 * 60 + 44,
        },
        {
          name: 'Puntas hacia atrás x 30 segs.',
          time: 8 * 60 + 14,
        },
      ]
    },
    {
      name: 'Back-Spin',
      time: 9 * 60 + 16,
      sub: [
        {
          name: 'Introducción',
          time: 9 * 60 + 16,
        },
        {
          name: 'Postura inicial',
          time: 10 * 60 + 10,
        },
        {
          name: 'Movimiento de piés',
          time: 11 * 60 + 29,
        },
        {
          name: 'Impulso de piés',
          time: 12 * 60 + 54,
        },
        {
          name: 'Demostración',
          time: 14 * 60 + 10,
        },
      ]
    },
    {
      name: 'Back-spin con Key Pose',
      time: 14 * 60 + 43,
      sub: [
        {
          name: 'Introducción',
          time: 14 * 60 + 43,
        },
        {
          name: 'Impulso en Key Pose',
          time: 15 * 60 + 34,
        },
        {
          name: 'Key Pose a Back-spin',
          time: 16 * 60 + 24,
        },
        {
          name: 'Demostración',
          time: 19 * 60 + 23,
        },
        {
          name: 'Recomendaciones',
          time: 19 * 60 + 44,
        },
        {
          name: 'Impulso con las manos',
          time: 20 * 60 + 51,
        },
      ]
    },
    {
      name: 'Variaciones',
      time: 21 * 60 + 38,
      sub: [
        {
          name: 'Introducción',
          time: 21 * 60 + 38,
        },
        {
          name: 'Back-spin con piernas estiradas',
          time: 22 * 60 + 33,
        },
        {
          name: 'Back-spin tocando la rodilla',
          time: 23 * 60 + 5,
        },
        {
          name: 'Back-spin contrayendo piernas',
          time: 23 * 60 + 49,
        },
        {
          name: 'Back-spin con piés cruzados',
          time: 24 * 60 + 59,
        },
        {
          name: 'Recomendaciones',
          time: 25 * 60 + 52,
        },
      ]
    },
  ],
},
{
  id: "060",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/060/Front/HLS/Session+060+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/060/Back/HLS/Session+060+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/060/Front/Thumbnails/Session+060+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['combo']
  },
  videoInfo: {
    about: 'Combinaciones con Back roll',
    description: 'En esta sesión combinamos diferentes elementos de piso aplicados a la danza acrobática. <br>El calentamiento y el estiramiento son muy importantes antes de realizar cualquier actividad física para evitar lesiones, por lo que te recomendamos realizarlos antes de iniciar con esta sesión.',
    relatesTo: 'Flex, Gimnasia, Breaking, Calentamiento',
    recommended: 'Los ejercicios de calentamiento y estiramiento son ideales para corregir posturas y activar músculos que generalmente no trabajamos.<br>Si tienes problemas con el nervio ciático puedes hacer los ejercicios de estiramiento, principalmente el de Isquiones.<br>Recuerda que en todas las sesiones es importante realizar un calentamiento previo, puedes encontrar otros videos con calentamientos generales de diferentes disciplinas que puedes realizar antes de hacer los movimientos de esta sesión.<br>O puedes realizar un calentamiento específico según el grupo muscular que vayas a utilizar en los elementos.',
    tools: '',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['006', '018', '008'],
  sections: [
    {
      name: 'Estiramiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Cabeza',
          time: 49,
        },
        {
          name: 'Corvas',
          time: 1 * 60 + 28,
        },
        {
          name: 'Segunda',
          time: 2 * 60 + 2,
        },
        {
          name: 'Plegado',
          time: 2 * 60 + 40,
        },
        {
          name: 'Cobra',
          time: 3 * 60 + 1,
        },
        {
          name: 'Meditación media',
          time: 3 * 60 + 22,
        },
        {
          name: 'Pike',
          time: 3 * 60 + 53,
        },
      ]
    },
    {
      name: 'Movimiento Articular',
      time: 4 * 60 + 23,
      sub: [
        {
          name: 'Cabeza',
          time: 4 * 60 + 23,
        },
        {
          name: 'Hombros',
          time: 5 * 60 + 0,
        },
        {
          name: 'Flat Back',
          time: 5 * 60 + 15,
        },
        {
          name: 'Piernas',
          time: 5 * 60 + 43,
        },
      ]
    },
    {
      name: 'Primera transición',
      time: 6 * 60 + 48,
      sub: [
        {
          name: 'Ala de Ángel',
          time: 6 * 60 + 48,
        },
        {
          name: 'Extendiendo brazo y pierna',
          time: 7 * 60 + 9,
        },
        {
          name: 'Cambio de peso',
          time: 8 * 60 + 25,
        },
        {
          name: 'Ron de',
          time: 8 * 60 + 37,
        },
        {
          name: 'Bajada al piso',
          time: 8 * 60 + 47,
        },
        {
          name: 'Medio círculo con flexión',
          time: 8 * 60 + 57,
        },
        {
          name: 'Medio circulo con pierna derecha',
          time: 9 * 60 + 3,
        },
        {
          name: 'Fluido',
          time: 9 * 60 + 21,
        },
      ]
    },
    {
      name: 'Segunda transición',
      time: 10 * 60 + 10,
      sub: [
        {
          name: 'Introducción',
          time: 10 * 60 + 10,
        },
        {
          name: 'Desplazamiento en segunda',
          time: 10 * 60 + 30,
        },
        {
          name: 'Back Roll basic',
          time: 12 * 60 + 48,
        },
      ]
    },
    {
      name: 'Combinación I',
      time: 14 * 60 + 24,
      sub: [
        {
          name: 'Introducción',
          time: 14 * 60 + 24,
        },
        {
          name: 'Desplazamiento con Ron de',
          time: 14 * 60 + 31,
        },
        {
          name: 'Ala de Ángel',
          time: 14 * 60 + 56,
        },
        {
          name: 'Desplazamiento en segunda',
          time: 15 * 60 + 6,
        },
        {
          name: 'Fluido',
          time: 15 * 60 + 59,
        },
        {
          name: 'Back Roll basic',
          time: 16 * 60 + 23,
        },
        {
          name: 'Ala de Ángel',
          time: 16 * 60 + 49,
        },
        {
          name: 'Fluido',
          time: 18 * 60 + 13,
        },
      ]
    },
    {
      name: 'Back Roll',
      time: 19 * 60 + 0,
      sub: [
        {
          name: 'Introducción',
          time: 19 * 60 + 0,
        },
        {
          name: 'Cambio de peso',
          time: 19 * 60 + 28,
        },
        {
          name: 'Impulso',
          time: 19 * 60 + 35,
        },
        {
          name: 'Fluido',
          time: 20 * 60 + 40,
        },
      ]
    },
    {
      name: 'Combinación II',
      time: 21 * 60 + 50,
      sub: [
        {
          name: 'Introducción',
          time: 21 * 60 + 50,
        },
        {
          name: 'Desplazamiento con Ron de',
          time: 21 * 60 + 59,
        },
        {
          name: 'Ala de Ángel',
          time: 22 * 60 + 8,
        },
        {
          name: 'Back Roll basic',
          time: 22 * 60 + 13,
        },
        {
          name: 'Ala de Ángel',
          time: 22 * 60 + 24,
        },
        {
          name: 'Desplazamiento en segunda',
          time: 22 * 60 + 25,
        },
        {
          name: 'Back Roll basic',
          time: 22 * 60 + 29,
        },
        {
          name: 'Ala de Ángel',
          time: 22 * 60 + 39,
        },
        {
          name: 'Back Roll full',
          time: 22 * 60 + 41,
        },
        {
          name: 'Fluido',
          time: 28 * 60 + 35,
        },
      ]
    },
  ],
},
{
  id: "061",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/061/Front/HLS/Session+061+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/061/Back/HLS/Session+061+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/061/Front/Thumbnails/Session+061+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Preparación para parado de manos',
    description: 'Aprende este elemento básico de la danza acrobática, y practícalo también en otras disciplinas. <br>El calentamiento y el estiramiento son muy importantes antes de realizar cualquier actividad física para evitar lesiones, por lo que te recomendamos realizarlos antes de iniciar con esta sesión.',
    relatesTo: 'Flex, Gimnasia, Breaking, Calentamiento',
    recommended: 'Los ejercicios de calentamiento y estiramiento son ideales para corregir posturas y activar músculos que generalmente no trabajamos.<br>Si tienes problemas con el nervio ciático puedes hacer los ejercicios de estiramiento, principalmente el de Isquiones.<br>Recuerda que en todas las sesiones es importante realizar un calentamiento previo, puedes encontrar otros videos con calentamientos generales de diferentes disciplinas que puedes realizar antes de hacer los movimientos de esta sesión.<br>O puedes realizar un calentamiento específico según el grupo muscular que vayas a utilizar en los elementos.',
    tools: '',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['006', '018', '008'],
  sections: [
    {
      name: 'Estiramiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Hombros',
          time: 58,
        },
        {
          name: 'Cabeza',
          time: 1 * 60 + 14,
        },
        {
          name: 'Espalda',
          time: 1 * 60 + 28,
        },
        {
          name: 'Segunda',
          time: 1 * 60 + 48,
        },
        {
          name: 'Cobra',
          time: 2 * 60 + 39,
        },
        {
          name: 'Meditación media',
          time: 2 * 60 + 57,
        },
      ]
    },
    {
      name: 'Acondicionamiento físico',
      time: 4 * 60 + 57,
      sub: [
        {
          name: 'Introducción',
          time: 4 * 60 + 57,
        },
        {
          name: 'Plancha',
          time: 5 * 60 + 9,
        },
        {
          name: 'Muelleos',
          time: 6 * 60 + 9,
        },
        {
          name: 'Macarenas',
          time: 7 * 60 + 16,
        },
        {
          name: 'Superman',
          time: 8 * 60 + 11,
        },
        {
          name: 'Comandos',
          time: 9 * 60 + 50,
        },
        {
          name: 'Muñecas',
          time: 13 * 60 + 21,
        },
        {
          name: 'Full crunch',
          time: 14 * 60 + 50,
        },
        {
          name: 'Abdominales en Flat-Back',
          time: 16 * 60 + 44,
        },
      ]
    },
    {
      name: 'Fortalecimiento para parado de manos',
      time: 20 * 60 + 44,
      sub: [
        {
          name: 'Postura',
          time: 20 * 60 + 44,
        },
        {
          name: 'Fortalecimiento',
          time: 22 * 60 + 47,
        },
        {
          name: 'Apertura de hombros',
          time: 24 * 60 + 25,
        },
        {
          name: 'Flexibilidad del hombro',
          time: 25 * 60 + 35,
        },
        {
          name: 'Posición de los brazos',
          time: 29 * 60 + 44,
        },
        {
          name: 'Calibrar elevación de piernas',
          time: 30 * 60 + 0,
        },
        {
          name: 'Parado de manos',
          time: 31 * 60 + 40,
        },
        {
          name: 'Con rodillas flexionadas',
          time: 31 * 60 + 50,
        },
      ]
    },
    {
      name: 'Parado de manos',
      time: 33 * 60 + 46,
      sub: [
        {
          name: 'Introducción',
          time: 33 * 60 + 46,
        },
        {
          name: 'En pared',
          time: 34 * 60 + 0,
        },
        {
          name: 'En pared hacia atrás',
          time: 35 * 60 + 12,
        },
        {
          name: 'Recomendaciones',
          time: 35 * 60 + 53,
        },
      ]
    },
  ],
},
{
  id: "062",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/062/Front/HLS/Session+062+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/062/Back/HLS/Session+062+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/062/Front/Thumbnails/Session+062+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Equilibrio en codos.',
    description: 'En esta sesión aprenderemos sobre las bases y la aplicación del equilibrio en codos, es importante señalar que hay requisitos para realizar este movimiento, los cuales son el dominio del parado de manos, fortalecimiento de hombros, flat back y abdomen. <br>El calentamiento y el estiramiento son muy importantes antes de realizar cualquier actividad física para evitar lesiones, por lo que te recomendamos realizarlos antes de iniciar con esta sesión.',
    relatesTo: 'Flex, Gimnasia, Breaking, Calentamiento',
    recommended: 'Los ejercicios de calentamiento y estiramiento son ideales para corregir posturas y activar músculos que generalmente no trabajamos.<br>Si tienes problemas con el nervio ciático puedes hacer los ejercicios de estiramiento, principalmente el de Isquiones.<br>Recuerda que en todas las sesiones es importante realizar un calentamiento previo, puedes encontrar otros videos con calentamientos generales de diferentes disciplinas que puedes realizar antes de hacer los movimientos de esta sesión.<br>O puedes realizar un calentamiento específico según el grupo muscular que vayas a utilizar en los elementos.',
    tools: '',
    equipment: 'Foam Roller, Tapete de Yoga o Colchoneta',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['006', '018', '008'],
  sections: [
    {
      name: 'Estiramiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Cuello',
          time: 1 * 60 + 10,
        },
        {
          name: 'Hombro',
          time: 1 * 60 + 40,
        },
        {
          name: 'Segunda',
          time: 2 * 60 + 21,
        },
        {
          name: 'Cobra',
          time: 2 * 60 + 49,
        },
        {
          name: 'Meditación media',
          time: 3 * 60 + 2,
        },
        {
          name: 'Cabeza',
          time: 3 * 60 + 55,
        },
        {
          name: 'Hombros',
          time: 4 * 60 + 24,
        },
      ]
    },
    {
      name: 'Acondicionamiento físico',
      time: 6 * 60 + 9,
      sub: [
        {
          name: 'Introducción',
          time: 6 * 60 + 9,
        },
        {
          name: 'Full Crunch',
          time: 6 * 60 + 23,
        },
        {
          name: 'Tronquitos',
          time: 8 * 60 + 25,
        },
        {
          name: 'Superman',
          time: 11 * 60 + 32,
        },
        {
          name: 'Extensión en Cobra',
          time: 15 * 60 + 37,
        },
        {
          name: 'Extensión en meditación media',
          time: 17 * 60 + 58,
        },
        {
          name: 'Saltos en codos a una pierna',
          time: 20 * 60 + 28,
        },
        {
          name: 'Extensión a una pierna',
          time: 23 * 60 + 49,
        },
      ]
    },
    {
      name: 'Equilibrio en Codos',
      time: 25 * 60 + 10,
      sub: [
        {
          name: 'Introducción',
          time: 25 * 60 + 10,
        },
        {
          name: 'Equilibrio en pared',
          time: 25 * 60 + 58,
        },
        {
          name: 'Equilibrio en pared a 20 cm.',
          time: 28 * 60 + 1,
        },
        {
          name: 'Equilibrio en pared a 30 cm.',
          time: 28 * 60 + 27,
        },
        {
          name: 'Equilibrio en pared a 40 cm.',
          time: 31 * 60 + 2,
        },
        {
          name: 'Equilibrio con pared',
          time: 32 * 60 + 9,
        },
        {
          name: 'Equilibrio en codos',
          time: 33 * 60 + 28,
        },
        {
          name: 'Recomendaciones',
          time: 34 * 60 + 44,
        },
      ]
    },
  ],
},
{
  id: "063",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/063/Front/HLS/Session+063+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/063/Back/HLS/Session+063+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/063/Front/Thumbnails/Session+063+-+Custom-Poster.jpg',
  details: roaster[roasterMap.didack],
  category: categories[categoryMap.breaking],
  classType: {
    slug: ['skill']
  },
  videoInfo: {
    about: 'Freezes I',
    description: 'En esta sesión Didack te enseña Key Pose, Baby Freeze y muchas transiciones entre cada uno para que tengas más herramientas a la hora de bailar.<br>Es muy importante que antes de cada sesión realices un calentamiento adecuado para evitar lesiones durante y después de tu entrenamiento.<br>En esta sesión Didack tiene para tí un calentamiento ¡al estilo Breaking!<br>El breaking, mejor conocido como Break Dance o B-boying o B-girling es una disciplina artística parte de la cultura Hip Hop.',
    relatesTo: 'Danza Acrobática, Baile Fitness, Danza Jazz, Ritmos Latinos, Calistenia',
    recommended: 'El breaking utiliza muchos movimientos dinámicos, todo tu cuerpo será expuesto a un ejercicio demandante por lo que es recomendable ejercitarlo y prepararlo antes de intentar estos movimientos.<br>Tal vez lo más característico de esta disciplina es que te permite expresar tus ideas, sentimientos y estados de ánimo mediante el baile.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['058', '048', '059'],
  sections: [
    {
      name: 'Key Pose',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Conceptos básicos',
          time: 1 * 60 + 11,
        },
        {
          name: 'Posición del brazo',
          time: 1 * 60 + 27,
        },
      ]
    },
    {
      name: 'Fortalecimiento',
      time: 1 * 60 + 59,
      sub: [
        {
          name: 'Introducción',
          time: 1 * 60 + 59,
        },
        {
          name: 'Posición base',
          time: 2 * 60 + 9,
        },
        {
          name: 'Correcciones',
          time: 2 * 60 + 40,
        },
        {
          name: 'Cambios de peso x 10 reps.',
          time: 3 * 60 + 18,
        },
        {
          name: 'Cambios de peso a una pierna x 10 reps.',
          time: 4 * 60 + 42,
        },
        {
          name: 'Toque de codos cruzados en Head Freeze x 10 reps.',
          time: 7 * 60 + 25,
        },
      ]
    },
    {
      name: 'Key Pose',
      time: 9 * 60 + 26,
      sub: [
        {
          name: 'Introducción',
          time: 9 * 60 + 26,
        },
        {
          name: 'Balanceos',
          time: 9 * 60 + 59,
        },
        {
          name: 'Correcciones',
          time: 10 * 60 + 23,
        },
        {
          name: 'Cambio de mano',
          time: 11 * 60 + 4,
        },
        {
          name: 'Ejercicio de Resistencia',
          time: 12 * 60 + 27,
        },
        {
          name: 'Ejercicio de Control',
          time: 13 * 60 + 24,
        },
      ]
    },
    {
      name: 'Baby Freeze',
      time: 16 * 60 + 25,
      sub: [
        {
          name: 'Introducción',
          time: 16 * 60 + 25,
        },
        {
          name: 'Key Pose',
          time: 18 * 60 + 35,
        },
        {
          name: 'Torción',
          time: 20 * 60 + 58,
        },
        {
          name: 'Cambio de lado',
          time: 22 * 60 + 5,
        },
        {
          name: 'Con fluidez',
          time: 23 * 60 + 0,
        },
        {
          name: 'Freezes alternados x 10 reps.',
          time: 24 * 60 + 42,
        },
      ]
    },
    {
      name: 'Variaciones',
      time: 25 * 60 + 21,
      sub: [
        {
          name: 'Introducción',
          time: 25 * 60 + 21,
        },
        {
          name: 'Key Pose con pierna cruzada',
          time: 25 * 60 + 39,
        },
        {
          name: 'Figuras en Baby Freeze',
          time: 26 * 60 + 18,
        },
      ]
    },
  ],
},
{
  id: "064",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/064/Front/HLS/Session+064+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/064/Back/HLS/Session+064+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/064/Front/Thumbnails/Session+064+-+Custom-Poster.jpg',
  details: roaster[roasterMap.didack],
  category: categories[categoryMap.breaking],
  classType: {
    slug: ['movement']
  },
  videoInfo: {
    about: 'Turtle',
    description: 'En este power-move Didack te enseña a aplicar el freeze key-pose para aplicar dinamísmo a tu baile.<br>Para este movimiento utilizaremos la rotación de tu cuerpo en posición Key-Pose por lo que si aún no dominas este video te invitamos a aprenderlo primero.<br>Es muy importante que antes de cada sesión realices un calentamiento adecuado para evitar lesiones durante y después de tu entrenamiento.<br>En esta sesión Didack tiene para tí un calentamiento ¡al estilo Breaking!<br>El breaking, mejor conocido como Break Dance o B-boying o B-girling es una disciplina artística parte de la cultura Hip Hop.',
    relatesTo: 'Danza Acrobática, Baile Fitness, Danza Jazz, Ritmos Latinos, Calistenia',
    recommended: 'El breaking utiliza muchos movimientos dinámicos, todo tu cuerpo será expuesto a un ejercicio demandante por lo que es recomendable ejercitarlo y prepararlo antes de intentar estos movimientos.<br>Tal vez lo más característico de esta disciplina es que te permite expresar tus ideas, sentimientos y estados de ánimo mediante el baile.',
    tools: 'Utiliza el modo espejo para seguir mejor los movimientos.<br>Activa la cámara trasera para ver las posturas desde otro ángulo.<br>Utiliza el #modochallenge para grabar tu parado de manos y ¡compartelo en redes sociales!',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['058', '048', '063'],
  sections: [
    {
      name: 'Fortalecimiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Key Pose x 5 reps.',
          time: 2 * 60 + 20,
        },
        {
          name: 'Caidas en Key Pose x 5 reps.',
          time: 4 * 60 + 45,
        },
      ]
    },
    {
      name: 'Turtle',
      time: 7 * 60 + 46,
      sub: [
        {
          name: 'Introducción',
          time: 7 * 60 + 46,
        },
        {
          name: 'Key Pose alternado',
          time: 8 * 60 + 38,
        },
        {
          name: 'Desplazamiento',
          time: 9 * 60 + 23,
        },
        {
          name: 'Rotación',
          time: 10 * 60 + 53,
        },
        {
          name: 'Con fluidez',
          time: 12 * 60 + 44,
        },
        {
          name: 'Hacia el otro lado',
          time: 13 * 60 + 49,
        },
      ]
    },
    {
      name: 'Combinaciones',
      time: 15 * 60 + 34,
      sub: [
        {
          name: 'Introducción',
          time: 15 * 60 + 34,
        },
        {
          name: 'Sweep a Turtle',
          time: 16 * 60 + 20,
        },
        {
          name: 'Back roll a Turtle',
          time: 18 * 60 + 37,
        },
        {
          name: 'Back spin a Turtle',
          time: 20 * 60 + 8,
        },
        {
          name: 'Recomendaciones',
          time: 23 * 60 + 6,
        },
      ]
    },
  ],
},
{
  id: "065",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/065/Front/HLS/Session+065+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/065/Back/HLS/Session+065+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/065/Front/Thumbnails/Session+065+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Fortalecimiento del área del core',
    description: 'El core se compone de todos los músculos que rodean el centro de nuestro cuerpo, principalmente los músculos del abdomen pero también incluyendo espalda y dorsales.<br>En esta sesión te traemos una rutina para nievel básico e intermedio que puedes agregar a tu rutina de ejercicios semanal. Es muy importante fortalecer esta zona, ya que es la parte encargada de darle balance a nuestros movimientos.<br>El calentamiento y el estiramiento son muy importantes antes de realizar cualquier actividad física para evitar lesiones, por lo que te recomendamos realizarlos antes de iniciar con esta sesión.',
    relatesTo: 'Flex, Gimnasia, Breaking, Calentamiento',
    recommended: 'Fortalecer la zona del core te ayudará a corregir tu postura, reduciendo dolores de espalda y te dará mejor balance al realizar actividades cotidianas. <br>Los ejercicios de calentamiento y estiramiento son ideales para corregir posturas y activar músculos que generalmente no trabajamos.<br>Si tienes problemas con el nervio ciático puedes hacer los ejercicios de estiramiento, principalmente el de Isquiones.<br>Recuerda que en todas las sesiones es importante realizar un calentamiento previo, puedes encontrar otros videos con calentamientos generales de diferentes disciplinas que puedes realizar antes de hacer los movimientos de esta sesión.<br>O puedes realizar un calentamiento específico según el grupo muscular que vayas a utilizar en los elementos.',
    tools: '',
    equipment: '',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['006', '018', '063'],
  sections: [
    {
      name: 'Estiramiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Hombros',
          time: 1 * 60 + 57,
        },
        {
          name: 'Cabeza',
          time: 2 * 60 + 15,
        },
        {
          name: 'Plegado',
          time: 2 * 60 + 42,
        },
        {
          name: 'Segunda',
          time: 3 * 60 + 0,
        },
        {
          name: 'Cobra',
          time: 3 * 60 + 49,
        },
        {
          name: 'Meditación media',
          time: 4 * 60 + 11,
        },
        {
          name: 'Cabeza',
          time: 4 * 60 + 46,
        },
        {
          name: 'Hombros',
          time: 5 * 60 + 12,
        },
      ]
    },
    {
      name: 'Rutina Core 25 x 20',
      time: 5 * 60 + 27,
      sub: [
        {
          name: 'Introducción',
          time: 5 * 60 + 27,
        },
        {
          name: 'Toque de piés',
          time: 5 * 60 + 44,
        },
        {
          name: 'Abdominales con piernas abiertas',
          time: 6 * 60 + 20,
        },
        {
          name: 'Combinadas',
          time: 6 * 60 + 33,
        },
        {
          name: 'Crunches',
          time: 6 * 60 + 48,
        },
        {
          name: 'Inicio de la rutina',
          time: 7 * 60 + 45,
        },
        {
          name: 'Recomendaciones',
          time: 12 * 60 + 30,
        },
      ]
    },
    {
      name: 'Rutina Core Laterales',
      time: 14 * 60 + 10,
      sub: [
        {
          name: 'Laterales sobre derecha',
          time: 14 * 60 + 10,
        },
        {
          name: 'Laterales sobre izquierda',
          time: 15 * 60 + 39,
        },
        {
          name: 'Recomendaciones',
          time: 16 * 60 + 32,
        },
      ]
    },
    {
      name: 'Rutina Core Espalda',
      time: 16 * 60 + 58,
      sub: [
        {
          name: 'Introducción',
          time: 16 * 60 + 58,
        },
        {
          name: 'Barbilla hacia arriba',
          time: 17 * 60 + 13,
        },
        {
          name: 'Resistencia en posición de ajuste',
          time: 18 * 60 + 44,
        },
        {
          name: 'Resistencia en plancha',
          time: 20 * 60 + 25,
        },
        {
          name: 'Barbilla hacia arriba (Estática)',
          time: 22 * 60 + 46,
        },
        {
          name: 'Resistencias laterales',
          time: 23 * 60 + 33,
        },
        {
          name: 'Recomendaciones',
          time: 24 * 60 + 50,
        },
      ]
    },
  ],
},
{
  id: "066",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/066/Front/HLS/Session+066+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/066/Back/HLS/Session+066+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/066/Front/Thumbnails/Session+066+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['training']
  },
  videoInfo: {
    about: 'Fortalecimiento de empeines',
    description: 'Ahora realizaremos ejercicios enfocados en fortalecer los músculos, tendones y articulaciones conectados con el empeine<br>Si frecuentemente sufres de torceduras del pié te recomendamos que realices esta serie de ejercicios con nosotros.<br>El calentamiento y el estiramiento son muy importantes antes de realizar cualquier actividad física para evitar lesiones, por lo que te recomendamos realizarlos antes de iniciar con esta sesión.',
    relatesTo: 'Flex, Gimnasia, Breaking, Calentamiento',
    recommended: 'Si eres una persona que utiliza zapatos altos durante mucho tiempo y tiendes a falsear mientras caminas, estos ejercicios son para tí.<br>Los ejercicios de calentamiento y estiramiento son ideales para corregir posturas y activar músculos que generalmente no trabajamos.<br>Si tienes problemas con el nervio ciático puedes hacer los ejercicios de estiramiento, principalmente el de Isquiones.<br>Recuerda que en todas las sesiones es importante realizar un calentamiento previo, puedes encontrar otros videos con calentamientos generales de diferentes disciplinas que puedes realizar antes de hacer los movimientos de esta sesión.<br>O puedes realizar un calentamiento específico según el grupo muscular que vayas a utilizar en los elementos.',
    tools: '',
    equipment: 'liga',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['063', '018', '065'],
  sections: [
    {
      name: 'Estiramiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Talones',
          time: 1 * 60 + 28,
        },
        {
          name: 'Recomendaciones',
          time: 3 * 60 + 17,
        },
      ]
    },
    {
      name: 'Fortalecimiento',
      time: 4 * 60 + 58,
      sub: [
        {
          name: 'Introducción',
          time: 4 * 60 + 58,
        },
        {
          name: 'Balanceo en puntas',
          time: 5 * 60 + 6,
        },
        {
          name: 'Estiramiento de pierna',
          time: 6 * 60 + 14,
        },
        {
          name: 'Estiramiento de dedos',
          time: 7 * 60 + 40,
        },
        {
          name: 'Estiramiento piernas paralelas',
          time: 8 * 60 + 57,
        },
      ]
    },
    {
      name: 'Aumento de temperatura',
      time: 9 * 60 + 44,
      sub: [
        {
          name: 'Introducción',
          time: 9 * 60 + 44,
        },
        {
          name: 'Sentadillas a relevé',
          time: 9 * 60 + 52,
        },
        {
          name: 'Cruces punta a flex',
          time: 11 * 60 + 25,
        },
        {
          name: 'Cruces flex - punta',
          time: 13 * 60 + 12,
        },
        {
          name: 'Punta - flex alternados',
          time: 14 * 60 + 26,
        },
        {
          name: 'Punta - flex laterales',
          time: 15 * 60 + 8,
        },
      ]
    },
    {
      name: 'Fortalecimiento',
      time: 16 * 60 + 19,
      sub: [
        {
          name: 'Introducción',
          time: 16 * 60 + 19,
        },
        {
          name: 'Presión en punta derecha',
          time: 16 * 60 + 57,
        },
        {
          name: 'Presión en punta izquierda',
          time: 18 * 60 + 56,
        },
        {
          name: 'Elevación pierna - pelvis con base derecha',
          time: 20 * 60 + 2,
        },
        {
          name: 'Elevación pierna - pelvis con base izquierda',
          time: 21 * 60 + 25,
        },
        {
          name: 'Sentadillas en relevé',
          time: 21 * 60 + 53,
        },
        {
          name: 'Cambios de empeine',
          time: 23 * 60 + 35,
        },
        {
          name: 'Relajación de dedos',
          time: 24 * 60 + 30,
        },
        {
          name: 'Elevación en punta a una pierna',
          time: 25 * 60 + 48,
        },
        {
          name: 'Relajación de metatarsos',
          time: 27 * 60 + 2,
        },
        {
          name: 'Recomendaciones',
          time: 27 * 60 + 48,
        },
        {
          name: 'Elevación en puntas (Intermedio)',
          time: 29 * 60 + 28,
        },
      ]
    },
    {
      name: 'Flexibilidad',
      time: 31 * 60 + 54,
      sub: [
        {
          name: 'Introducción',
          time: 31 * 60 + 54,
        },
        {
          name: 'Extensión en punta',
          time: 32 * 60 + 31,
        },
        {
          name: 'Resistencia en punta x 1 min.',
          time: 35 * 60 + 13,
        },
      ]
    },
  ],
},
{
  id: "067",
  streams: {
    _720: {
      front: 'https://vod-d-ns-sessions.s3.amazonaws.com/067/Front/HLS/Session+067+-+Front_720.m3u8',
      back: 'https://vod-d-ns-sessions.s3.amazonaws.com/067/Back/HLS/Session+067+-+Back_720.m3u8',
    }
  },
  poster: 'https://vod-d-ns-sessions.s3.amazonaws.com/067/Front/Thumbnails/Session+067+-+Custom-Poster.jpg',
  details: roaster[roasterMap['rao']],
  category: categories[categoryMap.danzaacrobatica],
  classType: {
    slug: ['skill']
  },
  videoInfo: {
    about: 'Cocodrilo',
    description: 'Aprende y domina esta técnica con los mejores tips y consejos para que la puedas aplicar en tus coreografías de danza acrobática o de otras disciplinas.<br>El calentamiento y el estiramiento son muy importantes antes de realizar cualquier actividad física para evitar lesiones, por lo que te recomendamos realizarlos antes de iniciar con esta sesión.',
    relatesTo: 'Flex, Gimnasia, Breaking, Calentamiento',
    recommended: 'Los ejercicios de calentamiento y fortalecimiento están especialmente enfocados en las muñecas, te recomendamos realizar esta rutina si es lo que quieres mejorar.<br>Los ejercicios de calentamiento y estiramiento son ideales para corregir posturas y activar músculos que generalmente no trabajamos.<br>Si tienes problemas con el nervio ciático puedes hacer los ejercicios de estiramiento, principalmente el de Isquiones.<br>Recuerda que en todas las sesiones es importante realizar un calentamiento previo, puedes encontrar otros videos con calentamientos generales de diferentes disciplinas que puedes realizar antes de hacer los movimientos de esta sesión.<br>O puedes realizar un calentamiento específico según el grupo muscular que vayas a utilizar en los elementos.',
    tools: '',
    equipment: 'liga',
    audience: 'Todo tipo de público.',
    rate: '[A]',
  },
  related: ['063', '018', '065'],
  sections: [
    {
      name: 'Calentamiento',
      time: 0,
      sub: [
        {
          name: 'Introducción',
          time: 0,
        },
        {
          name: 'Hombros',
          time: 54,
        },
        {
          name: 'Codos',
          time: 1 * 60 + 26,
        },
        {
          name: 'Cuello',
          time: 2 * 60 + 28,
        },
        {
          name: 'Muñecas',
          time: 3 * 60 + 33,
        },
        {
          name: 'Antebrazos',
          time: 4 * 60 + 45,
        },
        {
          name: 'Dorso de la muñeca',
          time: 5 * 60 + 24,
        },
        {
          name: 'Relajación',
          time: 6 * 60 + 10,
        },
      ]
    },
    {
      name: 'Fortalecimiento',
      time: 7 * 60 + 4,
      sub: [
        {
          name: 'Push Ups con Escápulas',
          time: 7 * 60 + 4,
        },
        {
          name: 'Estiramiento frontal de liga',
          time: 8 * 60 + 2,
        },
        {
          name: 'Muñeca arriba y abajo',
          time: 10 * 60 + 16,
        },
        {
          name: 'Muñeca invertida arriba y abajo',
          time: 11 * 60 + 33,
        },
      ]
    },
    {
      name: 'Preparación para Cocodrilo',
      time: 12 * 60 + 30,
      sub: [
        {
          name: 'Introducción',
          time: 12 * 60 + 30,
        },
        {
          name: 'Extensión de hombro',
          time: 15 * 60 + 20,
        },
        {
          name: 'Extensión de pecho',
          time: 16 * 60 + 31,
        },
        {
          name: 'Estiramiento de hombros en piso',
          time: 17 * 60 + 10,
        },
      ]
    },
    {
      name: 'Cocodrilo',
      time: 18 * 60 + 46,
      sub: [
        {
          name: 'Introducción',
          time: 18 * 60 + 46,
        },
        {
          name: 'Posición inicial',
          time: 18 * 60 + 53,
        },
        {
          name: 'Colocación del codo',
          time: 19 * 60 + 32,
        },
        {
          name: 'Cambio de peso al codo',
          time: 20 * 60 + 11,
        },
        {
          name: 'Equilibrio a un codo',
          time: 24 * 60 + 38,
        },
        {
          name: 'Recomendaciones',
          time: 26 * 60 + 10,
        },
        {
          name: 'Equilibrio con taquito',
          time: 27 * 60 + 32,
        },
      ]
    },
    {
      name: 'Fortalecimiento para Cocodrilo',
      time: 28 * 60 + 15,
      sub: [
        {
          name: 'Toque de hombros en plancha con balanceo',
          time: 28 * 60 + 15,
        },
        {
          name: 'Plancha sobre dedos',
          time: 29 * 60 + 34,
        },
        {
          name: 'Cambios de peso en Cocodrilo',
          time: 30 * 60 + 30,
        },
      ]
    },
  ],
},
];
function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  
  return array;
}
export const Sessions = {
  getSessions: (subscription) => {
    if (subscription === true) {
      return shuffle(sessions);
    }else{
      let freeSessions = [];
      sessions.forEach(element => {
        if (element.isFree) {
          freeSessions.push(element);
        }
      });
      return freeSessions.reverse();
    }
  },
  getCategories: () => {
    return categories;
  },
}
